// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.2.4 | MIT License | https://tailwindcss.com */
@layer properties;
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --font-sans: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
      "Courier New", monospace;
    --color-red-200: oklch(88.5% 0.062 18.334);
    --color-red-300: oklch(80.8% 0.114 19.571);
    --color-red-400: oklch(70.4% 0.191 22.216);
    --color-red-500: oklch(63.7% 0.237 25.331);
    --color-red-600: oklch(57.7% 0.245 27.325);
    --color-red-700: oklch(50.5% 0.213 27.518);
    --color-orange-50: oklch(98% 0.016 73.684);
    --color-orange-200: oklch(90.1% 0.076 70.697);
    --color-orange-400: oklch(75% 0.183 55.934);
    --color-orange-500: oklch(70.5% 0.213 47.604);
    --color-orange-700: oklch(55.3% 0.195 38.402);
    --color-orange-800: oklch(47% 0.157 37.304);
    --color-amber-50: oklch(98.7% 0.022 95.277);
    --color-amber-100: oklch(96.2% 0.059 95.617);
    --color-amber-200: oklch(92.4% 0.12 95.746);
    --color-amber-300: oklch(87.9% 0.169 91.605);
    --color-amber-400: oklch(82.8% 0.189 84.429);
    --color-amber-500: oklch(76.9% 0.188 70.08);
    --color-amber-600: oklch(66.6% 0.179 58.318);
    --color-amber-700: oklch(55.5% 0.163 48.998);
    --color-amber-800: oklch(47.3% 0.137 46.201);
    --color-amber-900: oklch(41.4% 0.112 45.904);
    --color-yellow-200: oklch(94.5% 0.129 101.54);
    --color-yellow-400: oklch(85.2% 0.199 91.936);
    --color-green-400: oklch(79.2% 0.209 151.711);
    --color-green-500: oklch(72.3% 0.219 149.579);
    --color-green-600: oklch(62.7% 0.194 149.214);
    --color-green-700: oklch(52.7% 0.154 150.069);
    --color-green-800: oklch(44.8% 0.119 151.328);
    --color-emerald-50: oklch(97.9% 0.021 166.113);
    --color-emerald-200: oklch(90.5% 0.093 164.15);
    --color-emerald-600: oklch(59.6% 0.145 163.225);
    --color-emerald-700: oklch(50.8% 0.118 165.612);
    --color-sky-50: oklch(97.7% 0.013 236.62);
    --color-sky-200: oklch(90.1% 0.058 230.902);
    --color-sky-600: oklch(58.8% 0.158 241.966);
    --color-sky-700: oklch(50% 0.134 242.749);
    --color-blue-50: oklch(97% 0.014 254.604);
    --color-blue-100: oklch(93.2% 0.032 255.585);
    --color-blue-200: oklch(88.2% 0.059 254.128);
    --color-blue-400: oklch(70.7% 0.165 254.624);
    --color-blue-500: oklch(62.3% 0.214 259.815);
    --color-blue-600: oklch(54.6% 0.245 262.881);
    --color-blue-700: oklch(48.8% 0.243 264.376);
    --color-purple-500: oklch(62.7% 0.265 303.9);
    --color-rose-50: oklch(96.9% 0.015 12.422);
    --color-rose-200: oklch(89.2% 0.058 10.001);
    --color-rose-600: oklch(58.6% 0.253 17.585);
    --color-rose-700: oklch(51.4% 0.222 16.935);
    --color-slate-50: oklch(98.4% 0.003 247.858);
    --color-slate-100: oklch(96.8% 0.007 247.896);
    --color-slate-200: oklch(92.9% 0.013 255.508);
    --color-slate-300: oklch(86.9% 0.022 252.894);
    --color-slate-400: oklch(70.4% 0.04 256.788);
    --color-slate-700: oklch(37.2% 0.044 257.287);
    --color-gray-50: oklch(98.5% 0.002 247.839);
    --color-gray-100: oklch(96.7% 0.003 264.542);
    --color-gray-200: oklch(92.8% 0.006 264.531);
    --color-gray-300: oklch(87.2% 0.01 258.338);
    --color-gray-400: oklch(70.7% 0.022 261.325);
    --color-gray-500: oklch(55.1% 0.027 264.364);
    --color-gray-600: oklch(44.6% 0.03 256.802);
    --color-gray-700: oklch(37.3% 0.034 259.733);
    --color-gray-800: oklch(27.8% 0.033 256.848);
    --color-gray-900: oklch(21% 0.034 264.665);
    --color-black: #000;
    --color-white: #fff;
    --spacing: 0.25rem;
    --container-xs: 20rem;
    --container-sm: 24rem;
    --container-md: 28rem;
    --container-lg: 32rem;
    --container-xl: 36rem;
    --container-2xl: 42rem;
    --container-4xl: 56rem;
    --container-5xl: 64rem;
    --text-xs: 0.75rem;
    --text-xs--line-height: calc(1 / 0.75);
    --text-sm: 0.875rem;
    --text-sm--line-height: calc(1.25 / 0.875);
    --text-base: 1rem;
    --text-base--line-height: calc(1.5 / 1);
    --text-lg: 1.125rem;
    --text-lg--line-height: calc(1.75 / 1.125);
    --text-xl: 1.25rem;
    --text-xl--line-height: calc(1.75 / 1.25);
    --text-2xl: 1.5rem;
    --text-2xl--line-height: calc(2 / 1.5);
    --text-3xl: 1.875rem;
    --text-3xl--line-height: calc(2.25 / 1.875);
    --text-4xl: 2.25rem;
    --text-4xl--line-height: calc(2.5 / 2.25);
    --text-5xl: 3rem;
    --text-5xl--line-height: 1;
    --font-weight-normal: 400;
    --font-weight-medium: 500;
    --font-weight-semibold: 600;
    --font-weight-bold: 700;
    --font-weight-black: 900;
    --tracking-tight: -0.025em;
    --tracking-wide: 0.025em;
    --tracking-wider: 0.05em;
    --leading-snug: 1.375;
    --radius-sm: 0.25rem;
    --radius-md: 0.375rem;
    --radius-lg: 0.5rem;
    --radius-xl: 0.75rem;
    --radius-2xl: 1rem;
    --radius-3xl: 1.5rem;
    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);
    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    --blur-md: 12px;
    --default-transition-duration: 150ms;
    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    --default-font-family: var(--font-sans);
    --default-mono-font-family: var(--font-mono);
    --font-title: 'Tautz';
    --color-title: #2d7194;
    --color-link: #2d7194;
    --color-main-field: #f9f9f9;
    --color-main-field-border: #dddddd;
    --color-mascot-black: #474747;
    --color-base-100: hsl(199, 15%, 86%);
    --color-base-200: hsl(199, 14%, 74%);
    --color-base-300: hsl(199, 14%, 63%);
    --color-base-500: hsl(199, 20%, 39%);
  }
}
@layer base {
  *,
  ::after,
  ::before,
  ::backdrop,
  ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html,
  :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    tab-size: 4;
    font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    -webkit-text-decoration: inherit;
    text-decoration: inherit;
  }
  b,
  strong {
    font-weight: bolder;
  }
  code,
  kbd,
  samp,
  pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol,
  ul,
  menu {
    list-style: none;
  }
  img,
  svg,
  video,
  canvas,
  audio,
  iframe,
  embed,
  object {
    display: block;
    vertical-align: middle;
  }
  img,
  video {
    max-width: 100%;
    height: auto;
  }
  button,
  input,
  select,
  optgroup,
  textarea,
  ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button))  or
    (contain-intrinsic-size: 1px) {
    ::placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit,
  ::-webkit-datetime-edit-year-field,
  ::-webkit-datetime-edit-month-field,
  ::-webkit-datetime-edit-day-field,
  ::-webkit-datetime-edit-hour-field,
  ::-webkit-datetime-edit-minute-field,
  ::-webkit-datetime-edit-second-field,
  ::-webkit-datetime-edit-millisecond-field,
  ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  ::-webkit-calendar-picker-indicator {
    line-height: 1;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button,
  input:where([type="button"], [type="reset"], [type="submit"]),
  ::file-selector-button {
    appearance: button;
  }
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities {
  .\\@container {
    container-type: inline-size;
  }
  .pointer-events-none {
    pointer-events: none;
  }
  .invisible {
    visibility: hidden;
  }
  .visible {
    visibility: visible;
  }
  .absolute {
    position: absolute;
  }
  .fixed {
    position: fixed;
  }
  .relative {
    position: relative;
  }
  .static {
    position: static;
  }
  .sticky {
    position: sticky;
  }
  .inset-0 {
    inset: calc(var(--spacing) * 0);
  }
  .start {
    inset-inline-start: var(--spacing);
  }
  .end {
    inset-inline-end: var(--spacing);
  }
  .-top-2\\.5 {
    top: calc(var(--spacing) * -2.5);
  }
  .top-0 {
    top: calc(var(--spacing) * 0);
  }
  .top-1\\.5 {
    top: calc(var(--spacing) * 1.5);
  }
  .top-1\\/2 {
    top: calc(1 / 2 * 100%);
  }
  .top-2 {
    top: calc(var(--spacing) * 2);
  }
  .top-3 {
    top: calc(var(--spacing) * 3);
  }
  .top-200 {
    top: calc(var(--spacing) * 200);
  }
  .top-full {
    top: 100%;
  }
  .right-0 {
    right: calc(var(--spacing) * 0);
  }
  .right-2 {
    right: calc(var(--spacing) * 2);
  }
  .right-3 {
    right: calc(var(--spacing) * 3);
  }
  .right-10 {
    right: calc(var(--spacing) * 10);
  }
  .right-full {
    right: 100%;
  }
  .bottom-0 {
    bottom: calc(var(--spacing) * 0);
  }
  .bottom-2 {
    bottom: calc(var(--spacing) * 2);
  }
  .bottom-6 {
    bottom: calc(var(--spacing) * 6);
  }
  .bottom-10 {
    bottom: calc(var(--spacing) * 10);
  }
  .bottom-12 {
    bottom: calc(var(--spacing) * 12);
  }
  .bottom-full {
    bottom: 100%;
  }
  .left-0 {
    left: calc(var(--spacing) * 0);
  }
  .left-0\\.5 {
    left: calc(var(--spacing) * 0.5);
  }
  .left-1\\.5 {
    left: calc(var(--spacing) * 1.5);
  }
  .left-1\\/2 {
    left: calc(1 / 2 * 100%);
  }
  .left-4 {
    left: calc(var(--spacing) * 4);
  }
  .left-6 {
    left: calc(var(--spacing) * 6);
  }
  .left-\\[calc\\(100\\%\\+1px\\)\\] {
    left: calc(100% + 1px);
  }
  .left-full {
    left: 100%;
  }
  .z-0 {
    z-index: 0;
  }
  .z-1 {
    z-index: 1;
  }
  .z-10 {
    z-index: 10;
  }
  .z-25 {
    z-index: 25;
  }
  .z-50 {
    z-index: 50;
  }
  .z-99 {
    z-index: 99;
  }
  .col-2 {
    grid-column: 2;
  }
  .col-10 {
    grid-column: 10;
  }
  .col-12 {
    grid-column: 12;
  }
  .col-span-1 {
    grid-column: span 1 / span 1;
  }
  .col-span-2 {
    grid-column: span 2 / span 2;
  }
  .col-span-3 {
    grid-column: span 3 / span 3;
  }
  .col-span-full {
    grid-column: 1 / -1;
  }
  .row-span-3 {
    grid-row: span 3 / span 3;
  }
  .float-right {
    float: right;
  }
  .m-0 {
    margin: calc(var(--spacing) * 0);
  }
  .m-0\\! {
    margin: calc(var(--spacing) * 0) !important;
  }
  .m-\\[5px\\] {
    margin: 5px;
  }
  .mx-1 {
    margin-inline: calc(var(--spacing) * 1);
  }
  .mx-2 {
    margin-inline: calc(var(--spacing) * 2);
  }
  .mx-4 {
    margin-inline: calc(var(--spacing) * 4);
  }
  .mx-auto {
    margin-inline: auto;
  }
  .my-1 {
    margin-block: calc(var(--spacing) * 1);
  }
  .my-2 {
    margin-block: calc(var(--spacing) * 2);
  }
  .my-2\\.5 {
    margin-block: calc(var(--spacing) * 2.5);
  }
  .my-3 {
    margin-block: calc(var(--spacing) * 3);
  }
  .my-5 {
    margin-block: calc(var(--spacing) * 5);
  }
  .my-10 {
    margin-block: calc(var(--spacing) * 10);
  }
  .ms-1 {
    margin-inline-start: calc(var(--spacing) * 1);
  }
  .ms-2 {
    margin-inline-start: calc(var(--spacing) * 2);
  }
  .ms-auto {
    margin-inline-start: auto;
  }
  .me-1 {
    margin-inline-end: calc(var(--spacing) * 1);
  }
  .-mt-0\\.5 {
    margin-top: calc(var(--spacing) * -0.5);
  }
  .mt-0\\.5 {
    margin-top: calc(var(--spacing) * 0.5);
  }
  .mt-1 {
    margin-top: calc(var(--spacing) * 1);
  }
  .mt-1\\! {
    margin-top: calc(var(--spacing) * 1) !important;
  }
  .mt-2 {
    margin-top: calc(var(--spacing) * 2);
  }
  .mt-2\\.5 {
    margin-top: calc(var(--spacing) * 2.5);
  }
  .mt-3 {
    margin-top: calc(var(--spacing) * 3);
  }
  .mt-4 {
    margin-top: calc(var(--spacing) * 4);
  }
  .mt-5 {
    margin-top: calc(var(--spacing) * 5);
  }
  .-mr-2 {
    margin-right: calc(var(--spacing) * -2);
  }
  .mr-1 {
    margin-right: calc(var(--spacing) * 1);
  }
  .mr-2 {
    margin-right: calc(var(--spacing) * 2);
  }
  .mb-0 {
    margin-bottom: calc(var(--spacing) * 0);
  }
  .mb-0\\! {
    margin-bottom: calc(var(--spacing) * 0) !important;
  }
  .mb-0\\.5 {
    margin-bottom: calc(var(--spacing) * 0.5);
  }
  .mb-1 {
    margin-bottom: calc(var(--spacing) * 1);
  }
  .mb-2 {
    margin-bottom: calc(var(--spacing) * 2);
  }
  .mb-2\\.5 {
    margin-bottom: calc(var(--spacing) * 2.5);
  }
  .mb-3 {
    margin-bottom: calc(var(--spacing) * 3);
  }
  .mb-4 {
    margin-bottom: calc(var(--spacing) * 4);
  }
  .mb-5 {
    margin-bottom: calc(var(--spacing) * 5);
  }
  .mb-6 {
    margin-bottom: calc(var(--spacing) * 6);
  }
  .mb-8 {
    margin-bottom: calc(var(--spacing) * 8);
  }
  .ml-0\\! {
    margin-left: calc(var(--spacing) * 0) !important;
  }
  .ml-1 {
    margin-left: calc(var(--spacing) * 1);
  }
  .ml-2 {
    margin-left: calc(var(--spacing) * 2);
  }
  .ml-auto {
    margin-left: auto;
  }
  .ml-auto\\! {
    margin-left: auto !important;
  }
  .line-clamp-1 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
  .line-clamp-2 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .block {
    display: block;
  }
  .contents {
    display: contents;
  }
  .flex {
    display: flex;
  }
  .flex\\! {
    display: flex !important;
  }
  .grid {
    display: grid;
  }
  .hidden {
    display: none;
  }
  .inline-block {
    display: inline-block;
  }
  .inline-flex {
    display: inline-flex;
  }
  .table {
    display: table;
  }
  .aspect-4\\/6 {
    aspect-ratio: 4/6;
  }
  .aspect-6\\/4 {
    aspect-ratio: 6/4;
  }
  .aspect-square {
    aspect-ratio: 1 / 1;
  }
  .h-1 {
    height: calc(var(--spacing) * 1);
  }
  .h-1\\.5 {
    height: calc(var(--spacing) * 1.5);
  }
  .h-2 {
    height: calc(var(--spacing) * 2);
  }
  .h-6 {
    height: calc(var(--spacing) * 6);
  }
  .h-7\\.5 {
    height: calc(var(--spacing) * 7.5);
  }
  .h-8 {
    height: calc(var(--spacing) * 8);
  }
  .h-9 {
    height: calc(var(--spacing) * 9);
  }
  .h-10 {
    height: calc(var(--spacing) * 10);
  }
  .h-12 {
    height: calc(var(--spacing) * 12);
  }
  .h-25 {
    height: calc(var(--spacing) * 25);
  }
  .h-30 {
    height: calc(var(--spacing) * 30);
  }
  .h-32 {
    height: calc(var(--spacing) * 32);
  }
  .h-40 {
    height: calc(var(--spacing) * 40);
  }
  .h-50 {
    height: calc(var(--spacing) * 50);
  }
  .h-60 {
    height: calc(var(--spacing) * 60);
  }
  .h-\\[3px\\] {
    height: 3px;
  }
  .h-\\[10px\\] {
    height: 10px;
  }
  .h-\\[40px\\] {
    height: 40px;
  }
  .h-\\[50px\\] {
    height: 50px;
  }
  .h-\\[70px\\] {
    height: 70px;
  }
  .h-\\[70vh\\] {
    height: 70vh;
  }
  .h-\\[75dvh\\] {
    height: 75dvh;
  }
  .h-\\[100px\\] {
    height: 100px;
  }
  .h-\\[200px\\] {
    height: 200px;
  }
  .h-\\[calc\\(100vh-60px\\)\\] {
    height: calc(100vh - 60px);
  }
  .h-dvh {
    height: 100dvh;
  }
  .h-full {
    height: 100%;
  }
  .h-full\\! {
    height: 100% !important;
  }
  .h-px {
    height: 1px;
  }
  .max-h-\\[300px\\] {
    max-height: 300px;
  }
  .max-h-\\[400px\\] {
    max-height: 400px;
  }
  .max-h-full {
    max-height: 100%;
  }
  .min-h-0 {
    min-height: calc(var(--spacing) * 0);
  }
  .min-h-1 {
    min-height: calc(var(--spacing) * 1);
  }
  .min-h-10 {
    min-height: calc(var(--spacing) * 10);
  }
  .min-h-30 {
    min-height: calc(var(--spacing) * 30);
  }
  .min-h-40 {
    min-height: calc(var(--spacing) * 40);
  }
  .min-h-50 {
    min-height: calc(var(--spacing) * 50);
  }
  .min-h-\\[30dvh\\] {
    min-height: 30dvh;
  }
  .min-h-\\[32px\\] {
    min-height: 32px;
  }
  .min-h-\\[50dvh\\] {
    min-height: 50dvh;
  }
  .min-h-\\[300px\\] {
    min-height: 300px;
  }
  .min-h-screen {
    min-height: 100vh;
  }
  .w-\\(--progress\\) {
    width: var(--progress);
  }
  .w-1 {
    width: calc(var(--spacing) * 1);
  }
  .w-1\\.5 {
    width: calc(var(--spacing) * 1.5);
  }
  .w-1\\/2 {
    width: calc(1 / 2 * 100%);
  }
  .w-1\\/3 {
    width: calc(1 / 3 * 100%);
  }
  .w-1\\/5 {
    width: calc(1 / 5 * 100%);
  }
  .w-1\\/6 {
    width: calc(1 / 6 * 100%);
  }
  .w-2 {
    width: calc(var(--spacing) * 2);
  }
  .w-4 {
    width: calc(var(--spacing) * 4);
  }
  .w-5 {
    width: calc(var(--spacing) * 5);
  }
  .w-6 {
    width: calc(var(--spacing) * 6);
  }
  .w-8 {
    width: calc(var(--spacing) * 8);
  }
  .w-8\\! {
    width: calc(var(--spacing) * 8) !important;
  }
  .w-10 {
    width: calc(var(--spacing) * 10);
  }
  .w-12 {
    width: calc(var(--spacing) * 12);
  }
  .w-25 {
    width: calc(var(--spacing) * 25);
  }
  .w-32 {
    width: calc(var(--spacing) * 32);
  }
  .w-40 {
    width: calc(var(--spacing) * 40);
  }
  .w-50 {
    width: calc(var(--spacing) * 50);
  }
  .w-100 {
    width: calc(var(--spacing) * 100);
  }
  .w-\\[7ch\\] {
    width: 7ch;
  }
  .w-\\[15\\%\\] {
    width: 15%;
  }
  .w-\\[30\\%\\] {
    width: 30%;
  }
  .w-\\[100px\\] {
    width: 100px;
  }
  .w-\\[150px\\] {
    width: 150px;
  }
  .w-\\[150px\\]\\! {
    width: 150px !important;
  }
  .w-\\[170px\\] {
    width: 170px;
  }
  .w-\\[180px\\] {
    width: 180px;
  }
  .w-\\[200px\\] {
    width: 200px;
  }
  .w-dvw {
    width: 100dvw;
  }
  .w-fit {
    width: fit-content;
  }
  .w-full {
    width: 100%;
  }
  .w-max {
    width: max-content;
  }
  .w-px {
    width: 1px;
  }
  .max-w-2xl {
    max-width: var(--container-2xl);
  }
  .max-w-4xl {
    max-width: var(--container-4xl);
  }
  .max-w-5xl {
    max-width: var(--container-5xl);
  }
  .max-w-\\[20ch\\] {
    max-width: 20ch;
  }
  .max-w-\\[30ch\\] {
    max-width: 30ch;
  }
  .max-w-\\[250px\\] {
    max-width: 250px;
  }
  .max-w-\\[300px\\] {
    max-width: 300px;
  }
  .max-w-\\[320px\\] {
    max-width: 320px;
  }
  .max-w-\\[400px\\] {
    max-width: 400px;
  }
  .max-w-\\[1980px\\] {
    max-width: 1980px;
  }
  .max-w-full {
    max-width: 100%;
  }
  .max-w-lg {
    max-width: var(--container-lg);
  }
  .max-w-lg\\! {
    max-width: var(--container-lg) !important;
  }
  .max-w-sm {
    max-width: var(--container-sm);
  }
  .max-w-xl {
    max-width: var(--container-xl);
  }
  .max-w-xs {
    max-width: var(--container-xs);
  }
  .min-w-0 {
    min-width: calc(var(--spacing) * 0);
  }
  .min-w-8 {
    min-width: calc(var(--spacing) * 8);
  }
  .min-w-50 {
    min-width: calc(var(--spacing) * 50);
  }
  .min-w-\\[20ch\\] {
    min-width: 20ch;
  }
  .min-w-\\[200px\\] {
    min-width: 200px;
  }
  .min-w-full {
    min-width: 100%;
  }
  .min-w-md {
    min-width: var(--container-md);
  }
  .flex-1 {
    flex: 1;
  }
  .flex-none {
    flex: none;
  }
  .shrink-0 {
    flex-shrink: 0;
  }
  .flex-grow-1 {
    flex-grow: 1;
  }
  .grow {
    flex-grow: 1;
  }
  .grow-0 {
    flex-grow: 0;
  }
  .origin-left {
    transform-origin: 0;
  }
  .-translate-x-1\\/2 {
    --tw-translate-x: calc(calc(1 / 2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-translate-x-3 {
    --tw-translate-x: calc(var(--spacing) * -3);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-x-3 {
    --tw-translate-x: calc(var(--spacing) * 3);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-translate-y-1\\/2 {
    --tw-translate-y: calc(calc(1 / 2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-y-0 {
    --tw-translate-y: calc(var(--spacing) * 0);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-y-10 {
    --tw-translate-y: calc(var(--spacing) * 10);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .scale-75 {
    --tw-scale-x: 75%;
    --tw-scale-y: 75%;
    --tw-scale-z: 75%;
    scale: var(--tw-scale-x) var(--tw-scale-y);
  }
  .scale-90 {
    --tw-scale-x: 90%;
    --tw-scale-y: 90%;
    --tw-scale-z: 90%;
    scale: var(--tw-scale-x) var(--tw-scale-y);
  }
  .transform {
    transform: var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
  }
  .animate-pulse {
    animation: var(--animate-pulse);
  }
  .cursor-default {
    cursor: default;
  }
  .cursor-move {
    cursor: move;
  }
  .cursor-not-allowed {
    cursor: not-allowed;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .resize {
    resize: both;
  }
  .snap-x {
    scroll-snap-type: x var(--tw-scroll-snap-strictness);
  }
  .snap-mandatory {
    --tw-scroll-snap-strictness: mandatory;
  }
  .list-inside {
    list-style-position: inside;
  }
  .list-disc {
    list-style-type: disc;
  }
  .list-none {
    list-style-type: none;
  }
  .grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .grid-cols-1\\! {
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }
  .grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .grid-cols-\\[1fr_15\\%_15\\%_15\\%\\] {
    grid-template-columns: 1fr 15% 15% 15%;
  }
  .grid-cols-\\[1fr_auto\\] {
    grid-template-columns: 1fr auto;
  }
  .grid-cols-\\[30\\%_1fr\\] {
    grid-template-columns: 30% 1fr;
  }
  .grid-cols-\\[auto_1fr\\] {
    grid-template-columns: auto 1fr;
  }
  .grid-cols-\\[auto_1fr_auto\\] {
    grid-template-columns: auto 1fr auto;
  }
  .grid-cols-\\[max-content_1fr\\] {
    grid-template-columns: max-content 1fr;
  }
  .grid-cols-\\[max-content_auto\\] {
    grid-template-columns: max-content auto;
  }
  .grid-cols-\\[repeat\\(5\\,20px\\)\\] {
    grid-template-columns: repeat(5,20px);
  }
  .grid-cols-\\[repeat\\(auto-fill\\,minmax\\(100px\\,max-content\\)\\)\\] {
    grid-template-columns: repeat(auto-fill,minmax(100px,max-content));
  }
  .grid-cols-\\[repeat\\(auto-fill\\,minmax\\(200px\\,1fr\\)\\)\\] {
    grid-template-columns: repeat(auto-fill,minmax(200px,1fr));
  }
  .grid-cols-\\[repeat\\(auto-fill\\,minmax\\(300px\\,1fr\\)\\)\\] {
    grid-template-columns: repeat(auto-fill,minmax(300px,1fr));
  }
  .grid-cols-\\[repeat\\(auto-fill\\,minmax\\(600px\\,1fr\\)\\)\\] {
    grid-template-columns: repeat(auto-fill,minmax(600px,1fr));
  }
  .grid-cols-subgrid {
    grid-template-columns: subgrid;
  }
  .grid-rows-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  .grid-rows-3\\! {
    grid-template-rows: repeat(3, minmax(0, 1fr)) !important;
  }
  .grid-rows-\\[0fr\\] {
    grid-template-rows: 0fr;
  }
  .grid-rows-\\[1fr_auto_auto\\] {
    grid-template-rows: 1fr auto auto;
  }
  .grid-rows-\\[auto_1fr_auto\\] {
    grid-template-rows: auto 1fr auto;
  }
  .grid-rows-\\[auto_250px_auto\\] {
    grid-template-rows: auto 250px auto;
  }
  .grid-rows-\\[auto_repeate\\(3\\,1fr\\)\\] {
    grid-template-rows: auto repeate(3,1fr);
  }
  .grid-rows-\\[minmax\\(auto\\,400px\\)_auto\\] {
    grid-template-rows: minmax(auto,400px) auto;
  }
  .grid-rows-subgrid {
    grid-template-rows: subgrid;
  }
  .flex-col {
    flex-direction: column;
  }
  .flex-row {
    flex-direction: row;
  }
  .flex-nowrap {
    flex-wrap: nowrap;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .items-baseline {
    align-items: baseline;
  }
  .items-center {
    align-items: center;
  }
  .items-end-safe {
    align-items: safe flex-end;
  }
  .items-start {
    align-items: flex-start;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .justify-end-safe {
    justify-content: safe flex-end;
  }
  .gap-0 {
    gap: calc(var(--spacing) * 0);
  }
  .gap-0\\.5 {
    gap: calc(var(--spacing) * 0.5);
  }
  .gap-1 {
    gap: calc(var(--spacing) * 1);
  }
  .gap-1\\.5 {
    gap: calc(var(--spacing) * 1.5);
  }
  .gap-2 {
    gap: calc(var(--spacing) * 2);
  }
  .gap-2\\.5 {
    gap: calc(var(--spacing) * 2.5);
  }
  .gap-3 {
    gap: calc(var(--spacing) * 3);
  }
  .gap-4 {
    gap: calc(var(--spacing) * 4);
  }
  .gap-5 {
    gap: calc(var(--spacing) * 5);
  }
  .space-y-2 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 2) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .gap-x-1 {
    column-gap: calc(var(--spacing) * 1);
  }
  .gap-x-2 {
    column-gap: calc(var(--spacing) * 2);
  }
  .gap-x-3 {
    column-gap: calc(var(--spacing) * 3);
  }
  .gap-x-4 {
    column-gap: calc(var(--spacing) * 4);
  }
  .gap-x-6 {
    column-gap: calc(var(--spacing) * 6);
  }
  .gap-x-8 {
    column-gap: calc(var(--spacing) * 8);
  }
  .gap-y-0\\.5 {
    row-gap: calc(var(--spacing) * 0.5);
  }
  .gap-y-1 {
    row-gap: calc(var(--spacing) * 1);
  }
  .gap-y-1\\.5 {
    row-gap: calc(var(--spacing) * 1.5);
  }
  .gap-y-2 {
    row-gap: calc(var(--spacing) * 2);
  }
  .gap-y-2\\.5 {
    row-gap: calc(var(--spacing) * 2.5);
  }
  .gap-y-3 {
    row-gap: calc(var(--spacing) * 3);
  }
  .gap-y-4 {
    row-gap: calc(var(--spacing) * 4);
  }
  .gap-y-5 {
    row-gap: calc(var(--spacing) * 5);
  }
  .gap-y-6 {
    row-gap: calc(var(--spacing) * 6);
  }
  .self-start {
    align-self: flex-start;
  }
  .truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .overflow-auto {
    overflow: auto;
  }
  .overflow-hidden {
    overflow: hidden;
  }
  .overflow-scroll {
    overflow: scroll;
  }
  .overflow-visible {
    overflow: visible;
  }
  .overflow-visible\\! {
    overflow: visible !important;
  }
  .overflow-x-auto {
    overflow-x: auto;
  }
  .overflow-x-hidden {
    overflow-x: hidden;
  }
  .overflow-x-hidden\\! {
    overflow-x: hidden !important;
  }
  .overflow-y-auto {
    overflow-y: auto;
  }
  .overflow-y-scroll {
    overflow-y: scroll;
  }
  .rounded {
    border-radius: 0.25rem;
  }
  .rounded-2xl {
    border-radius: var(--radius-2xl);
  }
  .rounded-3xl {
    border-radius: var(--radius-3xl);
  }
  .rounded-\\[5px\\] {
    border-radius: 5px;
  }
  .rounded-\\[8px\\] {
    border-radius: 8px;
  }
  .rounded-full {
    border-radius: calc(infinity * 1px);
  }
  .rounded-lg {
    border-radius: var(--radius-lg);
  }
  .rounded-md {
    border-radius: var(--radius-md);
  }
  .rounded-none\\! {
    border-radius: 0 !important;
  }
  .rounded-sm {
    border-radius: var(--radius-sm);
  }
  .rounded-xl {
    border-radius: var(--radius-xl);
  }
  .rounded-t {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }
  .rounded-r {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
  }
  .border {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .border\\! {
    border-style: var(--tw-border-style) !important;
    border-width: 1px !important;
  }
  .border-0 {
    border-style: var(--tw-border-style);
    border-width: 0px;
  }
  .border-2 {
    border-style: var(--tw-border-style);
    border-width: 2px;
  }
  .border-3 {
    border-style: var(--tw-border-style);
    border-width: 3px;
  }
  .border-t {
    border-top-style: var(--tw-border-style);
    border-top-width: 1px;
  }
  .border-r {
    border-right-style: var(--tw-border-style);
    border-right-width: 1px;
  }
  .border-b {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
  }
  .border-b-0 {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 0px;
  }
  .border-l {
    border-left-style: var(--tw-border-style);
    border-left-width: 1px;
  }
  .border-l-4 {
    border-left-style: var(--tw-border-style);
    border-left-width: 4px;
  }
  .border-dashed {
    --tw-border-style: dashed;
    border-style: dashed;
  }
  .border-none {
    --tw-border-style: none;
    border-style: none;
  }
  .border-amber-100 {
    border-color: var(--color-amber-100);
  }
  .border-amber-200 {
    border-color: var(--color-amber-200);
  }
  .border-amber-300 {
    border-color: var(--color-amber-300);
  }
  .border-blue-100\\/50 {
    border-color: color-mix(in srgb, oklch(93.2% 0.032 255.585) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-blue-100) 50%, transparent);
    }
  }
  .border-blue-200\\/60 {
    border-color: color-mix(in srgb, oklch(88.2% 0.059 254.128) 60%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-blue-200) 60%, transparent);
    }
  }
  .border-emerald-200 {
    border-color: var(--color-emerald-200);
  }
  .border-gray-50 {
    border-color: var(--color-gray-50);
  }
  .border-gray-100 {
    border-color: var(--color-gray-100);
  }
  .border-gray-200 {
    border-color: var(--color-gray-200);
  }
  .border-gray-200\\! {
    border-color: var(--color-gray-200) !important;
  }
  .border-gray-200\\/80 {
    border-color: color-mix(in srgb, oklch(92.8% 0.006 264.531) 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-gray-200) 80%, transparent);
    }
  }
  .border-gray-300 {
    border-color: var(--color-gray-300);
  }
  .border-gray-300\\! {
    border-color: var(--color-gray-300) !important;
  }
  .border-gray-400 {
    border-color: var(--color-gray-400);
  }
  .border-gray-500 {
    border-color: var(--color-gray-500);
  }
  .border-main-field-border {
    border-color: var(--color-main-field-border);
  }
  .border-orange-400 {
    border-color: var(--color-orange-400);
  }
  .border-red-200\\! {
    border-color: var(--color-red-200) !important;
  }
  .border-rose-200 {
    border-color: var(--color-rose-200);
  }
  .border-sky-200 {
    border-color: var(--color-sky-200);
  }
  .border-slate-200 {
    border-color: var(--color-slate-200);
  }
  .border-white\\/50 {
    border-color: color-mix(in srgb, #fff 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-white) 50%, transparent);
    }
  }
  .border-t-gray-200 {
    border-top-color: var(--color-gray-200);
  }
  .border-t-gray-300 {
    border-top-color: var(--color-gray-300);
  }
  .border-t-gray-400 {
    border-top-color: var(--color-gray-400);
  }
  .border-t-slate-300 {
    border-top-color: var(--color-slate-300);
  }
  .border-r-gray-100 {
    border-right-color: var(--color-gray-100);
  }
  .border-b-gray-300 {
    border-bottom-color: var(--color-gray-300);
  }
  .bg-amber-50 {
    background-color: var(--color-amber-50);
  }
  .bg-amber-50\\! {
    background-color: var(--color-amber-50) !important;
  }
  .bg-amber-50\\/50 {
    background-color: color-mix(in srgb, oklch(98.7% 0.022 95.277) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-amber-50) 50%, transparent);
    }
  }
  .bg-amber-50\\/60 {
    background-color: color-mix(in srgb, oklch(98.7% 0.022 95.277) 60%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-amber-50) 60%, transparent);
    }
  }
  .bg-amber-100 {
    background-color: var(--color-amber-100);
  }
  .bg-amber-200 {
    background-color: var(--color-amber-200);
  }
  .bg-amber-200\\/70 {
    background-color: color-mix(in srgb, oklch(92.4% 0.12 95.746) 70%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-amber-200) 70%, transparent);
    }
  }
  .bg-amber-500 {
    background-color: var(--color-amber-500);
  }
  .bg-amber-600 {
    background-color: var(--color-amber-600);
  }
  .bg-base-100 {
    background-color: var(--color-base-100);
  }
  .bg-black {
    background-color: var(--color-black);
  }
  .bg-blue-50 {
    background-color: var(--color-blue-50);
  }
  .bg-blue-50\\! {
    background-color: var(--color-blue-50) !important;
  }
  .bg-blue-50\\/30 {
    background-color: color-mix(in srgb, oklch(97% 0.014 254.604) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-blue-50) 30%, transparent);
    }
  }
  .bg-blue-50\\/40 {
    background-color: color-mix(in srgb, oklch(97% 0.014 254.604) 40%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-blue-50) 40%, transparent);
    }
  }
  .bg-blue-600 {
    background-color: var(--color-blue-600);
  }
  .bg-current {
    background-color: currentcolor;
  }
  .bg-emerald-50 {
    background-color: var(--color-emerald-50);
  }
  .bg-emerald-600 {
    background-color: var(--color-emerald-600);
  }
  .bg-gray-50 {
    background-color: var(--color-gray-50);
  }
  .bg-gray-50\\/30 {
    background-color: color-mix(in srgb, oklch(98.5% 0.002 247.839) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-gray-50) 30%, transparent);
    }
  }
  .bg-gray-100 {
    background-color: var(--color-gray-100);
  }
  .bg-gray-200 {
    background-color: var(--color-gray-200);
  }
  .bg-gray-200\\! {
    background-color: var(--color-gray-200) !important;
  }
  .bg-gray-300 {
    background-color: var(--color-gray-300);
  }
  .bg-gray-600 {
    background-color: var(--color-gray-600);
  }
  .bg-gray-700 {
    background-color: var(--color-gray-700);
  }
  .bg-gray-700\\/50 {
    background-color: color-mix(in srgb, oklch(37.3% 0.034 259.733) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-gray-700) 50%, transparent);
    }
  }
  .bg-gray-700\\/80 {
    background-color: color-mix(in srgb, oklch(37.3% 0.034 259.733) 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-gray-700) 80%, transparent);
    }
  }
  .bg-green-400 {
    background-color: var(--color-green-400);
  }
  .bg-green-700 {
    background-color: var(--color-green-700);
  }
  .bg-link {
    background-color: var(--color-link);
  }
  .bg-main-field {
    background-color: var(--color-main-field);
  }
  .bg-orange-50 {
    background-color: var(--color-orange-50);
  }
  .bg-orange-200\\! {
    background-color: var(--color-orange-200) !important;
  }
  .bg-orange-400 {
    background-color: var(--color-orange-400);
  }
  .bg-red-200 {
    background-color: var(--color-red-200);
  }
  .bg-red-300\\/\\(--my-opacity\\) {
    background-color: oklch(80.8% 0.114 19.571);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-red-300) var(--my-opacity), transparent);
    }
  }
  .bg-red-400 {
    background-color: var(--color-red-400);
  }
  .bg-red-700 {
    background-color: var(--color-red-700);
  }
  .bg-rose-50 {
    background-color: var(--color-rose-50);
  }
  .bg-rose-600 {
    background-color: var(--color-rose-600);
  }
  .bg-sky-50 {
    background-color: var(--color-sky-50);
  }
  .bg-sky-600 {
    background-color: var(--color-sky-600);
  }
  .bg-slate-50 {
    background-color: var(--color-slate-50);
  }
  .bg-slate-50\\/50 {
    background-color: color-mix(in srgb, oklch(98.4% 0.003 247.858) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-slate-50) 50%, transparent);
    }
  }
  .bg-slate-100\\/50 {
    background-color: color-mix(in srgb, oklch(96.8% 0.007 247.896) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-slate-100) 50%, transparent);
    }
  }
  .bg-white {
    background-color: var(--color-white);
  }
  .bg-white\\! {
    background-color: var(--color-white) !important;
  }
  .bg-white\\/80 {
    background-color: color-mix(in srgb, #fff 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 80%, transparent);
    }
  }
  .bg-yellow-200\\/70 {
    background-color: color-mix(in srgb, oklch(94.5% 0.129 101.54) 70%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-yellow-200) 70%, transparent);
    }
  }
  .bg-yellow-400 {
    background-color: var(--color-yellow-400);
  }
  .bg-gradient-to-b {
    --tw-gradient-position: to bottom in oklab;
    background-image: linear-gradient(var(--tw-gradient-stops));
  }
  .bg-\\(image\\:--color-image\\) {
    background-image: var(--color-image);
  }
  .bg-\\(image\\:--product-image\\) {
    background-image: var(--product-image);
  }
  .from-white {
    --tw-gradient-from: var(--color-white);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-gray-50\\/50 {
    --tw-gradient-to: color-mix(in srgb, oklch(98.5% 0.002 247.839) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-gradient-to: color-mix(in oklab, var(--color-gray-50) 50%, transparent);
    }
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .bg-contain {
    background-size: contain;
  }
  .bg-size-\\[105\\%\\] {
    background-size: 105%;
  }
  .bg-center {
    background-position: center;
  }
  .bg-no-repeat {
    background-repeat: no-repeat;
  }
  .object-contain {
    object-fit: contain;
  }
  .p-0\\! {
    padding: calc(var(--spacing) * 0) !important;
  }
  .p-0\\.5 {
    padding: calc(var(--spacing) * 0.5);
  }
  .p-1 {
    padding: calc(var(--spacing) * 1);
  }
  .p-2 {
    padding: calc(var(--spacing) * 2);
  }
  .p-2\\.5 {
    padding: calc(var(--spacing) * 2.5);
  }
  .p-3 {
    padding: calc(var(--spacing) * 3);
  }
  .p-4 {
    padding: calc(var(--spacing) * 4);
  }
  .px-0\\! {
    padding-inline: calc(var(--spacing) * 0) !important;
  }
  .px-1 {
    padding-inline: calc(var(--spacing) * 1);
  }
  .px-1\\.5 {
    padding-inline: calc(var(--spacing) * 1.5);
  }
  .px-2 {
    padding-inline: calc(var(--spacing) * 2);
  }
  .px-2\\.5 {
    padding-inline: calc(var(--spacing) * 2.5);
  }
  .px-3 {
    padding-inline: calc(var(--spacing) * 3);
  }
  .px-3\\.5 {
    padding-inline: calc(var(--spacing) * 3.5);
  }
  .px-4 {
    padding-inline: calc(var(--spacing) * 4);
  }
  .px-5 {
    padding-inline: calc(var(--spacing) * 5);
  }
  .px-6 {
    padding-inline: calc(var(--spacing) * 6);
  }
  .py-0\\! {
    padding-block: calc(var(--spacing) * 0) !important;
  }
  .py-0\\.5 {
    padding-block: calc(var(--spacing) * 0.5);
  }
  .py-1 {
    padding-block: calc(var(--spacing) * 1);
  }
  .py-1\\! {
    padding-block: calc(var(--spacing) * 1) !important;
  }
  .py-1\\.5 {
    padding-block: calc(var(--spacing) * 1.5);
  }
  .py-2 {
    padding-block: calc(var(--spacing) * 2);
  }
  .py-2\\.5 {
    padding-block: calc(var(--spacing) * 2.5);
  }
  .py-3 {
    padding-block: calc(var(--spacing) * 3);
  }
  .py-4 {
    padding-block: calc(var(--spacing) * 4);
  }
  .py-5 {
    padding-block: calc(var(--spacing) * 5);
  }
  .py-7 {
    padding-block: calc(var(--spacing) * 7);
  }
  .py-20 {
    padding-block: calc(var(--spacing) * 20);
  }
  .ps-0 {
    padding-inline-start: calc(var(--spacing) * 0);
  }
  .ps-1 {
    padding-inline-start: calc(var(--spacing) * 1);
  }
  .pe-2 {
    padding-inline-end: calc(var(--spacing) * 2);
  }
  .pt-1 {
    padding-top: calc(var(--spacing) * 1);
  }
  .pt-2 {
    padding-top: calc(var(--spacing) * 2);
  }
  .pt-3 {
    padding-top: calc(var(--spacing) * 3);
  }
  .pt-4 {
    padding-top: calc(var(--spacing) * 4);
  }
  .pt-5 {
    padding-top: calc(var(--spacing) * 5);
  }
  .pt-px {
    padding-top: 1px;
  }
  .pr-1 {
    padding-right: calc(var(--spacing) * 1);
  }
  .pr-2 {
    padding-right: calc(var(--spacing) * 2);
  }
  .pr-4 {
    padding-right: calc(var(--spacing) * 4);
  }
  .pr-5 {
    padding-right: calc(var(--spacing) * 5);
  }
  .pb-1 {
    padding-bottom: calc(var(--spacing) * 1);
  }
  .pb-2 {
    padding-bottom: calc(var(--spacing) * 2);
  }
  .pb-3 {
    padding-bottom: calc(var(--spacing) * 3);
  }
  .pb-15 {
    padding-bottom: calc(var(--spacing) * 15);
  }
  .pb-20 {
    padding-bottom: calc(var(--spacing) * 20);
  }
  .pl-2 {
    padding-left: calc(var(--spacing) * 2);
  }
  .pl-3 {
    padding-left: calc(var(--spacing) * 3);
  }
  .pl-5 {
    padding-left: calc(var(--spacing) * 5);
  }
  .pl-11 {
    padding-left: calc(var(--spacing) * 11);
  }
  .pl-\\[0\\.35em\\] {
    padding-left: 0.35em;
  }
  .text-center {
    text-align: center;
  }
  .text-right {
    text-align: right;
  }
  .font-mono {
    font-family: var(--font-mono);
  }
  .font-title {
    font-family: var(--font-title);
  }
  .text-2xl {
    font-size: var(--text-2xl);
    line-height: var(--tw-leading, var(--text-2xl--line-height));
  }
  .text-2xl\\! {
    font-size: var(--text-2xl) !important;
    line-height: var(--tw-leading, var(--text-2xl--line-height)) !important;
  }
  .text-3xl {
    font-size: var(--text-3xl);
    line-height: var(--tw-leading, var(--text-3xl--line-height));
  }
  .text-4xl {
    font-size: var(--text-4xl);
    line-height: var(--tw-leading, var(--text-4xl--line-height));
  }
  .text-5xl {
    font-size: var(--text-5xl);
    line-height: var(--tw-leading, var(--text-5xl--line-height));
  }
  .text-base {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
  }
  .text-lg {
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
  }
  .text-sm {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
  .text-xl {
    font-size: var(--text-xl);
    line-height: var(--tw-leading, var(--text-xl--line-height));
  }
  .text-xs {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
  }
  .text-xs\\! {
    font-size: var(--text-xs) !important;
    line-height: var(--tw-leading, var(--text-xs--line-height)) !important;
  }
  .text-\\[6px\\] {
    font-size: 6px;
  }
  .text-\\[9px\\] {
    font-size: 9px;
  }
  .text-\\[10px\\] {
    font-size: 10px;
  }
  .text-\\[11px\\] {
    font-size: 11px;
  }
  .leading-none {
    --tw-leading: 1;
    line-height: 1;
  }
  .leading-snug {
    --tw-leading: var(--leading-snug);
    line-height: var(--leading-snug);
  }
  .font-black {
    --tw-font-weight: var(--font-weight-black);
    font-weight: var(--font-weight-black);
  }
  .font-bold {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
  .font-bold\\! {
    --tw-font-weight: var(--font-weight-bold) !important;
    font-weight: var(--font-weight-bold) !important;
  }
  .font-medium {
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .font-normal {
    --tw-font-weight: var(--font-weight-normal);
    font-weight: var(--font-weight-normal);
  }
  .font-semibold {
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
  }
  .tracking-\\[0\\.35em\\] {
    --tw-tracking: 0.35em;
    letter-spacing: 0.35em;
  }
  .tracking-tight {
    --tw-tracking: var(--tracking-tight);
    letter-spacing: var(--tracking-tight);
  }
  .tracking-wide {
    --tw-tracking: var(--tracking-wide);
    letter-spacing: var(--tracking-wide);
  }
  .tracking-wider {
    --tw-tracking: var(--tracking-wider);
    letter-spacing: var(--tracking-wider);
  }
  .text-balance {
    text-wrap: balance;
  }
  .wrap-break-word {
    overflow-wrap: break-word;
  }
  .break-all {
    word-break: break-all;
  }
  .whitespace-normal {
    white-space: normal;
  }
  .whitespace-nowrap {
    white-space: nowrap;
  }
  .text-\\[\\#ffdb4d\\] {
    color: #ffdb4d;
  }
  .text-amber-400 {
    color: var(--color-amber-400);
  }
  .text-amber-500 {
    color: var(--color-amber-500);
  }
  .text-amber-600 {
    color: var(--color-amber-600);
  }
  .text-amber-700 {
    color: var(--color-amber-700);
  }
  .text-amber-700\\! {
    color: var(--color-amber-700) !important;
  }
  .text-amber-800 {
    color: var(--color-amber-800);
  }
  .text-amber-900 {
    color: var(--color-amber-900);
  }
  .text-base-500 {
    color: var(--color-base-500);
  }
  .text-black {
    color: var(--color-black);
  }
  .text-black\\! {
    color: var(--color-black) !important;
  }
  .text-blue-400 {
    color: var(--color-blue-400);
  }
  .text-blue-500 {
    color: var(--color-blue-500);
  }
  .text-blue-600 {
    color: var(--color-blue-600);
  }
  .text-blue-700 {
    color: var(--color-blue-700);
  }
  .text-emerald-700 {
    color: var(--color-emerald-700);
  }
  .text-emerald-700\\! {
    color: var(--color-emerald-700) !important;
  }
  .text-gray-200 {
    color: var(--color-gray-200);
  }
  .text-gray-300 {
    color: var(--color-gray-300);
  }
  .text-gray-400 {
    color: var(--color-gray-400);
  }
  .text-gray-400\\! {
    color: var(--color-gray-400) !important;
  }
  .text-gray-500 {
    color: var(--color-gray-500);
  }
  .text-gray-600 {
    color: var(--color-gray-600);
  }
  .text-gray-700 {
    color: var(--color-gray-700);
  }
  .text-gray-800 {
    color: var(--color-gray-800);
  }
  .text-gray-900 {
    color: var(--color-gray-900);
  }
  .text-green-500 {
    color: var(--color-green-500);
  }
  .text-green-600 {
    color: var(--color-green-600);
  }
  .text-green-700 {
    color: var(--color-green-700);
  }
  .text-green-800 {
    color: var(--color-green-800);
  }
  .text-link {
    color: var(--color-link);
  }
  .text-link\\! {
    color: var(--color-link) !important;
  }
  .text-orange-400 {
    color: var(--color-orange-400);
  }
  .text-orange-500 {
    color: var(--color-orange-500);
  }
  .text-orange-700 {
    color: var(--color-orange-700);
  }
  .text-orange-800 {
    color: var(--color-orange-800);
  }
  .text-purple-500 {
    color: var(--color-purple-500);
  }
  .text-red-300 {
    color: var(--color-red-300);
  }
  .text-red-400 {
    color: var(--color-red-400);
  }
  .text-red-500 {
    color: var(--color-red-500);
  }
  .text-red-600\\! {
    color: var(--color-red-600) !important;
  }
  .text-red-700 {
    color: var(--color-red-700);
  }
  .text-rose-700 {
    color: var(--color-rose-700);
  }
  .text-rose-700\\! {
    color: var(--color-rose-700) !important;
  }
  .text-sky-700 {
    color: var(--color-sky-700);
  }
  .text-sky-700\\! {
    color: var(--color-sky-700) !important;
  }
  .text-slate-400 {
    color: var(--color-slate-400);
  }
  .text-slate-700 {
    color: var(--color-slate-700);
  }
  .text-title {
    color: var(--color-title);
  }
  .text-white {
    color: var(--color-white);
  }
  .text-white\\! {
    color: var(--color-white) !important;
  }
  .capitalize {
    text-transform: capitalize;
  }
  .uppercase {
    text-transform: uppercase;
  }
  .italic {
    font-style: italic;
  }
  .line-through {
    text-decoration-line: line-through;
  }
  .no-underline\\! {
    text-decoration-line: none !important;
  }
  .underline {
    text-decoration-line: underline;
  }
  .opacity-0 {
    opacity: 0%;
  }
  .opacity-20 {
    opacity: 20%;
  }
  .opacity-50 {
    opacity: 50%;
  }
  .opacity-70 {
    opacity: 70%;
  }
  .opacity-100 {
    opacity: 100%;
  }
  .bg-blend-darken {
    background-blend-mode: darken;
  }
  .shadow {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-2xl {
    --tw-shadow: 0 25px 50px -12px var(--tw-shadow-color, rgb(0 0 0 / 0.25));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-2xs {
    --tw-shadow: 0 1px var(--tw-shadow-color, rgb(0 0 0 / 0.05));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0_-2px_10px_rgb\\(0\\,0\\,0\\,0\\.12\\)\\] {
    --tw-shadow: 0 -2px 10px var(--tw-shadow-color, rgb(0,0,0,0.12));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-lg {
    --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-md {
    --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 2px 4px -2px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-sm {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-xs {
    --tw-shadow: 0 1px 2px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.05));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-amber-200 {
    --tw-shadow-color: oklch(92.4% 0.12 95.746);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-shadow-color: color-mix(in oklab, var(--color-amber-200) var(--tw-shadow-alpha), transparent);
    }
  }
  .shadow-blue-100 {
    --tw-shadow-color: oklch(93.2% 0.032 255.585);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-shadow-color: color-mix(in oklab, var(--color-blue-100) var(--tw-shadow-alpha), transparent);
    }
  }
  .shadow-emerald-200 {
    --tw-shadow-color: oklch(90.5% 0.093 164.15);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-shadow-color: color-mix(in oklab, var(--color-emerald-200) var(--tw-shadow-alpha), transparent);
    }
  }
  .shadow-gray-200 {
    --tw-shadow-color: oklch(92.8% 0.006 264.531);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-shadow-color: color-mix(in oklab, var(--color-gray-200) var(--tw-shadow-alpha), transparent);
    }
  }
  .shadow-gray-300 {
    --tw-shadow-color: oklch(87.2% 0.01 258.338);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-shadow-color: color-mix(in oklab, var(--color-gray-300) var(--tw-shadow-alpha), transparent);
    }
  }
  .shadow-rose-200 {
    --tw-shadow-color: oklch(89.2% 0.058 10.001);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-shadow-color: color-mix(in oklab, var(--color-rose-200) var(--tw-shadow-alpha), transparent);
    }
  }
  .shadow-sky-200 {
    --tw-shadow-color: oklch(90.1% 0.058 230.902);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-shadow-color: color-mix(in oklab, var(--color-sky-200) var(--tw-shadow-alpha), transparent);
    }
  }
  .\\!outline-4 {
    outline-style: var(--tw-outline-style) !important;
    outline-width: 4px !important;
  }
  .outline {
    outline-style: var(--tw-outline-style);
    outline-width: 1px;
  }
  .outline-1 {
    outline-style: var(--tw-outline-style);
    outline-width: 1px;
  }
  .outline-2 {
    outline-style: var(--tw-outline-style);
    outline-width: 2px;
  }
  .outline-base-200 {
    outline-color: var(--color-base-200);
  }
  .outline-base-500 {
    outline-color: var(--color-base-500);
  }
  .outline-black {
    outline-color: var(--color-black);
  }
  .outline-gray-200 {
    outline-color: var(--color-gray-200);
  }
  .outline-gray-300 {
    outline-color: var(--color-gray-300);
  }
  .outline-gray-400 {
    outline-color: var(--color-gray-400);
  }
  .outline-green-500 {
    outline-color: var(--color-green-500);
  }
  .outline-red-400 {
    outline-color: var(--color-red-400);
  }
  .filter {
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .backdrop-blur-md {
    --tw-backdrop-blur: blur(var(--blur-md));
    -webkit-backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .transition {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, -webkit-backdrop-filter, backdrop-filter, display, content-visibility, overlay, pointer-events;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-\\[grid-template-rows\\,opacity\\] {
    transition-property: grid-template-rows,opacity;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-all {
    transition-property: all;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-colors {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-shadow {
    transition-property: box-shadow;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-transform {
    transition-property: transform, translate, scale, rotate;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .duration-200 {
    --tw-duration: 200ms;
    transition-duration: 200ms;
  }
  .duration-300 {
    --tw-duration: 300ms;
    transition-duration: 300ms;
  }
  .duration-500 {
    --tw-duration: 500ms;
    transition-duration: 500ms;
  }
  .ease-in-out {
    --tw-ease: var(--ease-in-out);
    transition-timing-function: var(--ease-in-out);
  }
  .outline-dashed {
    --tw-outline-style: dashed;
    outline-style: dashed;
  }
  .outline-none {
    --tw-outline-style: none;
    outline-style: none;
  }
  .select-none {
    -webkit-user-select: none;
    user-select: none;
  }
  .\\[scrollbar-width\\:none\\] {
    scrollbar-width: none;
  }
  .text-shadow-yellow-400 {
    --tw-text-shadow-color: oklch(85.2% 0.199 91.936);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-text-shadow-color: color-mix(in oklab, var(--color-yellow-400) var(--tw-text-shadow-alpha), transparent);
    }
  }
  .not-first\\:border-t {
    &:not(*:first-child) {
      border-top-style: var(--tw-border-style);
      border-top-width: 1px;
    }
  }
  .not-first\\:border-t-gray-200 {
    &:not(*:first-child) {
      border-top-color: var(--color-gray-200);
    }
  }
  .not-first\\:pt-1 {
    &:not(*:first-child) {
      padding-top: calc(var(--spacing) * 1);
    }
  }
  .not-last\\:cursor-pointer {
    &:not(*:last-child) {
      cursor: pointer;
    }
  }
  .not-last\\:text-link\\! {
    &:not(*:last-child) {
      color: var(--color-link) !important;
    }
  }
  .group-hover\\:rotate-180 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        rotate: 180deg;
      }
    }
  }
  .group-hover\\:bg-blue-50 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        background-color: var(--color-blue-50);
      }
    }
  }
  .group-hover\\:bg-gray-300\\/50 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        background-color: color-mix(in srgb, oklch(87.2% 0.01 258.338) 50%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-gray-300) 50%, transparent);
        }
      }
    }
  }
  .group-hover\\:text-blue-600 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        color: var(--color-blue-600);
      }
    }
  }
  .group-hover\\:text-blue-700 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        color: var(--color-blue-700);
      }
    }
  }
  .group-hover\\:text-gray-500 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        color: var(--color-gray-500);
      }
    }
  }
  .group-hover\\:text-gray-700 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        color: var(--color-gray-700);
      }
    }
  }
  .group-hover\\:text-red-500 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        color: var(--color-red-500);
      }
    }
  }
  .group-hover\\:opacity-30 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        opacity: 30%;
      }
    }
  }
  .group-hover\\:opacity-100 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        opacity: 100%;
      }
    }
  }
  .group-hover\\/assigned\\:flex\\! {
    &:is(:where(.group\\/assigned):hover *) {
      @media (hover: hover) {
        display: flex !important;
      }
    }
  }
  .group-hover\\/tooltip-hover\\:visible\\! {
    &:is(:where(.group\\/tooltip-hover):hover *) {
      @media (hover: hover) {
        visibility: visible !important;
      }
    }
  }
  .group-hover\\/tooltip-hover\\:scale-100 {
    &:is(:where(.group\\/tooltip-hover):hover *) {
      @media (hover: hover) {
        --tw-scale-x: 100%;
        --tw-scale-y: 100%;
        --tw-scale-z: 100%;
        scale: var(--tw-scale-x) var(--tw-scale-y);
      }
    }
  }
  .group-hover\\/tooltip-hover\\:opacity-100 {
    &:is(:where(.group\\/tooltip-hover):hover *) {
      @media (hover: hover) {
        opacity: 100%;
      }
    }
  }
  .group-\\[\\.is-expanded\\]\\:rotate-180 {
    &:is(:where(.group):is(.is-expanded) *) {
      rotate: 180deg;
    }
  }
  .group-\\[\\.is-expanded\\]\\:grid-rows-\\[1fr\\] {
    &:is(:where(.group):is(.is-expanded) *) {
      grid-template-rows: 1fr;
    }
  }
  .group-\\[\\.is-expanded\\]\\:overflow-visible {
    &:is(:where(.group):is(.is-expanded) *) {
      overflow: visible;
    }
  }
  .group-\\[\\.is-expanded\\]\\:opacity-100 {
    &:is(:where(.group):is(.is-expanded) *) {
      opacity: 100%;
    }
  }
  .before\\:content-\\[\\'\\/\\'\\] {
    &::before {
      --tw-content: '/';
      content: var(--tw-content);
    }
  }
  .even\\:bg-gray-100 {
    &:nth-child(even) {
      background-color: var(--color-gray-100);
    }
  }
  .hover\\:cursor-grab {
    &:hover {
      @media (hover: hover) {
        cursor: grab;
      }
    }
  }
  .hover\\:cursor-not-allowed {
    &:hover {
      @media (hover: hover) {
        cursor: not-allowed;
      }
    }
  }
  .hover\\:cursor-pointer {
    &:hover {
      @media (hover: hover) {
        cursor: pointer;
      }
    }
  }
  .hover\\:border-blue-500 {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-blue-500);
      }
    }
  }
  .hover\\:bg-amber-50 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-amber-50);
      }
    }
  }
  .hover\\:bg-amber-100 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-amber-100);
      }
    }
  }
  .hover\\:bg-amber-100\\! {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-amber-100) !important;
      }
    }
  }
  .hover\\:bg-blue-50 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-blue-50);
      }
    }
  }
  .hover\\:bg-blue-700 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-blue-700);
      }
    }
  }
  .hover\\:bg-gray-50 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-50);
      }
    }
  }
  .hover\\:bg-gray-700 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-700);
      }
    }
  }
  .hover\\:bg-gray-800 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-800);
      }
    }
  }
  .hover\\:text-black {
    &:hover {
      @media (hover: hover) {
        color: var(--color-black);
      }
    }
  }
  .hover\\:text-blue-500 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-blue-500);
      }
    }
  }
  .hover\\:text-blue-700 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-blue-700);
      }
    }
  }
  .hover\\:text-blue-700\\! {
    &:hover {
      @media (hover: hover) {
        color: var(--color-blue-700) !important;
      }
    }
  }
  .hover\\:text-gray-700 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-gray-700);
      }
    }
  }
  .hover\\:text-link {
    &:hover {
      @media (hover: hover) {
        color: var(--color-link);
      }
    }
  }
  .hover\\:text-red-700 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-red-700);
      }
    }
  }
  .hover\\:no-underline\\! {
    &:hover {
      @media (hover: hover) {
        text-decoration-line: none !important;
      }
    }
  }
  .hover\\:underline {
    &:hover {
      @media (hover: hover) {
        text-decoration-line: underline;
      }
    }
  }
  .hover\\:underline\\! {
    &:hover {
      @media (hover: hover) {
        text-decoration-line: underline !important;
      }
    }
  }
  .hover\\:opacity-100 {
    &:hover {
      @media (hover: hover) {
        opacity: 100%;
      }
    }
  }
  .hover\\:shadow-md\\/50 {
    &:hover {
      @media (hover: hover) {
        --tw-shadow-alpha: 50%;
        --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, oklab(from rgb(0 0 0 / 0.1) l a b / 50%)), 0 2px 4px -2px var(--tw-shadow-color, oklab(from rgb(0 0 0 / 0.1) l a b / 50%));
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      }
    }
  }
  .hover\\:shadow {
    &:hover {
      @media (hover: hover) {
        --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      }
    }
  }
  .hover\\:shadow-md {
    &:hover {
      @media (hover: hover) {
        --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 2px 4px -2px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      }
    }
  }
  .hover\\:shadow-sm {
    &:hover {
      @media (hover: hover) {
        --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
        box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
      }
    }
  }
  .hover\\:outline-1 {
    &:hover {
      @media (hover: hover) {
        outline-style: var(--tw-outline-style);
        outline-width: 1px;
      }
    }
  }
  .hover\\:outline-2 {
    &:hover {
      @media (hover: hover) {
        outline-style: var(--tw-outline-style);
        outline-width: 2px;
      }
    }
  }
  .hover\\:outline-gray-400 {
    &:hover {
      @media (hover: hover) {
        outline-color: var(--color-gray-400);
      }
    }
  }
  .hover\\:outline-green-600 {
    &:hover {
      @media (hover: hover) {
        outline-color: var(--color-green-600);
      }
    }
  }
  .not-last\\:hover\\:underline {
    &:not(*:last-child) {
      &:hover {
        @media (hover: hover) {
          text-decoration-line: underline;
        }
      }
    }
  }
  .focus\\:text-blue-700\\! {
    &:focus {
      color: var(--color-blue-700) !important;
    }
  }
  .focus\\:ring-2 {
    &:focus {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus\\:ring-blue-100 {
    &:focus {
      --tw-ring-color: var(--color-blue-100);
    }
  }
  .focus\\:outline-0\\! {
    &:focus {
      outline-style: var(--tw-outline-style) !important;
      outline-width: 0px !important;
    }
  }
  .active\\:scale-98 {
    &:active {
      --tw-scale-x: 98%;
      --tw-scale-y: 98%;
      --tw-scale-z: 98%;
      scale: var(--tw-scale-x) var(--tw-scale-y);
    }
  }
  .sm\\:col-span-2 {
    @media (width >= 40rem) {
      grid-column: span 2 / span 2;
    }
  }
  .sm\\:grid-cols-2 {
    @media (width >= 40rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  .md\\:col-\\[1\\/span_2\\] {
    @media (width >= 48rem) {
      grid-column: 1/span 2;
    }
  }
  .md\\:col-span-1 {
    @media (width >= 48rem) {
      grid-column: span 1 / span 1;
    }
  }
  .md\\:col-span-2 {
    @media (width >= 48rem) {
      grid-column: span 2 / span 2;
    }
  }
  .md\\:col-span-3 {
    @media (width >= 48rem) {
      grid-column: span 3 / span 3;
    }
  }
  .md\\:col-span-full {
    @media (width >= 48rem) {
      grid-column: 1 / -1;
    }
  }
  .md\\:mb-0 {
    @media (width >= 48rem) {
      margin-bottom: calc(var(--spacing) * 0);
    }
  }
  .md\\:block\\! {
    @media (width >= 48rem) {
      display: block !important;
    }
  }
  .md\\:grid {
    @media (width >= 48rem) {
      display: grid;
    }
  }
  .md\\:grid\\! {
    @media (width >= 48rem) {
      display: grid !important;
    }
  }
  .md\\:hidden {
    @media (width >= 48rem) {
      display: none;
    }
  }
  .md\\:w-3\\/5 {
    @media (width >= 48rem) {
      width: calc(3 / 5 * 100%);
    }
  }
  .md\\:w-auto {
    @media (width >= 48rem) {
      width: auto;
    }
  }
  .md\\:grid-cols-2 {
    @media (width >= 48rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  .md\\:grid-cols-3 {
    @media (width >= 48rem) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
  .md\\:grid-cols-12 {
    @media (width >= 48rem) {
      grid-template-columns: repeat(12, minmax(0, 1fr));
    }
  }
  .md\\:grid-cols-\\[250px_1fr\\] {
    @media (width >= 48rem) {
      grid-template-columns: 250px 1fr;
    }
  }
  .md\\:grid-cols-\\[300px_1fr\\] {
    @media (width >= 48rem) {
      grid-template-columns: 300px 1fr;
    }
  }
  .md\\:grid-cols-\\[repeat\\(auto-fill\\,minmax\\(240px\\,1fr\\)\\)\\] {
    @media (width >= 48rem) {
      grid-template-columns: repeat(auto-fill,minmax(240px,1fr));
    }
  }
  .md\\:grid-cols-\\[repeat\\(auto-fill\\,minmax\\(280px\\,1fr\\)\\)\\] {
    @media (width >= 48rem) {
      grid-template-columns: repeat(auto-fill,minmax(280px,1fr));
    }
  }
  .md\\:grid-cols-subgrid {
    @media (width >= 48rem) {
      grid-template-columns: subgrid;
    }
  }
  .md\\:flex-row {
    @media (width >= 48rem) {
      flex-direction: row;
    }
  }
  .md\\:items-center {
    @media (width >= 48rem) {
      align-items: center;
    }
  }
  .md\\:items-start {
    @media (width >= 48rem) {
      align-items: flex-start;
    }
  }
  .md\\:justify-between {
    @media (width >= 48rem) {
      justify-content: space-between;
    }
  }
  .md\\:justify-center {
    @media (width >= 48rem) {
      justify-content: center;
    }
  }
  .md\\:justify-end {
    @media (width >= 48rem) {
      justify-content: flex-end;
    }
  }
  .md\\:justify-start {
    @media (width >= 48rem) {
      justify-content: flex-start;
    }
  }
  .md\\:gap-x-3 {
    @media (width >= 48rem) {
      column-gap: calc(var(--spacing) * 3);
    }
  }
  .md\\:gap-x-4 {
    @media (width >= 48rem) {
      column-gap: calc(var(--spacing) * 4);
    }
  }
  .md\\:gap-x-8 {
    @media (width >= 48rem) {
      column-gap: calc(var(--spacing) * 8);
    }
  }
  .md\\:overflow-hidden {
    @media (width >= 48rem) {
      overflow: hidden;
    }
  }
  .md\\:rounded-none {
    @media (width >= 48rem) {
      border-radius: 0;
    }
  }
  .md\\:border-t-0 {
    @media (width >= 48rem) {
      border-top-style: var(--tw-border-style);
      border-top-width: 0px;
    }
  }
  .md\\:border-r {
    @media (width >= 48rem) {
      border-right-style: var(--tw-border-style);
      border-right-width: 1px;
    }
  }
  .md\\:border-b {
    @media (width >= 48rem) {
      border-bottom-style: var(--tw-border-style);
      border-bottom-width: 1px;
    }
  }
  .md\\:bg-transparent {
    @media (width >= 48rem) {
      background-color: transparent;
    }
  }
  .md\\:p-0 {
    @media (width >= 48rem) {
      padding: calc(var(--spacing) * 0);
    }
  }
  .md\\:px-0 {
    @media (width >= 48rem) {
      padding-inline: calc(var(--spacing) * 0);
    }
  }
  .md\\:px-2 {
    @media (width >= 48rem) {
      padding-inline: calc(var(--spacing) * 2);
    }
  }
  .md\\:pb-0 {
    @media (width >= 48rem) {
      padding-bottom: calc(var(--spacing) * 0);
    }
  }
  .md\\:pb-2 {
    @media (width >= 48rem) {
      padding-bottom: calc(var(--spacing) * 2);
    }
  }
  .md\\:text-center {
    @media (width >= 48rem) {
      text-align: center;
    }
  }
  .md\\:text-sm {
    @media (width >= 48rem) {
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
    }
  }
  .md\\:text-xs {
    @media (width >= 48rem) {
      font-size: var(--text-xs);
      line-height: var(--tw-leading, var(--text-xs--line-height));
    }
  }
  .md\\:text-black {
    @media (width >= 48rem) {
      color: var(--color-black);
    }
  }
  .md\\:not-italic {
    @media (width >= 48rem) {
      font-style: normal;
    }
  }
  .md\\:opacity-0 {
    @media (width >= 48rem) {
      opacity: 0%;
    }
  }
  .md\\:shadow-none {
    @media (width >= 48rem) {
      --tw-shadow: 0 0 #0000;
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .md\\:group-hover\\/search-icon-action\\:opacity-50 {
    @media (width >= 48rem) {
      &:is(:where(.group\\/search-icon-action):hover *) {
        @media (hover: hover) {
          opacity: 50%;
        }
      }
    }
  }
  .lg\\:col-span-1 {
    @media (width >= 64rem) {
      grid-column: span 1 / span 1;
    }
  }
  .lg\\:col-span-2 {
    @media (width >= 64rem) {
      grid-column: span 2 / span 2;
    }
  }
  .lg\\:col-span-3 {
    @media (width >= 64rem) {
      grid-column: span 3 / span 3;
    }
  }
  .lg\\:col-start-1 {
    @media (width >= 64rem) {
      grid-column-start: 1;
    }
  }
  .lg\\:col-start-2 {
    @media (width >= 64rem) {
      grid-column-start: 2;
    }
  }
  .lg\\:mt-0 {
    @media (width >= 64rem) {
      margin-top: calc(var(--spacing) * 0);
    }
  }
  .lg\\:flex\\! {
    @media (width >= 64rem) {
      display: flex !important;
    }
  }
  .lg\\:hidden {
    @media (width >= 64rem) {
      display: none;
    }
  }
  .lg\\:h-\\[70px\\] {
    @media (width >= 64rem) {
      height: 70px;
    }
  }
  .lg\\:w-md {
    @media (width >= 64rem) {
      width: var(--container-md);
    }
  }
  .lg\\:grow {
    @media (width >= 64rem) {
      flex-grow: 1;
    }
  }
  .lg\\:grid-cols-2 {
    @media (width >= 64rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  .lg\\:grid-cols-3 {
    @media (width >= 64rem) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
  .lg\\:grid-cols-4 {
    @media (width >= 64rem) {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
  }
  .lg\\:grid-cols-\\[200px_1fr\\] {
    @media (width >= 64rem) {
      grid-template-columns: 200px 1fr;
    }
  }
  .lg\\:grid-cols-\\[repeat\\(auto-fill\\,minmax\\(200px\\,1fr\\)\\)\\] {
    @media (width >= 64rem) {
      grid-template-columns: repeat(auto-fill,minmax(200px,1fr));
    }
  }
  .lg\\:flex-row {
    @media (width >= 64rem) {
      flex-direction: row;
    }
  }
  .lg\\:justify-center {
    @media (width >= 64rem) {
      justify-content: center;
    }
  }
  .lg\\:gap-x-2 {
    @media (width >= 64rem) {
      column-gap: calc(var(--spacing) * 2);
    }
  }
  .lg\\:gap-x-10 {
    @media (width >= 64rem) {
      column-gap: calc(var(--spacing) * 10);
    }
  }
  .lg\\:gap-y-0 {
    @media (width >= 64rem) {
      row-gap: calc(var(--spacing) * 0);
    }
  }
  .lg\\:pr-5 {
    @media (width >= 64rem) {
      padding-right: calc(var(--spacing) * 5);
    }
  }
  .xl\\:grid-cols-2 {
    @media (width >= 80rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  .xl\\:grid-cols-4 {
    @media (width >= 80rem) {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
  }
  .xl\\:grid-cols-5 {
    @media (width >= 80rem) {
      grid-template-columns: repeat(5, minmax(0, 1fr));
    }
  }
  .\\32 xl\\:grid-cols-6 {
    @media (width >= 96rem) {
      grid-template-columns: repeat(6, minmax(0, 1fr));
    }
  }
  .\\[\\&-\\:\\:-webkit-scrollbar\\]\\:hidden {
    &-::-webkit-scrollbar {
      display: none;
    }
  }
  .\\[\\&\\>div\\]\\:h-full {
    &>div {
      height: 100%;
    }
  }
  .\\[\\&\\>div\\]\\:items-center {
    &>div {
      align-items: center;
    }
  }
}
.ui-select-highlight {
  font-weight: bold;
}
.ui-select-offscreen {
  clip: rect(0 0 0 0) !important;
  width: 1px !important;
  height: 1px !important;
  border: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: hidden !important;
  position: absolute !important;
  outline: 0 !important;
  left: 0px !important;
  top: 0px !important;
}
.ui-select-choices-row:hover {
  background-color: #f5f5f5;
}
.ng-dirty.ng-invalid > a.select2-choice {
  border-color: #D44950;
}
.select2-result-single {
  padding-left: 0;
}
.select2-locked > .select2-search-choice-close {
  display: none;
}
.select-locked > .ui-select-match-close {
  display: none;
}
body > .select2-container.open {
  z-index: 9999;
}
.ui-select-container[theme="select2"].direction-up .ui-select-match,
.ui-select-container.select2.direction-up .ui-select-match {
  border-radius: 4px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.ui-select-container[theme="select2"].direction-up .ui-select-dropdown,
.ui-select-container.select2.direction-up .ui-select-dropdown {
  border-radius: 4px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-width: 1px;
  border-top-style: solid;
  box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.25);
  margin-top: -4px;
}
.ui-select-container[theme="select2"].direction-up .ui-select-dropdown .select2-search,
.ui-select-container.select2.direction-up .ui-select-dropdown .select2-search {
  margin-top: 4px;
}
.ui-select-container[theme="select2"].direction-up.select2-dropdown-open .ui-select-match,
.ui-select-container.select2.direction-up.select2-dropdown-open .ui-select-match {
  border-bottom-color: #5897fb;
}
.ui-select-container[theme="select2"] .ui-select-dropdown .ui-select-search-hidden,
.ui-select-container[theme="select2"] .ui-select-dropdown .ui-select-search-hidden input {
  opacity: 0;
  height: 0;
  min-height: 0;
  padding: 0;
  margin: 0;
  border: 0;
}
.selectize-input.selectize-focus {
  border-color: #007FBB !important;
}
.selectize-control.single > .selectize-input > input {
  width: 100%;
}
.selectize-control.multi > .selectize-input > input {
  margin: 0 !important;
}
.selectize-control > .selectize-dropdown {
  width: 100%;
}
.ng-dirty.ng-invalid > div.selectize-input {
  border-color: #D44950;
}
.ui-select-container[theme="selectize"].direction-up .ui-select-dropdown {
  box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.25);
  margin-top: -2px;
}
.ui-select-container[theme="selectize"] input.ui-select-search-hidden {
  opacity: 0;
  height: 0;
  min-height: 0;
  padding: 0;
  margin: 0;
  border: 0;
  width: 0;
}
.btn-default-focus {
  color: #333;
  background-color: #EBEBEB;
  border-color: #ADADAD;
  text-decoration: none;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
}
.ui-select-bootstrap .ui-select-toggle {
  position: relative;
}
.ui-select-bootstrap .ui-select-toggle > .caret {
  position: absolute;
  height: 10px;
  top: 50%;
  right: 10px;
  margin-top: -2px;
}
.input-group > .ui-select-bootstrap.dropdown {
  position: static;
}
.input-group > .ui-select-bootstrap > input.ui-select-search.form-control {
  border-radius: 4px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > .ui-select-bootstrap > input.ui-select-search.form-control.direction-up {
  border-radius: 4px !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.ui-select-bootstrap .ui-select-search-hidden {
  opacity: 0;
  height: 0;
  min-height: 0;
  padding: 0;
  margin: 0;
  border: 0;
}
.ui-select-bootstrap > .ui-select-match > .btn {
  text-align: left !important;
}
.ui-select-bootstrap > .ui-select-match > .caret {
  position: absolute;
  top: 45%;
  right: 15px;
}
.ui-select-bootstrap > .ui-select-choices ,.ui-select-bootstrap > .ui-select-no-choice {
  width: 100%;
  height: auto;
  max-height: 200px;
  overflow-x: hidden;
  margin-top: -1px;
}
body > .ui-select-bootstrap.open {
  z-index: 1000;
}
.ui-select-multiple.ui-select-bootstrap {
  height: auto;
  padding: 3px 3px 0 3px;
}
.ui-select-multiple.ui-select-bootstrap input.ui-select-search {
  background-color: transparent !important;
  border: none;
  outline: none;
  height: 1.666666em;
  margin-bottom: 3px;
}
.ui-select-multiple.ui-select-bootstrap .ui-select-match .close {
  font-size: 1.6em;
  line-height: 0.75;
}
.ui-select-multiple.ui-select-bootstrap .ui-select-match-item {
  outline: 0;
  margin: 0 3px 3px 0;
}
.ui-select-multiple .ui-select-match-item {
  position: relative;
}
.ui-select-multiple .ui-select-match-item.dropping .ui-select-match-close {
  pointer-events: none;
}
.ui-select-multiple:hover .ui-select-match-item.dropping-before:before {
  content: "";
  position: absolute;
  top: 0;
  right: 100%;
  height: 100%;
  margin-right: 2px;
  border-left: 1px solid #428bca;
}
.ui-select-multiple:hover .ui-select-match-item.dropping-after:after {
  content: "";
  position: absolute;
  top: 0;
  left: 100%;
  height: 100%;
  margin-left: 2px;
  border-right: 1px solid #428bca;
}
.ui-select-bootstrap .ui-select-choices-row>span {
  cursor: pointer;
  display: block;
  padding: 3px 20px;
  clear: both;
  font-weight: 400;
  line-height: 1.42857143;
  color: #333;
  white-space: nowrap;
}
.ui-select-bootstrap .ui-select-choices-row>span:hover, .ui-select-bootstrap .ui-select-choices-row>span:focus {
  text-decoration: none;
  color: #262626;
  background-color: #f5f5f5;
}
.ui-select-bootstrap .ui-select-choices-row.active>span {
  color: #fff;
  text-decoration: none;
  outline: 0;
  background-color: #428bca;
}
.ui-select-bootstrap .ui-select-choices-row.disabled>span,
.ui-select-bootstrap .ui-select-choices-row.active.disabled>span {
  color: #777;
  cursor: not-allowed;
  background-color: #fff;
}
.ui-select-match.ng-hide-add,
.ui-select-search.ng-hide-add {
  display: none !important;
}
.ui-select-bootstrap.ng-dirty.ng-invalid > button.btn.ui-select-match {
  border-color: #D44950;
}
.ui-select-container[theme="bootstrap"].direction-up .ui-select-dropdown {
  box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.25);
}
.ui-select-bootstrap .ui-select-match-text {
  width: 100%;
  padding-right: 1em;
}
.ui-select-bootstrap .ui-select-match-text span {
  display: inline-block;
  width: 100%;
  overflow: hidden;
}
.ui-select-bootstrap .ui-select-toggle > a.btn {
  position: absolute;
  height: 10px;
  right: 10px;
  margin-top: -2px;
}
.ui-select-refreshing.glyphicon {
  position: absolute;
  right: 0;
  padding: 8px 27px;
}
@-webkit-keyframes ui-select-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
@keyframes ui-select-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
.ui-select-spin {
  -webkit-animation: ui-select-spin 2s infinite linear;
  animation: ui-select-spin 2s infinite linear;
}
.ui-select-refreshing.ng-animate {
  -webkit-animation: none 0s;
}
@layer base {
  *, ::before, ::after {
    box-sizing: border-box;
  }
  img {
    display: inline-block;
    vertical-align: middle;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    background-color: white;
  }
  select, input, textarea, optgroup {
    &:not(.ui-select-container *) {
      border-radius: 0.25rem;
      border-style: var(--tw-border-style);
      border-width: 1px;
      border-color: var(--color-gray-400);
      padding-inline: calc(var(--spacing) * 1);
    }
  }
}
html {
  font-size: 16px;
  height: 100dvh !important;
}
body {
  height: 100dvh !important;
}
#divArea {
  max-height: 100%;
  overflow-x: auto;
  width: 100%;
  font-size: 13px;
  flex-grow: 1;
}
#divAreaModal {
  max-height: 100%;
  overflow: auto;
  width: 100%;
  font-size: 13px;
}
#lock-message-background {
  background-color: white;
  opacity: 0.4;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10001;
  display: none;
}
table > thead > tr > td {
  background-color: #fff;
}
.form-control {
  border-radius: 0;
}
.btn {
  border-radius: var(--radius-sm);
}
.text-info {
  color: grey;
  font-weight: bold;
}
.text-center .day-text-normal {
  color: grey;
  background-color: #ddd;
}
.uib-day button, .uib-month button, .uib-year button {
  border-radius: 0;
  border: solid 1px #ddd;
}
.uib-datepicker .uib-title, .uib-left, .uib-right {
  border-radius: 0 !important;
}
.modal-header {
  padding: 8px 15px;
  color: black;
  background-color: #c9bfb4;
  .modal-title {
    color: #2d7194;
  }
  .fa-times {
    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 1rem;
    cursor: pointer;
  }
}
.modal-header > strong {
  text-transform: uppercase;
}
.modal-header .modal-title {
  display: block;
  padding: 5px 0;
}
.modal-content {
  border-radius: 0;
}
.btn-purple {
  color: grey !important;
  background-color: #fefefe;
  border-color: darkgrey;
}
.btn.btn-secondary {
  border: 1px solid #bfbfbf;
}
.btn-purple:focus,
.btn-purple.focus {
  color: black;
  background-color: #ddd;
  border-color: darkgrey;
}
.btn-purple:hover {
  color: black;
  background-color: #ddd;
  border-color: darkgrey;
}
.btn-purple:active,
.btn-purple.active,
.open > .dropdown-toggle.btn-purple {
  color: black;
  background-color: #ddd;
  border-color: darkgrey;
}
.btn-purple:active:hover,
.btn-purple.active:hover,
.open > .dropdown-toggle.btn-purple:hover,
.btn-purple:active:focus,
.btn-purple.active:focus,
.open > .dropdown-toggle.btn-purple:focus,
.btn-purple:active.focus,
.btn-purple.active.focus,
.open > .dropdown-toggle.btn-purple.focus {
  color: black;
  background-color: #ddd;
  border-color: darkgrey;
}
.btn-purple:active,
.btn-purple.active,
.open > .dropdown-toggle.btn-purple {
  background-image: none;
}
.btn-purple.disabled:hover,
.btn-purple[disabled]:hover,
fieldset[disabled] .btn-purple:hover,
.btn-purple.disabled:focus,
.btn-purple[disabled]:focus,
fieldset[disabled] .btn-purple:focus,
.btn-purple.disabled.focus,
.btn-purple[disabled].focus,
fieldset[disabled] .btn-purple.focus {
  color: black;
  background-color: #ddd;
  border-color: darkgrey;
}
.btn-purple .badge {
  color: black;
  background-color: #ddd;
}
.home > .dropdown {
  cursor: pointer;
  font-size: 14px;
}
.menu {
  position: relative;
}
.menu > .dropdown-menu {
  position: static;
  display: block;
  font-size: 12px;
}
.content-area {
  margin-top: 5px;
}
.nav-tabs.nav-justified > li {
  float: left;
  width: 25% !important;
}
.category-area {
  height: 70.1rem;
  overflow: auto;
  width: 100.2%;
}
.fit-content {
  width: 103%;
}
.document-fields-group {
  outline: 1px solid lightgray;
  margin-bottom: 5px;
}
.document-fields-group .title {
  padding: 5px;
  padding-left: 10px;
  border: none;
  color: black;
  font-size: 12px;
  font-weight: bold;
  background-color: #ddd;
}
.document-fields-group .content {
  background-color: var(--color-white);
  padding: calc(var(--spacing) * 2.5);
}
.text-input {
  border: 1px solid #CCC;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.075) inset;
  padding: 3px;
  min-width: 1rem;
  width: 100%;
  height: 30px;
  color: dimgray;
}
label.input-inline {
  line-height: 30px;
}
label.gray-label {
  background-color: #ddd;
  line-height: 30px;
  padding: 0 8px;
}
.text-input:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6);
}
.text-search {
  border: 1px solid #CCC;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.075) inset;
  padding: 6px;
  min-width: 1rem;
  width: 100%;
  font-weight: 500;
  font-style: italic;
}
.select2-selection {
  border: 1px solid #ccc !important;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.075) inset;
  min-width: 1rem;
  width: 100%;
  font-weight: 500;
  font-style: italic;
  border-radius: 0 !important;
  line-height: inherit;
  height: 32px !important;
}
.select2-container--default .select2-selection--single .select2-selection__rendered {
  line-height: inherit;
  padding: 6px;
}
.panel-default > .panel-heading {
  background: none;
}
.panel-heading.fix-top {
  position: absolute;
  width: 100%;
  top: 0;
}
.panel-heading.fix-top.border-bottom,
.row.border-bottom {
  border-bottom: 1px solid #ddd;
}
.text-input-grid {
  border: none;
}
#category-info > tbody > tr > td {
  border: none;
  padding: 5px !important;
}
.table tr:first-child > th {
  background-color: #ddd !important;
  color: black;
  border: solid 1px darkgrey;
  border-bottom: none;
}
.table tr:last-child > th {
  background-color: #fff;
}
a:not(.dropdown-toggle,.btn) {
  color: grey;
}
table a[href] {
  color: #2d7194;
  text-decoration: underline;
}
.nav > li > a:hover, .nav > li > a:focus {
  color: black;
}
.nav .open > a, .nav .open > a:hover, .nav .open > a:focus {
  border: none;
}
.panel-default, .panel-default > .panel-heading {
  border-radius: 0px;
}
.input-group-addon {
  background-color: #ddd;
  border: solid 1px lightgrey;
  color: black;
  border-radius: 0;
  text-align: left;
}
.footer {
  position: absolute;
  bottom: 10px;
  background-color: #f2e8ec;
  width: 100%;
  height: 4rem;
  color: #e59866;
  text-align: center;
}
.common-content {
  background-color: #fafafa;
  position: absolute;
  height: 100%;
}
.pagination > .active > a, .pagination > .active > a:focus, .pagination > .active > a:hover, .pagination > .active > span, .pagination > .active > span:focus, .pagination > .active > span:hover {
  background-color: #ddd;
  border-color: lightgrey;
  color: black;
}
.pagination > li > a, .pagination > li > span {
  color: black;
}
.nav-pills > li.active > a, .nav-pills > li.active > a:focus, .nav-pills > li.active > a:hover {
  background-color: #ddd;
  color: black;
  line-height: 15px;
}
.nav-pills > li > a {
  border-radius: 0;
  cursor: pointer;
}
.dropup .dropdown-menu, .navbar-fixed-bottom .dropdown .dropdown-menu {
  margin-bottom: -25px;
}
.mascot-brand {
  float: right;
}
.customer-address {
  background-color: #fafafa;
  font-weight: 600;
  line-height: 20px;
  width: 23%;
  margin: 10px;
}
.total-record {
  font-weight: 600;
}
.caret-order {
  cursor: pointer;
  margin-top: 7px;
  float: right;
}
.up-caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-bottom: 4px solid;
  border-left: 4px solid transparent;
  border-top: 0 dotted;
  border-right: 4px solid transparent;
  content: "";
}
.upload-area {
  line-height: 30px;
  margin-top: 5px;
  width: 98%;
  margin-left: 15px;
  height: 40px;
  border: dotted 1px grey;
}
.text-focus {
  border: solid 1px #ddd;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 1);
}
.header-cursor {
  cursor: pointer;
}
.panel-title {
  font-size: 14px;
}
.copy-text {
  color: white;
  font-size: 0.2px;
}
em::selection {
  color: white !important;
  background: none;
}
.fake-span {
  cursor: pointer;
  font-weight: 400;
  font-size: 12px;
}
.pending-popover {
  display: none;
}
.table .table-rule > tbody > tr > td {
  border-top: none;
}
.page-heading {
  margin-bottom: calc(var(--spacing) * 2);
  &.no-margin {
    margin: 0;
  }
  .page-title {
    margin-block: calc(var(--spacing) * 2);
    display: grid;
    cursor: default;
    grid-template-columns: auto 1fr;
    gap: calc(var(--spacing) * 2);
    grid-template-areas: "title controls";
    h3 {
      margin: 0;
      flex: 0;
      grid-area: title;
      font-size: 1.8em;
      font-weight: normal;
      font-family: Roboto;
    }
    .controls {
      display: flex;
      justify-content: flex-end;
      gap: calc(var(--spacing) * 2);
      grid-area: controls;
    }
  }
}
.page-body {
  margin-top: 160px;
}
.page-paging {
  position: fixed;
  top: 95px;
  left: 15px;
  right: 15px;
  padding-bottom: 10px;
  background-color: white;
}
.dropdown dd, .dropdown dt {
  margin: 0px;
  padding: 0px;
}
.dropdown ul {
  margin: -1px 0 0 0;
}
.dropdown dd {
  position: relative;
}
.dropdown a,
.dropdown a:visited {
  text-decoration: none;
  outline: none;
}
.dropdown dt a {
  display: block;
  height: 30px;
  line-height: 24px;
  overflow: hidden;
  border: 0;
  width: 235px;
}
.dropdown dt a span, .multiSel span {
  cursor: pointer;
  display: inline-block;
  padding: 0 3px 2px 0;
}
.dropdown dd ul {
  background-color: white;
  border: double 1px gray;
  color: black;
  display: none;
  left: 0px;
  padding: 2px 15px 2px 5px;
  position: absolute;
  top: 2px;
  width: 99%;
  list-style: none;
  height: 100px;
  overflow: auto;
  z-index: 999;
}
.dropdown span.value {
  display: none;
}
.dropdown dd ul li a {
  padding: 5px;
  display: block;
}
.dropdown dd ul li a:hover {
  background-color: #fff;
}
.document-fields-group table td {
  padding: 5px !important;
}
.cart-footer {
  font-size: 12px;
}
.cart-footer table.basket-footer-values {
  width: 100%;
}
.cart-footer .basket-footer-values tr > td:first-child {
  min-width: 150px;
  padding: 3px 15px;
  font-weight: 300;
  line-height: 1.4;
}
.cart-footer .basket-footer-values tr > td:last-child {
  min-width: 120px;
  padding-right: 5px;
  text-align: right;
  font-weight: 600;
  color: #777;
}
.cart-footer .basket-footer-values tr.noted {
  background-color: yellow !important;
}
.cart-footer .basket-footer-values tr.sub-noted {
  background-color: yellow !important;
}
.validation-failed {
  border: 1px dashed #eb340a !important;
  background: #faebe7 !important;
}
.validation-hide {
  display: none;
}
.validation-advice {
  clear: both;
  min-height: 13px;
  margin: 3px 0 0;
  font-size: 11px;
  font-weight: bold;
  line-height: 13px;
  color: #eb340a;
  position: relative;
  top: 100%;
  text-align: left;
}
.has-error input {
  border-color: #eb340a !important;
}
.has-error .control-label, .has-error .error-message {
  color: #eb340a;
}
.error-message {
  display: none;
}
.has-error .error-message {
  display: block;
}
.modal-dialog {
  &:has(.sm-modal) {
    width: 90dvw;
    max-width: 480px;
  }
  &:has(.md-modal) {
    width: 90dvw;
    max-width: 640px;
  }
  &:has(.lg-modal) {
    width: 90dvw;
    max-width: 960px;
  }
  &:has(.xl-modal) {
    width: 90dvw;
    max-width: 1280px;
  }
  &:has(.xxl-modal) {
    width: 90dvw;
    max-width: 1980px;
  }
  .modal-header .icon-close {
    position: absolute;
    top: calc(var(--spacing) * 0);
    right: calc(var(--spacing) * 0);
    margin: calc(var(--spacing) * 2);
    cursor: pointer;
    &:hover {
      @media (hover: hover) {
        color: var(--color-red-500);
      }
    }
  }
}
.customer-rule-dialog > .modal-dialog {
  width: 50%;
  margin-top: 100px;
}
.add-rule-dialog > .modal-dialog {
  width: 90%;
  margin-top: 100px;
}
.edit-rule-dialog > .modal-dialog {
  width: 90%;
  margin-top: 50px;
}
.table-no-border > tbody > tr > td {
  border: none !important;
}
.fixed-header {
  border: none;
  top: 35px;
  position: fixed;
  z-index: 1020;
  background-color: #FFF;
  right: 15px;
  left: 15px;
}
.free-content {
  position: absolute;
  top: 75px;
  margin-right: 15px;
}
table.product-size-table tr td:first-child {
  width: 20%;
}
table.product-size-table tr td:last-child {
  width: 30%;
}
table.product-size-table tr td {
  border-top: none !important;
}
.btn-focus {
  color: #333;
  background-color: #e6e6e6;
}
td {
  vertical-align: middle !important;
}
.line-focus {
  background-color: #fafafa;
}
.multiSelectCert > ul > li:hover {
  background-color: #ddd;
  cursor: pointer;
}
.invoice-header {
  margin-top: 25px;
}
.invoice-title {
  display: inline-block;
}
.invoice-section-header {
  font-weight: bold;
  padding: 8px;
  background-color: lightGrey;
  margin-top: 5px;
}
.invoice-section-body {
  border: solid 1px #dddddd;
  padding: 10px;
}
.invoice-section-body table {
  width: 100%;
}
.invoice-section-body table td {
  padding: 1px 0;
}
.invoice-section-body table.two-col td:first-child {
  width: 30%;
}
.invoice-section-body table.two-col td:last-child {
  width: 70%;
}
.invoice-section-body table.item-invoiced td:not(:first-child), .invoice-section-body table.item-invoiced th:not(:first-child) {
  text-align: right;
}
.email-type-list {
  list-style: none;
  padding: 0;
}
.email-type-list > li {
  cursor: pointer;
  padding: 3px;
}
.email-type-list > li > a:hover {
  text-decoration: none;
  color: black;
}
.email-placeholder-code {
  padding: 0;
}
.email-placeholder-code > li {
  padding: 3px;
}
.email-placeholder-code-info {
  list-style: none;
  padding: 10px;
}
.email-placeholder-code-info > li {
  padding-left: 25px;
  padding-bottom: 3px;
}
.dealer-group {
  list-style: none;
  padding: 0;
}
.dealer-group > li {
  padding-bottom: 10px;
}
.dealer-group > li:hover {
  background-color: #fafafa;
}
.filter-group {
  margin: 5px;
  width: calc(100% - 10px);
}
.filter-group > .input-group-addon {
  text-align: left;
  width: 110px;
}
.dealer-detail {
  border: solid 1px #ddd;
}
.dealer-detail > li > a > i {
  float: right;
  font-size: 15px;
}
.dealer-detail > li > a > i:hover {
  color: grey;
}
.return-accept-box {
  border: solid 1px green;
  background-color: yellow;
  height: 22px;
  float: left;
  margin-right: 5px;
  margin-bottom: 3px;
  padding: 2px;
}
a.help {
  display: inline-block;
  line-height: 20px;
  padding: 0 5px;
  color: #000;
}
.top-200 {
  margin-top: 200px;
}
.ep-header-select-box {
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
  height: 30px;
}
.small-multi-select {
  height: clamp(200px, 50dvh, 80dvh);
  overflow-y: auto;
}
.small-multi-select li {
  list-style: none;
  padding: 6px 12px;
  font-size: 12px;
  border-bottom: 1px solid #dddddd;
}
.small-multi-select li:hover {
  background-color: #fefefe;
}
.customer-group-dialog .modal-dialog {
  width: 60%;
  top: 100px;
}
.dealer-customer-group-dialog .modal-dialog {
  width: 90%;
  top: 100px;
}
.select-image-dialog .modal-dialog {
  width: 90%;
  top: 10px;
}
.promotion-index-dialog .modal-dialog {
  width: 800px;
  top: 10px;
}
.color-item.active {
  .color-image {
    --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 2px 4px -2px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    --tw-shadow-color: currentcolor;
    @supports (color: color-mix(in lab, red, red)) {
      --tw-shadow-color: color-mix(in oklab, currentcolor var(--tw-shadow-alpha), transparent);
    }
    outline-style: var(--tw-outline-style);
    outline-width: 3px;
    outline-color: var(--color-gray-500);
  }
  .color-name {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
}
.filter-super-class {
  font-weight: bold;
  color: red;
}
.tooltip-holder {
  position: relative;
  .tooltip-text {
    bottom: 100%;
    left: calc(1 / 2 * 100%);
    width: max-content;
    --tw-translate-x: calc(calc(1 / 2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
    border-radius: var(--radius-lg);
    background-color: color-mix(in srgb, oklch(37.3% 0.034 259.733) 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-gray-700) 80%, transparent);
    }
    padding-inline: calc(var(--spacing) * 2);
    padding-block: calc(var(--spacing) * 1);
    text-align: center;
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    color: var(--color-white);
    visibility: hidden;
    position: absolute;
    z-index: 1;
  }
  &:hover .tooltip-text {
    visibility: visible;
  }
}
#divInstore {
  margin: 5% 10%;
}
@media screen and (max-width: 768px) {
  #divInstore {
    margin: 3% 2%;
  }
  #divInstore .display {
    display: none;
  }
}
.loading {
  border: 16px solid #f3f3f3;
  border-top: 16px solid #3498db;
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.conflict-rule-dialog > .modal-dialog {
  margin-top: 20%;
}
.refund-order-dialog > .modal-dialog {
  width: 60%;
  margin-top: 50px;
}
.custom-modal-60 .modal-dialog {
  width: 60% !important;
}
.custom-modal-70 .modal-dialog {
  width: 70% !important;
}
.custom-modal-80 .modal-dialog {
  width: 80% !important;
}
.custom-modal-90 .modal-dialog {
  width: 90% !important;
}
table thead tr th {
  overflow: unset !important;
}
td, th {
  overflow: unset !important;
}
.ui-dialog {
  z-index: 9999 !important;
}
.text-red {
  color: #d0033f !important;
}
#tblList .col-key {
  max-width: 600px;
  text-overflow: ellipsis;
  overflow: hidden !important;
  white-space: nowrap;
}
.navbar {
  margin: 0;
  flex: 0 0 auto;
  z-index: 1030;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  border: 0;
  border-radius: 0;
}
.navbar #logo.navbar-header {
  height: 60px;
  display: flex;
  align-items: end;
}
.navbar #logo.navbar-header .navbar-brand {
  height: 100%;
  color: white !important;
  margin: unset !important;
  padding: 0;
  background-position: center;
}
*::-webkit-scrollbar {
  width: 8px;
}
*::-webkit-scrollbar-thumb {
  background: #E0E0E0;
  border-radius: 4px;
}
*::-webkit-scrollbar-thumb:hover {
  background: #bbb;
}
main {
  padding-right: calc(var(--spacing) * 2);
  padding-left: calc(var(--spacing) * 2);
  display: flex;
  overflow-y: auto;
  --bs-gutter-x: 1.5rem;
  background-color: #fefefe;
  &:has(.page-container) {
    padding-right: calc(var(--spacing) * 0);
  }
  > div {
    flex-grow: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .page-box {
    display: flex;
    height: 100%;
    flex-direction: column;
    overflow: hidden;
    .page-heading {
      flex: 0 0 auto;
    }
    .layout-wrapper {
      flex: 1;
      display: flex;
      overflow: hidden;
      margin: 0;
      .content-scrollable {
        height: 100%;
        padding-bottom: 15px;
        overflow-y: auto;
      }
      .sidebar-fixed {
        height: 100%;
      }
    }
  }
}
.modal-body {
  max-height: 75vh;
  overflow-x: hidden;
  overflow-y: auto;
}
.text-input:not(textarea) {
  max-width: 45ch;
  &.text-input-xs {
    max-width: 15ch;
  }
  &.text-input-sm {
    max-width: 30ch;
  }
  &.text-input-md {
    max-width: 45ch;
  }
  &.text-input-lg {
    max-width: 100ch;
  }
  &.text-input-full {
    max-width: unset !important;
  }
}
#distributor-info {
  tr:has(td:nth-child(2)) td:nth-child(1) {
    width: 35ch;
  }
}
.break-word {
  overflow-wrap: break-word;
}
.grid-cols-subgrid {
  grid-template-columns: subgrid;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.cursor-pointer:hover {
  cursor: pointer;
}
.list-style-none {
  list-style: none;
}
.text-gray {
  color: grey;
}
.text-balance {
  text-wrap: balance;
}
.d-grid {
  display: grid;
}
.d-flex {
  display: flex;
}
.d-block {
  display: block;
}
.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
  > * {
    box-sizing: border-box;
    flex-shrink: 0;
    max-width: 100%;
    padding-right: calc(var(--bs-gutter-x) * 0.5);
    padding-left: calc(var(--bs-gutter-x) * 0.5);
    margin-top: var(--bs-gutter-y);
  }
  > *:not([class*="col-"]) {
    width: 100%;
  }
  .col {
    flex: 1 0 0;
  }
  .col-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-1 {
    margin-left: 8.33333333%;
  }
  .offset-2 {
    margin-left: 16.66666667%;
  }
  .offset-3 {
    margin-left: 25%;
  }
  .offset-4 {
    margin-left: 33.33333333%;
  }
  .offset-5 {
    margin-left: 41.66666667%;
  }
  .offset-6 {
    margin-left: 50%;
  }
  .offset-7 {
    margin-left: 58.33333333%;
  }
  .offset-8 {
    margin-left: 66.66666667%;
  }
  .offset-9 {
    margin-left: 75%;
  }
  .offset-10 {
    margin-left: 83.33333333%;
  }
  .offset-11 {
    margin-left: 91.66666667%;
  }
}
.flex-grow-1 {
  flex-grow: 1;
}
.cke_chrome {
  height: 100% !important;
  display: flex !important;
  flex-direction: column;
  .cke_inner {
    display: flex !important;
    flex-direction: column;
    flex: 1;
  }
  .cke_contents {
    flex: 1 !important;
    height: auto !important;
  }
}
[id^=nspopover-] {
  z-index: 2000 !important;
}
.ns-popover-tooltip-theme {
  .ns-popover-tooltip {
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #d2d2d2;
    border-radius: 3px;
    max-width: 20rem;
    margin: 10px;
    padding: .5625rem .875rem;
    font-size: 1.2rem;
    -webkit-box-shadow: 0 .3125rem .625rem #0003;
    -moz-box-shadow: 0 .3125rem .625rem #0003;
    box-shadow: 0 .3125rem .625rem #0003;
  }
}
.ns-popover-dropdown-select {
  border-radius: var(--radius-xl);
  border-style: var(--tw-border-style);
  border-width: 1px;
  border-color: var(--color-gray-200);
  background-color: var(--color-white);
  background-clip: padding-box;
  padding: 5px 0;
  --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
  box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}
table.sticky-header {
  border-collapse: separate;
  border-spacing: 0;
  thead {
    tr:nth-child(1) th {
      position: sticky;
      top: 0;
      z-index: 11;
      background: #fff;
    }
    tr:nth-child(2) th {
      position: sticky;
      top: 40px;
      z-index: 10;
      background: #fff;
    }
  }
}
ng-container.ng-scope {
  all: unset;
  display: contents;
}
.nav.nav-stacked li {
  display: flex;
  align-items: center;
  column-gap: calc(var(--spacing) * 1);
  padding: 10px 15px;
  &:hover {
    cursor: pointer;
    background-color: var(--color-gray-100);
  }
  .fa {
    margin-inline-start: auto;
    &:hover {
      @media (hover: hover) {
        color: var(--color-black);
      }
    }
    &:hover {
      @media (hover: hover) {
        outline-style: var(--tw-outline-style);
        outline-width: 1px;
      }
    }
    &:hover {
      @media (hover: hover) {
        outline-color: var(--color-base-300);
      }
    }
    &:hover {
      @media (hover: hover) {
        margin-right: calc(var(--spacing) * -1);
      }
    }
    &:hover {
      @media (hover: hover) {
        border-radius: 0.25rem;
      }
    }
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-white);
      }
    }
    &:hover {
      @media (hover: hover) {
        padding-inline: calc(var(--spacing) * 1);
      }
    }
  }
  &.active {
    background-color: var(--color-gray-200);
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    color: var(--color-mascot-black);
    a {
      color: var(--color-mascot-black);
      display: contents;
    }
  }
  a {
    display: contents;
  }
}
.dropdown:hover > .dropdown-menu {
  display: block;
}
.category-tree, [data-angular-treeview] {
  ul {
    position: relative;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      left: 10px;
      border-left: 1px dashed #ccc;
    }
    li {
      padding-left: 20px;
      &::before {
        content: "";
        position: absolute;
        top: 15px;
        left: 10px;
        width: 10px;
        border-top: 1px dashed #ccc;
      }
    }
  }
}
.drag-ghost {
  opacity: 0.4;
  background: #e5e7eb;
  border: 1px dashed #9ca3af;
}
@property --tw-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-z {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-scale-x {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-y {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-z {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-rotate-x {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-y {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-z {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-x {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-y {
  syntax: "*";
  inherits: false;
}
@property --tw-scroll-snap-strictness {
  syntax: "*";
  inherits: false;
  initial-value: proximity;
}
@property --tw-space-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-gradient-position {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-from {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-via {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-to {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-stops {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-via-stops {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-from-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 0%;
}
@property --tw-gradient-via-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 50%;
}
@property --tw-gradient-to-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-tracking {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-outline-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-drop-shadow-size {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-ease {
  syntax: "*";
  inherits: false;
}
@property --tw-text-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-text-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-content {
  syntax: "*";
  initial-value: "";
  inherits: false;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-translate-x: 0;
      --tw-translate-y: 0;
      --tw-translate-z: 0;
      --tw-scale-x: 1;
      --tw-scale-y: 1;
      --tw-scale-z: 1;
      --tw-rotate-x: initial;
      --tw-rotate-y: initial;
      --tw-rotate-z: initial;
      --tw-skew-x: initial;
      --tw-skew-y: initial;
      --tw-scroll-snap-strictness: proximity;
      --tw-space-y-reverse: 0;
      --tw-border-style: solid;
      --tw-gradient-position: initial;
      --tw-gradient-from: #0000;
      --tw-gradient-via: #0000;
      --tw-gradient-to: #0000;
      --tw-gradient-stops: initial;
      --tw-gradient-via-stops: initial;
      --tw-gradient-from-position: 0%;
      --tw-gradient-via-position: 50%;
      --tw-gradient-to-position: 100%;
      --tw-leading: initial;
      --tw-font-weight: initial;
      --tw-tracking: initial;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-outline-style: solid;
      --tw-blur: initial;
      --tw-brightness: initial;
      --tw-contrast: initial;
      --tw-grayscale: initial;
      --tw-hue-rotate: initial;
      --tw-invert: initial;
      --tw-opacity: initial;
      --tw-saturate: initial;
      --tw-sepia: initial;
      --tw-drop-shadow: initial;
      --tw-drop-shadow-color: initial;
      --tw-drop-shadow-alpha: 100%;
      --tw-drop-shadow-size: initial;
      --tw-backdrop-blur: initial;
      --tw-backdrop-brightness: initial;
      --tw-backdrop-contrast: initial;
      --tw-backdrop-grayscale: initial;
      --tw-backdrop-hue-rotate: initial;
      --tw-backdrop-invert: initial;
      --tw-backdrop-opacity: initial;
      --tw-backdrop-saturate: initial;
      --tw-backdrop-sepia: initial;
      --tw-duration: initial;
      --tw-ease: initial;
      --tw-text-shadow-color: initial;
      --tw-text-shadow-alpha: 100%;
      --tw-content: "";
    }
  }
}
`, "",{"version":3,"sources":["<no source>","webpack://./node_modules/tailwindcss/index.css","webpack://./app/assets/css/main.css","webpack://./app/assets/css/common.css"],"names":[],"mappings":"AAAA,iEAAA;AC86BE,iBAAoB;AA96BtB,yCAA0C;AAE1C;EACE;IACE;6DAE0D;IAE1D;8BAE2B;IAI3B,0CAA2C;IAC3C,0CAA2C;IAC3C,0CAA2C;IAC3C,0CAA2C;IAC3C,0CAA2C;IAC3C,0CAA2C;IAK3C,0CAA2C;IAE3C,6CAA8C;IAE9C,2CAA4C;IAC5C,6CAA8C;IAE9C,6CAA8C;IAC9C,2CAA4C;IAI5C,2CAA4C;IAC5C,4CAA6C;IAC7C,2CAA4C;IAC5C,4CAA6C;IAC7C,4CAA6C;IAC7C,2CAA4C;IAC5C,4CAA6C;IAC7C,4CAA6C;IAC7C,4CAA6C;IAC7C,4CAA6C;IAK7C,6CAA8C;IAE9C,6CAA8C;IAwB9C,6CAA8C;IAC9C,6CAA8C;IAC9C,6CAA8C;IAC9C,6CAA8C;IAC9C,6CAA8C;IAI9C,8CAA+C;IAE/C,8CAA+C;IAI/C,+CAAgD;IAChD,+CAAgD;IA6BhD,yCAA0C;IAE1C,2CAA4C;IAI5C,2CAA4C;IAC5C,yCAA0C;IAK1C,yCAA0C;IAC1C,4CAA6C;IAC7C,4CAA6C;IAE7C,4CAA6C;IAC7C,4CAA6C;IAC7C,4CAA6C;IAC7C,4CAA6C;IAkC7C,4CAA6C;IA+B7C,0CAA2C;IAE3C,2CAA4C;IAI5C,2CAA4C;IAC5C,2CAA4C;IAK5C,4CAA6C;IAC7C,6CAA8C;IAC9C,6CAA8C;IAC9C,6CAA8C;IAC9C,4CAA6C;IAG7C,6CAA8C;IAK9C,2CAA4C;IAC5C,4CAA6C;IAC7C,4CAA6C;IAC7C,2CAA4C;IAC5C,4CAA6C;IAC7C,4CAA6C;IAC7C,2CAA4C;IAC5C,4CAA6C;IAC7C,4CAA6C;IAC7C,0CAA2C;IAuF3C,mBAAoB;IACpB,mBAAoB;IC3QpB,kBAAmB;IDuRnB,qBAAsB;IACtB,qBAAsB;IACtB,qBAAsB;IACtB,qBAAsB;IACtB,qBAAsB;IACtB,sBAAuB;IAEvB,sBAAuB;IACvB,sBAAuB;IAIvB,kBAAmB;IACnB,sCAAuC;IACvC,mBAAoB;IACpB,0CAA2C;IAC3C,iBAAkB;IAClB,uCAAwC;IACxC,mBAAoB;IACpB,0CAA2C;IAC3C,kBAAmB;IACnB,yCAA0C;IAC1C,kBAAmB;IACnB,sCAAuC;IACvC,oBAAqB;IACrB,2CAA4C;IAC5C,mBAAoB;IACpB,yCAA0C;IAC1C,gBAAiB;IACjB,0BAA2B;IAa3B,yBAA0B;IAC1B,yBAA0B;IAC1B,2BAA4B;IAC5B,uBAAwB;IAExB,wBAAyB;IAGzB,0BAA2B;IAE3B,wBAAyB;IACzB,wBAAyB;IAIzB,qBAAsB;IAMtB,oBAAqB;IACrB,qBAAsB;IACtB,mBAAoB;IACpB,oBAAqB;IACrB,kBAAmB;IACnB,oBAAqB;IAuCrB,2CAA4C;IAI5C,+DAAgE;IAsChE,eAAgB;IAchB,oCAAqC;IACrC,kEAAmE;IACnE,uCAAqD;IASrD,4CAA0D;ICje1D,qBAAsB;IAEtB,sBAAuB;IAEvB,qBAAsB;IACtB,2BAA4B;IAC5B,kCAAmC;IAEnC,6BAA8B;IAO9B,oCAAqC;IAErC,oCAAqC;IACrC,oCAAqC;IAErC,oCAAqC;EDsdtC;AAWF;AAED;EAOE;;;;;IAKE,sBAAuB;IACvB,SAAU;IACV,UAAW;IACX,eAAgB;EACjB;EAYD;;IAEE,gBAAiB;IACjB,8BAA+B;IAC/B,WAAY;IACZ,2JASE;IACF,mEAGE;IACF,uEAGE;IACF,wCAAyC;EAC1C;EAQD;IACE,SAAU;IACV,cAAe;IACf,qBAAsB;EACvB;EAMD;IACE,yCAA0C;IAC1C,iCAAkC;EACnC;EAMD;;;;;;IAME,kBAAmB;IACnB,oBAAqB;EACtB;EAMD;IACE,cAAe;IACf,gCAAiC;IACjC,wBAAyB;EAC1B;EAMD;;IAEE,mBAAoB;EACrB;EASD;;;;IAIE,gJAUE;IACF,wEAGE;IACF,4EAGE;IACF,cAAe;EAChB;EAMD;IACE,cAAe;EAChB;EAMD;;IAEE,cAAe;IACf,cAAe;IACf,kBAAmB;IACnB,wBAAyB;EAC1B;EAED;IACE,eAAgB;EACjB;EAED;IACE,WAAY;EACb;EAQD;IACE,cAAe;IACf,qBAAsB;IACtB,yBAA0B;EAC3B;EAMD;IACE,aAAc;EACf;EAMD;IACE,wBAAyB;EAC1B;EAMD;IACE,kBAAmB;EACpB;EAMD;;;IAGE,gBAAiB;EAClB;EAQD;;;;;;;;IAQE,cAAe;IACf,sBAAuB;EACxB;EAMD;;IAEE,eAAgB;IAChB,YAAa;EACd;EASD;;;;;;IAME,aAAc;IACd,8BAA+B;IAC/B,gCAAiC;IACjC,uBAAwB;IACxB,cAAe;IACf,gBAAiB;IACjB,6BAA8B;IAC9B,UAAW;EACZ;EAMD;IACE,mBAAoB;EACrB;EAMD;IACE,0BAA2B;EAC5B;EAMD;IACE,sBAAuB;EACxB;EAMD;IACE,UAAW;EACZ;EAOD;;IAEE;MACE,mBAA0D;MAA1D;QAAA,yDAA0D;MAAA;IAC3D;EACF;EAMD;IACE,gBAAiB;EAClB;EAMD;IACE,wBAAyB;EAC1B;EAOD;IACE,eAAgB;IAChB,mBAAoB;EACrB;EAMD;IACE,oBAAqB;EACtB;EAMD;IACE,UAAW;EACZ;EAED;;;;;;;;;IASE,gBAAiB;EAClB;EAMD;IACE,cAAe;EAChB;EAMD;IACE,gBAAiB;EAClB;EAMD;;;IAGE,kBAAmB;EACpB;EAMD;;IAEE,YAAa;EACd;EAMD;IACE,wBAAyB;EAC1B;AACF;AAED;EACE;IAAA,2BAAoB;EAAA;EAApB;IAAA,oBAAoB;EAAA;EAApB;IAAA,kBAAoB;EAAA;EAApB;IAAA,mBAAoB;EAAA;EAApB;IAAA,kBAAoB;EAAA;EAApB;IAAA,eAAoB;EAAA;EAApB;IAAA,kBAAoB;EAAA;EAApB;IAAA,gBAAoB;EAAA;EAApB;IAAA,gBAAoB;EAAA;EAApB;IAAA,+BAAoB;EAAA;EAApB;IAAA,kCAAoB;EAAA;EAApB;IAAA,gCAAoB;EAAA;EAApB;IAAA,gCAAoB;EAAA;EAApB;IAAA,6BAAoB;EAAA;EAApB;IAAA,+BAAoB;EAAA;EAApB;IAAA,uBAAoB;EAAA;EAApB;IAAA,6BAAoB;EAAA;EAApB;IAAA,6BAAoB;EAAA;EAApB;IAAA,+BAAoB;EAAA;EAApB;IAAA,SAAoB;EAAA;EAApB;IAAA,+BAAoB;EAAA;EAApB;IAAA,+BAAoB;EAAA;EAApB;IAAA,+BAAoB;EAAA;EAApB;IAAA,gCAAoB;EAAA;EAApB;IAAA,WAAoB;EAAA;EAApB;IAAA,gCAAoB;EAAA;EAApB;IAAA,gCAAoB;EAAA;EAApB;IAAA,gCAAoB;EAAA;EAApB;IAAA,iCAAoB;EAAA;EAApB;IAAA,iCAAoB;EAAA;EAApB;IAAA,YAAoB;EAAA;EAApB;IAAA,8BAAoB;EAAA;EAApB;IAAA,gCAAoB;EAAA;EAApB;IAAA,gCAAoB;EAAA;EAApB;IAAA,wBAAoB;EAAA;EAApB;IAAA,8BAAoB;EAAA;EAApB;IAAA,8BAAoB;EAAA;EAApB;IAAA,sBAAoB;EAAA;EAApB;IAAA,UAAoB;EAAA;EAApB;IAAA,UAAoB;EAAA;EAApB;IAAA,UAAoB;EAAA;EAApB;IAAA,WAAoB;EAAA;EAApB;IAAA,WAAoB;EAAA;EAApB;IAAA,WAAoB;EAAA;EAApB;IAAA,WAAoB;EAAA;EAApB;IAAA,cAAoB;EAAA;EAApB;IAAA,eAAoB;EAAA;EAApB;IAAA,eAAoB;EAAA;EAApB;IAAA,4BAAoB;EAAA;EAApB;IAAA,4BAAoB;EAAA;EAApB;IAAA,4BAAoB;EAAA;EAApB;IAAA,mBAAoB;EAAA;EAApB;IAAA,yBAAoB;EAAA;EAApB;IAAA,YAAoB;EAAA;EAApB;IAAA,gCAAoB;EAAA;EAApB;IAAA,2CAAoB;EAAA;EAApB;IAAA,WAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,mBAAoB;EAAA;EAApB;IAAA,sCAAoB;EAAA;EAApB;IAAA,sCAAoB;EAAA;EAApB;IAAA,wCAAoB;EAAA;EAApB;IAAA,sCAAoB;EAAA;EAApB;IAAA,sCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,6CAAoB;EAAA;EAApB;IAAA,6CAAoB;EAAA;EAApB;IAAA,yBAAoB;EAAA;EAApB;IAAA,2CAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,sCAAoB;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,+CAAoB;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,sCAAoB;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,sCAAoB;EAAA;EAApB;IAAA,sCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,kDAAoB;EAAA;EAApB;IAAA,yCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,yCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,gDAAoB;EAAA;EAApB;IAAA,qCAAoB;EAAA;EAApB;IAAA,qCAAoB;EAAA;EAApB;IAAA,iBAAoB;EAAA;EAApB;IAAA,4BAAoB;EAAA;EAApB;IAAA,gBAAoB;IAApB,oBAAoB;IAApB,4BAAoB;IAApB,qBAAoB;EAAA;EAApB;IAAA,gBAAoB;IAApB,oBAAoB;IAApB,4BAAoB;IAApB,qBAAoB;EAAA;EAApB;IAAA,cAAoB;EAAA;EAApB;IAAA,iBAAoB;EAAA;EAApB;IAAA,aAAoB;EAAA;EAApB;IAAA,wBAAoB;EAAA;EAApB;IAAA,aAAoB;EAAA;EAApB;IAAA,aAAoB;EAAA;EAApB;IAAA,qBAAoB;EAAA;EAApB;IAAA,oBAAoB;EAAA;EAApB;IAAA,cAAoB;EAAA;EAApB;IAAA,iBAAoB;EAAA;EAApB;IAAA,iBAAoB;EAAA;EAApB;IAAA,mBAAoB;EAAA;EAApB;IAAA,gCAAoB;EAAA;EAApB;IAAA,kCAAoB;EAAA;EAApB;IAAA,gCAAoB;EAAA;EAApB;IAAA,gCAAoB;EAAA;EAApB;IAAA,kCAAoB;EAAA;EAApB;IAAA,gCAAoB;EAAA;EAApB;IAAA,gCAAoB;EAAA;EAApB;IAAA,iCAAoB;EAAA;EAApB;IAAA,iCAAoB;EAAA;EAApB;IAAA,iCAAoB;EAAA;EAApB;IAAA,iCAAoB;EAAA;EAApB;IAAA,iCAAoB;EAAA;EAApB;IAAA,iCAAoB;EAAA;EAApB;IAAA,iCAAoB;EAAA;EAApB;IAAA,iCAAoB;EAAA;EAApB;IAAA,WAAoB;EAAA;EAApB;IAAA,YAAoB;EAAA;EAApB;IAAA,YAAoB;EAAA;EAApB;IAAA,YAAoB;EAAA;EAApB;IAAA,YAAoB;EAAA;EAApB;IAAA,YAAoB;EAAA;EAApB;IAAA,aAAoB;EAAA;EAApB;IAAA,aAAoB;EAAA;EAApB;IAAA,aAAoB;EAAA;EAApB;IAAA,0BAAoB;EAAA;EAApB;IAAA,cAAoB;EAAA;EAApB;IAAA,YAAoB;EAAA;EAApB;IAAA,uBAAoB;EAAA;EAApB;IAAA,WAAoB;EAAA;EAApB;IAAA,iBAAoB;EAAA;EAApB;IAAA,iBAAoB;EAAA;EAApB;IAAA,gBAAoB;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,qCAAoB;EAAA;EAApB;IAAA,qCAAoB;EAAA;EAApB;IAAA,qCAAoB;EAAA;EAApB;IAAA,qCAAoB;EAAA;EAApB;IAAA,iBAAoB;EAAA;EAApB;IAAA,gBAAoB;EAAA;EAApB;IAAA,iBAAoB;EAAA;EAApB;IAAA,iBAAoB;EAAA;EAApB;IAAA,iBAAoB;EAAA;EAApB;IAAA,sBAAoB;EAAA;EAApB;IAAA,+BAAoB;EAAA;EAApB;IAAA,iCAAoB;EAAA;EAApB;IAAA,yBAAoB;EAAA;EAApB;IAAA,yBAAoB;EAAA;EAApB;IAAA,yBAAoB;EAAA;EAApB;IAAA,yBAAoB;EAAA;EAApB;IAAA,+BAAoB;EAAA;EAApB;IAAA,+BAAoB;EAAA;EAApB;IAAA,+BAAoB;EAAA;EAApB;IAAA,+BAAoB;EAAA;EAApB;IAAA,+BAAoB;EAAA;EAApB;IAAA,0CAAoB;EAAA;EAApB;IAAA,gCAAoB;EAAA;EAApB;IAAA,gCAAoB;EAAA;EAApB;IAAA,gCAAoB;EAAA;EAApB;IAAA,gCAAoB;EAAA;EAApB;IAAA,gCAAoB;EAAA;EAApB;IAAA,gCAAoB;EAAA;EAApB;IAAA,iCAAoB;EAAA;EAApB;IAAA,UAAoB;EAAA;EAApB;IAAA,UAAoB;EAAA;EAApB;IAAA,UAAoB;EAAA;EAApB;IAAA,YAAoB;EAAA;EAApB;IAAA,YAAoB;EAAA;EAApB;IAAA,uBAAoB;EAAA;EAApB;IAAA,YAAoB;EAAA;EAApB;IAAA,YAAoB;EAAA;EAApB;IAAA,YAAoB;EAAA;EAApB;IAAA,aAAoB;EAAA;EAApB;IAAA,kBAAoB;EAAA;EAApB;IAAA,WAAoB;EAAA;EAApB;IAAA,kBAAoB;EAAA;EAApB;IAAA,UAAoB;EAAA;EAApB;IAAA,+BAAoB;EAAA;EAApB;IAAA,+BAAoB;EAAA;EAApB;IAAA,+BAAoB;EAAA;EAApB;IAAA,eAAoB;EAAA;EAApB;IAAA,eAAoB;EAAA;EAApB;IAAA,gBAAoB;EAAA;EAApB;IAAA,gBAAoB;EAAA;EAApB;IAAA,gBAAoB;EAAA;EAApB;IAAA,gBAAoB;EAAA;EAApB;IAAA,iBAAoB;EAAA;EAApB;IAAA,eAAoB;EAAA;EAApB;IAAA,8BAAoB;EAAA;EAApB;IAAA,yCAAoB;EAAA;EAApB;IAAA,8BAAoB;EAAA;EAApB;IAAA,8BAAoB;EAAA;EAApB;IAAA,8BAAoB;EAAA;EAApB;IAAA,mCAAoB;EAAA;EAApB;IAAA,mCAAoB;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,eAAoB;EAAA;EAApB;IAAA,gBAAoB;EAAA;EAApB;IAAA,eAAoB;EAAA;EAApB;IAAA,8BAAoB;EAAA;EAApB;IAAA,OAAoB;EAAA;EAApB;IAAA,UAAoB;EAAA;EAApB;IAAA,cAAoB;EAAA;EAApB;IAAA,YAAoB;EAAA;EAApB;IAAA,YAAoB;EAAA;EAApB;IAAA,YAAoB;EAAA;EAApB;IAAA,mBAAoB;EAAA;EAApB;IAAA,+CAAoB;IAApB,sDAAoB;EAAA;EAApB;IAAA,2CAAoB;IAApB,sDAAoB;EAAA;EAApB;IAAA,0CAAoB;IAApB,sDAAoB;EAAA;EAApB;IAAA,+CAAoB;IAApB,sDAAoB;EAAA;EAApB;IAAA,0CAAoB;IAApB,sDAAoB;EAAA;EAApB;IAAA,2CAAoB;IAApB,sDAAoB;EAAA;EAApB;IAAA,iBAAoB;IAApB,iBAAoB;IAApB,iBAAoB;IAApB,0CAAoB;EAAA;EAApB;IAAA,iBAAoB;IAApB,iBAAoB;IAApB,iBAAoB;IAApB,0CAAoB;EAAA;EAApB;IAAA,0GAAoB;EAAA;EAApB;IAAA,+BAAoB;EAAA;EAApB;IAAA,eAAoB;EAAA;EAApB;IAAA,YAAoB;EAAA;EAApB;IAAA,mBAAoB;EAAA;EAApB;IAAA,eAAoB;EAAA;EAApB;IAAA,YAAoB;EAAA;EAApB;IAAA,oDAAoB;EAAA;EAApB;IAAA,sCAAoB;EAAA;EAApB;IAAA,2BAAoB;EAAA;EAApB;IAAA,qBAAoB;EAAA;EAApB;IAAA,qBAAoB;EAAA;EAApB;IAAA,gDAAoB;EAAA;EAApB;IAAA,2DAAoB;EAAA;EAApB;IAAA,gDAAoB;EAAA;EAApB;IAAA,gDAAoB;EAAA;EAApB;IAAA,sCAAoB;EAAA;EAApB;IAAA,+BAAoB;EAAA;EAApB;IAAA,8BAAoB;EAAA;EAApB;IAAA,+BAAoB;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,sCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,qCAAoB;EAAA;EAApB;IAAA,kEAAoB;EAAA;EAApB;IAAA,0DAAoB;EAAA;EAApB;IAAA,0DAAoB;EAAA;EAApB;IAAA,0DAAoB;EAAA;EAApB;IAAA,8BAAoB;EAAA;EAApB;IAAA,6CAAoB;EAAA;EAApB;IAAA,wDAAoB;EAAA;EAApB;IAAA,uBAAoB;EAAA;EAApB;IAAA,iCAAoB;EAAA;EAApB;IAAA,iCAAoB;EAAA;EAApB;IAAA,mCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,2CAAoB;EAAA;EAApB;IAAA,2BAAoB;EAAA;EAApB;IAAA,sBAAoB;EAAA;EAApB;IAAA,mBAAoB;EAAA;EAApB;IAAA,iBAAoB;EAAA;EAApB;IAAA,eAAoB;EAAA;EAApB;IAAA,qBAAoB;EAAA;EAApB;IAAA,mBAAoB;EAAA;EAApB;IAAA,0BAAoB;EAAA;EAApB;IAAA,uBAAoB;EAAA;EAApB;IAAA,8BAAoB;EAAA;EAApB;IAAA,uBAAoB;EAAA;EAApB;IAAA,yBAAoB;EAAA;EAApB;IAAA,8BAAoB;EAAA;EAApB;IAAA,6BAAoB;EAAA;EAApB;IAAA,+BAAoB;EAAA;EAApB;IAAA,6BAAoB;EAAA;EAApB;IAAA,+BAAoB;EAAA;EAApB;IAAA,6BAAoB;EAAA;EAApB;IAAA,+BAAoB;EAAA;EAApB;IAAA,6BAAoB;EAAA;EAApB;IAAA,6BAAoB;EAAA;EAApB;IAAA,6BAAoB;EAAA;EAApB;IAAA;MAAA,uBAAoB;MAApB,8EAAoB;MAApB,sFAAoB;IAAA;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,mCAAoB;EAAA;EAApB;IAAA,iCAAoB;EAAA;EAApB;IAAA,mCAAoB;EAAA;EAApB;IAAA,iCAAoB;EAAA;EAApB;IAAA,mCAAoB;EAAA;EAApB;IAAA,iCAAoB;EAAA;EAApB;IAAA,iCAAoB;EAAA;EAApB;IAAA,iCAAoB;EAAA;EAApB;IAAA,iCAAoB;EAAA;EAApB;IAAA,sBAAoB;EAAA;EAApB;IAAA,gBAAoB;IAApB,uBAAoB;IAApB,mBAAoB;EAAA;EAApB;IAAA,cAAoB;EAAA;EAApB;IAAA,gBAAoB;EAAA;EAApB;IAAA,gBAAoB;EAAA;EAApB;IAAA,iBAAoB;EAAA;EAApB;IAAA,4BAAoB;EAAA;EAApB;IAAA,gBAAoB;EAAA;EAApB;IAAA,kBAAoB;EAAA;EAApB;IAAA,6BAAoB;EAAA;EAApB;IAAA,gBAAoB;EAAA;EAApB;IAAA,kBAAoB;EAAA;EAApB;IAAA,sBAAoB;EAAA;EAApB;IAAA,gCAAoB;EAAA;EAApB;IAAA,gCAAoB;EAAA;EAApB;IAAA,kBAAoB;EAAA;EAApB;IAAA,kBAAoB;EAAA;EAApB;IAAA,mCAAoB;EAAA;EAApB;IAAA,+BAAoB;EAAA;EAApB;IAAA,+BAAoB;EAAA;EAApB;IAAA,2BAAoB;EAAA;EAApB;IAAA,+BAAoB;EAAA;EAApB;IAAA,+BAAoB;EAAA;EAApB;IAAA,+BAAoB;IAApB,gCAAoB;EAAA;EAApB;IAAA,gCAAoB;IAApB,mCAAoB;EAAA;EAApB;IAAA,oCAAoB;IAApB,iBAAoB;EAAA;EAApB;IAAA,+CAAoB;IAApB,4BAAoB;EAAA;EAApB;IAAA,oCAAoB;IAApB,iBAAoB;EAAA;EAApB;IAAA,oCAAoB;IAApB,iBAAoB;EAAA;EAApB;IAAA,oCAAoB;IAApB,iBAAoB;EAAA;EAApB;IAAA,wCAAoB;IAApB,qBAAoB;EAAA;EAApB;IAAA,0CAAoB;IAApB,uBAAoB;EAAA;EAApB;IAAA,2CAAoB;IAApB,wBAAoB;EAAA;EAApB;IAAA,2CAAoB;IAApB,wBAAoB;EAAA;EAApB;IAAA,yCAAoB;IAApB,sBAAoB;EAAA;EAApB;IAAA,yCAAoB;IAApB,sBAAoB;EAAA;EAApB;IAAA,yBAAoB;IAApB,oBAAoB;EAAA;EAApB;IAAA,uBAAoB;IAApB,kBAAoB;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,6EAAoB;IAApB;MAAA,yEAAoB;IAAA;EAAA;EAApB;IAAA,6EAAoB;IAApB;MAAA,yEAAoB;IAAA;EAAA;EAApB;IAAA,sCAAoB;EAAA;EAApB;IAAA,kCAAoB;EAAA;EAApB;IAAA,mCAAoB;EAAA;EAApB;IAAA,mCAAoB;EAAA;EAApB;IAAA,8CAAoB;EAAA;EAApB;IAAA,6EAAoB;IAApB;MAAA,yEAAoB;IAAA;EAAA;EAApB;IAAA,mCAAoB;EAAA;EAApB;IAAA,8CAAoB;EAAA;EAApB;IAAA,mCAAoB;EAAA;EAApB;IAAA,mCAAoB;EAAA;EAApB;IAAA,4CAAoB;EAAA;EAApB;IAAA,qCAAoB;EAAA;EAApB;IAAA,6CAAoB;EAAA;EAApB;IAAA,mCAAoB;EAAA;EAApB;IAAA,kCAAoB;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,uDAAoB;IAApB;MAAA,sEAAoB;IAAA;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,wCAAoB;EAAA;EAApB;IAAA,yCAAoB;EAAA;EAApB;IAAA,0CAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,kDAAoB;EAAA;EAApB;IAAA,gFAAoB;IAApB;MAAA,6EAAoB;IAAA;EAAA;EAApB;IAAA,gFAAoB;IAApB;MAAA,6EAAoB;IAAA;EAAA;EAApB;IAAA,wCAAoB;EAAA;EAApB;IAAA,wCAAoB;EAAA;EAApB;IAAA,+EAAoB;IAApB;MAAA,8EAAoB;IAAA;EAAA;EAApB;IAAA,wCAAoB;EAAA;EAApB;IAAA,wCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,sCAAoB;EAAA;EAApB;IAAA,iDAAoB;EAAA;EAApB;IAAA,+EAAoB;IAApB;MAAA,4EAAoB;IAAA;EAAA;EAApB;IAAA,+EAAoB;IAApB;MAAA,4EAAoB;IAAA;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,8BAAoB;EAAA;EAApB;IAAA,yCAAoB;EAAA;EAApB;IAAA,0CAAoB;EAAA;EAApB;IAAA,sCAAoB;EAAA;EAApB;IAAA,iFAAoB;IAApB;MAAA,4EAAoB;IAAA;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,kDAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,iFAAoB;IAApB;MAAA,6EAAoB;IAAA;EAAA;EAApB;IAAA,iFAAoB;IAApB;MAAA,6EAAoB;IAAA;EAAA;EAApB;IAAA,wCAAoB;EAAA;EAApB;IAAA,wCAAoB;EAAA;EAApB;IAAA,mCAAoB;EAAA;EAApB;IAAA,yCAAoB;EAAA;EAApB;IAAA,wCAAoB;EAAA;EAApB;IAAA,oDAAoB;EAAA;EAApB;IAAA,yCAAoB;EAAA;EAApB;IAAA,sCAAoB;EAAA;EAApB;IAAA,2CAAoB;IAApB;MAAA,0FAAoB;IAAA;EAAA;EAApB;IAAA,sCAAoB;EAAA;EAApB;IAAA,sCAAoB;EAAA;EAApB;IAAA,sCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,qCAAoB;EAAA;EAApB;IAAA,sCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,iFAAoB;IAApB;MAAA,6EAAoB;IAAA;EAAA;EAApB;IAAA,iFAAoB;IAApB;MAAA,8EAAoB;IAAA;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,+CAAoB;EAAA;EAApB;IAAA,2DAAoB;IAApB;MAAA,0EAAoB;IAAA;EAAA;EAApB;IAAA,gFAAoB;IAApB;MAAA,+EAAoB;IAAA;EAAA;EAApB;IAAA,yCAAoB;EAAA;EAApB;IAAA,0CAAoB;IAApB,2DAAoB;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,sCAAoB;EAAA;EAApB;IAAA,sCAAoB;IAApB,8LAAoB;EAAA;EAApB;IAAA,iFAAoB;IAApB;MAAA,4EAAoB;IAAA;IAApB,8LAAoB;EAAA;EAApB;IAAA,wBAAoB;EAAA;EAApB;IAAA,qBAAoB;EAAA;EAApB;IAAA,2BAAoB;EAAA;EAApB;IAAA,4BAAoB;EAAA;EAApB;IAAA,mBAAoB;EAAA;EAApB;IAAA,4CAAoB;EAAA;EAApB;IAAA,mCAAoB;EAAA;EAApB;IAAA,iCAAoB;EAAA;EAApB;IAAA,iCAAoB;EAAA;EAApB;IAAA,mCAAoB;EAAA;EAApB;IAAA,iCAAoB;EAAA;EAApB;IAAA,iCAAoB;EAAA;EAApB;IAAA,mDAAoB;EAAA;EAApB;IAAA,wCAAoB;EAAA;EAApB;IAAA,0CAAoB;EAAA;EAApB;IAAA,wCAAoB;EAAA;EAApB;IAAA,0CAAoB;EAAA;EAApB;IAAA,wCAAoB;EAAA;EAApB;IAAA,0CAAoB;EAAA;EAApB;IAAA,wCAAoB;EAAA;EAApB;IAAA,wCAAoB;EAAA;EAApB;IAAA,wCAAoB;EAAA;EAApB;IAAA,kDAAoB;EAAA;EAApB;IAAA,yCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,kDAAoB;EAAA;EAApB;IAAA,yCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,yCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,wCAAoB;EAAA;EAApB;IAAA,8CAAoB;EAAA;EAApB;IAAA,8CAAoB;EAAA;EAApB;IAAA,4CAAoB;EAAA;EAApB;IAAA,qCAAoB;EAAA;EAApB;IAAA,qCAAoB;EAAA;EAApB;IAAA,qCAAoB;EAAA;EAApB;IAAA,qCAAoB;EAAA;EAApB;IAAA,qCAAoB;EAAA;EAApB;IAAA,gBAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,wCAAoB;EAAA;EAApB;IAAA,wCAAoB;EAAA;EAApB;IAAA,wCAAoB;EAAA;EAApB;IAAA,yCAAoB;EAAA;EAApB;IAAA,yCAAoB;EAAA;EAApB;IAAA,sCAAoB;EAAA;EAApB;IAAA,sCAAoB;EAAA;EAApB;IAAA,sCAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,oBAAoB;EAAA;EAApB;IAAA,kBAAoB;EAAA;EAApB;IAAA,iBAAoB;EAAA;EAApB;IAAA,6BAAoB;EAAA;EAApB;IAAA,8BAAoB;EAAA;EAApB;IAAA,0BAAoB;IAApB,4DAAoB;EAAA;EAApB;IAAA,qCAAoB;IAApB,uEAAoB;EAAA;EAApB;IAAA,0BAAoB;IAApB,4DAAoB;EAAA;EAApB;IAAA,0BAAoB;IAApB,4DAAoB;EAAA;EAApB;IAAA,0BAAoB;IAApB,4DAAoB;EAAA;EAApB;IAAA,2BAAoB;IAApB,6DAAoB;EAAA;EAApB;IAAA,yBAAoB;IAApB,2DAAoB;EAAA;EAApB;IAAA,yBAAoB;IAApB,2DAAoB;EAAA;EAApB;IAAA,yBAAoB;IAApB,2DAAoB;EAAA;EAApB;IAAA,yBAAoB;IAApB,2DAAoB;EAAA;EAApB;IAAA,oCAAoB;IAApB,sEAAoB;EAAA;EAApB;IAAA,cAAoB;EAAA;EAApB;IAAA,cAAoB;EAAA;EAApB;IAAA,eAAoB;EAAA;EAApB;IAAA,eAAoB;EAAA;EAApB;IAAA,eAAoB;IAApB,cAAoB;EAAA;EAApB;IAAA,iCAAoB;IAApB,gCAAoB;EAAA;EAApB;IAAA,0CAAoB;IAApB,qCAAoB;EAAA;EAApB;IAAA,yCAAoB;IAApB,oCAAoB;EAAA;EAApB;IAAA,oDAAoB;IAApB,+CAAoB;EAAA;EAApB;IAAA,2CAAoB;IAApB,sCAAoB;EAAA;EAApB;IAAA,2CAAoB;IAApB,sCAAoB;EAAA;EAApB;IAAA,6CAAoB;IAApB,wCAAoB;EAAA;EAApB;IAAA,qBAAoB;IAApB,sBAAoB;EAAA;EAApB;IAAA,oCAAoB;IAApB,qCAAoB;EAAA;EAApB;IAAA,mCAAoB;IAApB,oCAAoB;EAAA;EAApB;IAAA,oCAAoB;IAApB,qCAAoB;EAAA;EAApB;IAAA,kBAAoB;EAAA;EAApB;IAAA,yBAAoB;EAAA;EAApB;IAAA,qBAAoB;EAAA;EAApB;IAAA,mBAAoB;EAAA;EAApB;IAAA,mBAAoB;EAAA;EAApB;IAAA,cAAoB;EAAA;EAApB;IAAA,6BAAoB;EAAA;EAApB;IAAA,6BAAoB;EAAA;EAApB;IAAA,6BAAoB;EAAA;EAApB;IAAA,6BAAoB;EAAA;EAApB;IAAA,wCAAoB;EAAA;EAApB;IAAA,6BAAoB;EAAA;EAApB;IAAA,6BAAoB;EAAA;EAApB;IAAA,4BAAoB;EAAA;EAApB;IAAA,yBAAoB;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,4BAAoB;EAAA;EAApB;IAAA,4BAAoB;EAAA;EAApB;IAAA,4BAAoB;EAAA;EAApB;IAAA,4BAAoB;EAAA;EAApB;IAAA,+BAAoB;EAAA;EAApB;IAAA,0CAAoB;EAAA;EAApB;IAAA,4BAAoB;EAAA;EAApB;IAAA,4BAAoB;EAAA;EAApB;IAAA,4BAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,4BAAoB;EAAA;EAApB;IAAA,4BAAoB;EAAA;EAApB;IAAA,4BAAoB;EAAA;EAApB;IAAA,4BAAoB;EAAA;EAApB;IAAA,4BAAoB;EAAA;EAApB;IAAA,6BAAoB;EAAA;EAApB;IAAA,6BAAoB;EAAA;EAApB;IAAA,6BAAoB;EAAA;EAApB;IAAA,6BAAoB;EAAA;EAApB;IAAA,wBAAoB;EAAA;EAApB;IAAA,mCAAoB;EAAA;EAApB;IAAA,8BAAoB;EAAA;EAApB;IAAA,8BAAoB;EAAA;EAApB;IAAA,8BAAoB;EAAA;EAApB;IAAA,8BAAoB;EAAA;EAApB;IAAA,8BAAoB;EAAA;EAApB;IAAA,2BAAoB;EAAA;EAApB;IAAA,2BAAoB;EAAA;EAApB;IAAA,2BAAoB;EAAA;EAApB;IAAA,sCAAoB;EAAA;EAApB;IAAA,2BAAoB;EAAA;EAApB;IAAA,4BAAoB;EAAA;EAApB;IAAA,uCAAoB;EAAA;EAApB;IAAA,2BAAoB;EAAA;EAApB;IAAA,sCAAoB;EAAA;EAApB;IAAA,6BAAoB;EAAA;EAApB;IAAA,6BAAoB;EAAA;EAApB;IAAA,yBAAoB;EAAA;EAApB;IAAA,yBAAoB;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,0BAAoB;EAAA;EAApB;IAAA,yBAAoB;EAAA;EAApB;IAAA,kBAAoB;EAAA;EAApB;IAAA,kCAAoB;EAAA;EAApB;IAAA,qCAAoB;EAAA;EAApB;IAAA,+BAAoB;EAAA;EAApB;IAAA,WAAoB;EAAA;EAApB;IAAA,YAAoB;EAAA;EAApB;IAAA,YAAoB;EAAA;EAApB;IAAA,YAAoB;EAAA;EAApB;IAAA,aAAoB;EAAA;EAApB;IAAA,6BAAoB;EAAA;EAApB;IAAA,0HAAoB;IAApB,sIAAoB;EAAA;EAApB;IAAA,wEAAoB;IAApB,sIAAoB;EAAA;EAApB;IAAA,4DAAoB;IAApB,sIAAoB;EAAA;EAApB;IAAA,gEAAoB;IAApB,sIAAoB;EAAA;EAApB;IAAA,+HAAoB;IAApB,sIAAoB;EAAA;EAApB;IAAA,6HAAoB;IAApB,sIAAoB;EAAA;EAApB;IAAA,0HAAoB;IAApB,sIAAoB;EAAA;EAApB;IAAA,kEAAoB;IAApB,sIAAoB;EAAA;EAApB;IAAA,2CAAoB;IAApB;MAAA,kGAAoB;IAAA;EAAA;EAApB;IAAA,6CAAoB;IAApB;MAAA,iGAAoB;IAAA;EAAA;EAApB;IAAA,4CAAoB;IAApB;MAAA,oGAAoB;IAAA;EAAA;EAApB;IAAA,6CAAoB;IAApB;MAAA,iGAAoB;IAAA;EAAA;EAApB;IAAA,4CAAoB;IAApB;MAAA,iGAAoB;IAAA;EAAA;EAApB;IAAA,4CAAoB;IAApB;MAAA,iGAAoB;IAAA;EAAA;EAApB;IAAA,6CAAoB;IAApB;MAAA,gGAAoB;IAAA;EAAA;EAApB;IAAA,iDAAoB;IAApB,6BAAoB;EAAA;EAApB;IAAA,sCAAoB;IAApB,kBAAoB;EAAA;EAApB;IAAA,sCAAoB;IAApB,kBAAoB;EAAA;EAApB;IAAA,sCAAoB;IAApB,kBAAoB;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,iCAAoB;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,oCAAoB;EAAA;EAApB;IAAA,qCAAoB;EAAA;EAApB;IAAA,mCAAoB;EAAA;EAApB;IAAA,0LAAoB;EAAA;EAApB;IAAA,wCAAoB;IAApB,wRAAoB;IAApB,gRAAoB;EAAA;EAApB;IAAA,yUAAoB;IAApB,qFAAoB;IAApB,2EAAoB;EAAA;EAApB;IAAA,+CAAoB;IAApB,qFAAoB;IAApB,2EAAoB;EAAA;EAApB;IAAA,wBAAoB;IAApB,qFAAoB;IAApB,2EAAoB;EAAA;EAApB;IAAA,uKAAoB;IAApB,qFAAoB;IAApB,2EAAoB;EAAA;EAApB;IAAA,+BAAoB;IAApB,qFAAoB;IAApB,2EAAoB;EAAA;EAApB;IAAA,wDAAoB;IAApB,qFAAoB;IAApB,2EAAoB;EAAA;EAApB;IAAA,oBAAoB;IAApB,0BAAoB;EAAA;EAApB;IAAA,oBAAoB;IAApB,0BAAoB;EAAA;EAApB;IAAA,oBAAoB;IAApB,0BAAoB;EAAA;EAApB;IAAA,6BAAoB;IAApB,8CAAoB;EAAA;EAApB;IAAA,0BAAoB;IAApB,qBAAoB;EAAA;EAApB;IAAA,wBAAoB;IAApB,mBAAoB;EAAA;EAApB;IAAA,yBAAoB;IAApB,iBAAoB;EAAA;EAApB;IAAA,qBAAoB;EAAA;EAApB;IAAA,iDAAoB;IAApB;MAAA,6GAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,wCAAoB;MAApB,qBAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,uCAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,qCAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,eAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,mCAAoB;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,cAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,sCAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,gFAAoB;QAApB;UAAA,6EAAoB;QAAA;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,4BAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,4BAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,4BAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,4BAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,2BAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,YAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,aAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,wBAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,8BAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,kBAAoB;QAApB,kBAAoB;QAApB,kBAAoB;QAApB,0CAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,aAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA,cAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,uBAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,iBAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,aAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,iBAAoB;MAApB,0BAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,uCAAoB;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,YAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,mBAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,eAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,mCAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,uCAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,wCAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,mDAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,sCAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,uCAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,sCAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,uCAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,uCAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,yBAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,4BAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,4BAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,uCAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,4BAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,wBAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,2BAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,qCAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,+BAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,0CAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,aAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,sBAAoB;QAApB,6KAAoB;QAApB,sIAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,0HAAoB;QAApB,sIAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,6HAAoB;QAApB,sIAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,0HAAoB;QAApB,sIAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,sCAAoB;QAApB,kBAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,sCAAoB;QAApB,kBAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,oCAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA,qCAAoB;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA;UAAA,+BAAoB;QAAA;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA,uCAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,wHAAoB;MAApB,sIAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,sCAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,iDAAoB;MAApB,6BAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,iBAAoB;MAApB,iBAAoB;MAApB,iBAAoB;MAApB,0CAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,4BAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,gDAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,qBAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,4BAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,4BAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,4BAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,mBAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,uCAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,yBAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,aAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,wBAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,aAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,yBAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,WAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,gDAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,gDAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,iDAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,gCAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,gCAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,0DAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,0DAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,8BAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,mBAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,mBAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,uBAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,8BAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,uBAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,yBAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,2BAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,oCAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,oCAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,oCAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,gBAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,gBAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,wCAAoB;MAApB,qBAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,0CAAoB;MAApB,uBAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,2CAAoB;MAApB,wBAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,6BAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,iCAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,wCAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,wCAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,wCAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,wCAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,kBAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,yBAAoB;MAApB,2DAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,yBAAoB;MAApB,2DAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,yBAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,kBAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,WAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,sBAAoB;MAApB,sIAAoB;IAAA;EAAA;EAApB;IAAA;MAAA;QAAA;UAAA,YAAoB;QAAA;MAAA;IAAA;EAAA;EAApB;IAAA;MAAA,4BAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,4BAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,4BAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,oBAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,oBAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,oCAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,wBAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,aAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,YAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,0BAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,YAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,gDAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,gDAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,gDAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,gCAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,0DAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,mBAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,uBAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,oCAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,qCAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,iCAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,uCAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,gDAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,gDAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,gDAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,gDAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,aAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,YAAoB;IAAA;EAAA;EAApB;IAAA;MAAA,mBAAoB;IAAA;EAAA;AACrB;AE96BD;EACI,iBAAkB;AACrB;AAED;EACI,8BAA+B;EAC/B,qBAAsB;EACtB,sBAAuB;EACvB,oBAAqB;EACrB,oBAAqB;EACrB,qBAAsB;EACtB,2BAA4B;EAC5B,6BAA8B;EAC9B,qBAAsB;EACtB,oBAAqB;EACrB,mBAAoB;AACvB;AAGD;EACI,yBAA0B;AAC7B;AAKD;EACI,qBAAsB;AACzB;AAED;EACI,eAAgB;AACnB;AAED;EACI,aAAa;AAChB;AAED;EACI,aAAa;AAChB;AAED;EACI,aAAc;AACjB;AAGD;;EAEI,kBAAmB;EACnB,yBAA0B;EAC1B,0BAA2B;AAC9B;AACD;;EAEI,kBAAmB;EACnB,4BAA6B;EAC7B,6BAA8B;EAE9B,qBAAsB;EACtB,uBAAwB;EAExB,0CAA2C;EAE3C,gBAAiB;AACpB;AACD;;EAEI,eAAgB;AACnB;AACD;;EAEI,4BAA6B;AAChC;AAED;;EAEI,UAAW;EACX,SAAU;EACV,aAAc;EACd,UAAW;EACX,SAAU;EACV,SAAS;AACZ;AAKD;EACI,gCAAiC;AACpC;AAGD;EACI,WAAY;AACf;AAGD;EACI,oBAAqB;AACxB;AAGD;EACI,WAAY;AACf;AAGD;EACI,qBAAsB;AACzB;AAGD;EACI,0CAA2C;EAC3C,gBAAiB;AACpB;AAED;EACI,UAAW;EACX,SAAU;EACV,aAAc;EACd,UAAW;EACX,SAAU;EACV,SAAS;EACT,QAAS;AACZ;AAKD;EACI,WAAY;EACZ,yBAA0B;EAC1B,qBAAsB;EACtB,qBAAsB;EACtB,0CAA2C;EAC3C,oBAAqB;EACrB,kFAAmF;AACtF;AAED;EACI,kBAAmB;AACtB;AAED;EACI,kBAAmB;EACnB,YAAa;EACb,QAAS;EACT,WAAY;EACZ,gBAAiB;AACpB;AAGD;EAEI,gBAAiB;AACpB;AAED;EACI,kBAAmB;EACnB,0BAA2B;EAC3B,6BAA8B;AACjC;AACD;EACI,6BAA8B;EAC9B,qCAAsC;EACtC,wCAAyC;AAC5C;AAED;EACI,UAAW;EACX,SAAU;EACV,aAAc;EACd,UAAW;EACX,SAAU;EACV,SAAS;AACZ;AAED;EAEI,2BAA4B;AAC/B;AAED;EACI,kBAAmB;EACnB,QAAS;EACT,WAAY;AACf;AAGD;EACI,WAAY;EACZ,YAAa;EACb,iBAAkB;EAClB,kBAAmB;EACnB,gBAAiB;AACpB;AAED;EACI,aAAc;AACjB;AAED;EACI,YAAa;EACb,sBAAuB;AAC1B;AAED;EACI,wCAAyC;EACzC,YAAa;EACb,aAAc;EACd,kBAAmB;EACnB,kBAAmB;AACtB;AAED;EACI,gBAAiB;EACjB,iBAAkB;AACrB;AAED;EACI,UAAW;EACX,mBAAoB;AACvB;AAED;EACI,kBAAmB;AACtB;AAED;EACI,oBAAqB;AACxB;AAED;EACI,WAAY;EACZ,kBAAmB;EACnB,MAAO;EACP,WAAY;EACZ,YAAa;EACb,iBAAkB;EAClB,8BAA+B;AAClC;AAED;EACI,WAAY;EACZ,kBAAmB;EACnB,MAAO;EACP,UAAW;EACX,YAAa;EACb,gBAAiB;EACjB,+BAAgC;AACnC;AAED;EACI,eAAgB;EAChB,cAAe;EACf,iBAAkB;EAClB,WAAY;EACZ,gBAAiB;EACjB,uBAAwB;EACxB,WAAY;EACZ,mBAAoB;AACvB;AAED;EACI,qBAAsB;EACtB,cAAe;EACf,yBAA0B;AAC7B;AAED;EACI,WAAY;EACZ,qBAAsB;EACtB,UAAW;EACX,yBAA0B;AAC7B;AAED;;EAEI,WAAY;EACZ,mBAAoB;EACpB,sBAAuB;AAC1B;AAGD;;EAEI,wBAAyB;AAC5B;AAGD;EACI,qBAAsB;AACzB;AAGD;EACI,0CAA2C;AAC9C;AAED;EACI,WAAY;EACZ,kBAAmB;AACtB;AACD;EACI,qBAAsB;EACtB,WAAY;EACZ,gBAAiB;AACpB;AACD;EACI,kBAAmB;EACnB,YAAa;EACb,WAAY;EACZ,gBAAiB;AACpB;AAGD;EACI,kBAAmB;EACnB,QAAS;EACT,iBAAkB;AACrB;AAED;EACI;IACI,+BAAgC;IAChC,uBAAwB;EAC3B;EACD;IACI,iCAAkC;IAClC,yBAA0B;EAC7B;AACJ;AACD;EACI;IACI,+BAAgC;IAChC,uBAAwB;EAC3B;EACD;IACI,iCAAkC;IAClC,yBAA0B;EAC7B;AACJ;AAED;EACI,oDAAqD;EACrD,4CAA6C;AAChD;AAED;EACI,0BAA2B;AAC9B;AD9VD;EACI;IACI,sBAAuB;EAC1B;EAOD;IACI,qBAAsB;IACtB,sBAAuB;EAC1B;EAED;IACI,uBAAwB;EAC3B;EAED;IACI;MACkB,sBAAO;MAAd,oCAAM;MAAN,iBAAM;MAAS,mCAAe;MAAC,wCAAI;IAC7C;EACJ;AACJ;AAkCD;EACI,eAAgB;EAChB,yBAA0B;AAC7B;AAED;EACI,yBAA0B;AAC7B;AAED;EACI,gBAAiB;EACjB,gBAAiB;EACjB,WAAY;EACZ,eAAgB;EAChB,YAAa;AAChB;AAED;EACI,gBAAiB;EACjB,cAAe;EACf,WAAY;EACZ,eAAgB;AACnB;AAED;EACI,uBAAwB;EACxB,YAAa;EACb,kBAAmB;EACnB,MAAO;EACP,OAAQ;EACR,WAAY;EACZ,YAAa;EACb,cAAe;EACf,aAAc;AACjB;AAED;EACI,sBAAuB;AAC1B;AAED;EACI,gBAAiB;AACpB;AAED;EACW,+BAAU;AACpB;AAED;EACI,WAAY;EACZ,iBAAkB;AACrB;AAED;EACI,WAAY;EACZ,sBAAuB;AAC1B;AAED;EACI,gBAAiB;EACjB,sBAAuB;AAC1B;AAED;EACI,2BAA4B;AAC/B;AAED;EACI,iBAAkB;EAClB,YAAa;EACb,yBAA0B;EAE1B;IACI,cAAe;EAClB;EAED;IACI,kBAAmB;IACnB,WAAY;IACZ,SAAU;IACV,eAAgB;IAChB,eAAgB;EACnB;AACJ;AAED;EACI,yBAA0B;AAC7B;AAED;EACI,cAAe;EACf,cAAe;AAClB;AAED;EACI,gBAAiB;AACpB;AAED;EACI,sBAAuB;EACvB,yBAA0B;EAC1B,sBAAuB;AAC1B;AAED;EACI,yBAA0B;AAC7B;AAGD;;EAEI,YAAa;EACb,sBAAuB;EACvB,sBAAuB;AAC1B;AAED;EACI,YAAa;EACb,sBAAuB;EACvB,sBAAuB;AAC1B;AAED;;;EAGI,YAAa;EACb,sBAAuB;EACvB,sBAAuB;AAC1B;AAED;;;;;;;;;EASI,YAAa;EACb,sBAAuB;EACvB,sBAAuB;AAC1B;AAED;;;EAGI,sBAAuB;AAC1B;AAED;;;;;;;;;EASI,YAAa;EACb,sBAAuB;EACvB,sBAAuB;AAC1B;AAED;EACI,YAAa;EACb,sBAAuB;AAC1B;AAuBD;EACI,eAAgB;EAChB,eAAgB;AAGnB;AAUD;EACI,kBAAmB;AACtB;AAED;EACI,gBAAiB;EACjB,cAAe;EACf,eAAgB;AACnB;AAED;EACI,eAAgB;AACnB;AAED;EACI,WAAY;EACZ,qBAAsB;AACzB;AAED;EACI,eAAgB;EAChB,cAAe;EACf,aAAc;AACjB;AAED;EACI,WAAY;AACf;AAED;EACI,4BAA6B;EAE7B,kBAAmB;AACtB;AAED;EACI,YAAa;EACb,kBAAmB;EACnB,YAAa;EACb,YAAa;EACb,eAAgB;EAChB,iBAAkB;EAClB,sBAAuB;AAC1B;AAGD;EACW,oCAAQ;EAAC,mCAAK;AACxB;AAED;EACI,sBAAuB;EACvB,kDAAmD;EACnD,YAAa;EACb,eAAgB;EAChB,WAAY;EACZ,YAAa;EACb,cAAe;AAClB;AAED;EACI,iBAAkB;AACrB;AAED;EACI,sBAAuB;EACvB,iBAAkB;EAClB,cAAe;AAClB;AAED;EACI,qBAAsB;EACtB,UAAW;EACX,wFAAyF;EACzF,gFAAiF;AACpF;AAED;EACI,sBAAuB;EACvB,kDAAmD;EACnD,YAAa;EACb,eAAgB;EAChB,WAAY;EAEZ,gBAAiB;EACjB,kBAAmB;AACtB;AAED;EACI,iCAAkC;EAClC,kDAAmD;EACnD,eAAgB;EAChB,WAAY;EACZ,gBAAiB;EACjB,kBAAmB;EACnB,2BAA4B;EAC5B,oBAAqB;EACrB,uBAAwB;AAC3B;AAED;EACI,oBAAqB;EACrB,YAAa;AAChB;AAED;EACI,gBAAiB;AACpB;AAED;EACI,kBAAmB;EACnB,WAAY;EACZ,MAAM;AACT;AAED;;EAEI,6BAA8B;AACjC;AAGD;EACI,YAAa;AAChB;AAED;EACI,YAAa;EACb,uBAAwB;AAC3B;AAOD;EACI,iCAAkC;EAClC,YAAa;EACb,0BAA2B;EAC3B,mBAAoB;AACvB;AAED;EACI,sBAAuB;AAC1B;AAMD;EACI,WAAY;AACf;AAED;EACI,cAAe;EACf,0BAA2B;AAC9B;AAMD;EAGI,YAAa;AAChB;AAED;EACI,YAAa;AAEhB;AAMD;EACI,kBAAmB;AACtB;AAED;EACI,sBAAuB;EACvB,2BAA4B;EAC5B,YAAa;EACb,gBAAiB;EACjB,gBAAiB;AACpB;AAED;EACI,kBAAmB;EACnB,YAAa;EACb,yBAA0B;EAC1B,WAAY;EACZ,YAAa;EACb,cAAe;EACf,kBAAmB;AACtB;AAED;EACI,yBAA0B;EAC1B,kBAAmB;EACnB,YAAa;AAChB;AAED;EACI,sBAAuB;EACvB,uBAAwB;EACxB,YAAa;AAChB;AAED;EACI,YAAa;AAChB;AAED;EACI,sBAAuB;EACvB,YAAa;EACb,iBAAkB;AACrB;AAED;EACI,gBAAiB;EACjB,eAAgB;AACnB;AAED;EACI,oBAAqB;AACxB;AAGD;EACI,YAAa;AAChB;AAED;EACI,yBAA0B;EAC1B,gBAAiB;EACjB,iBAAkB;EAClB,UAAW;EACX,YAAa;AAChB;AAGD;EAEI,gBAAiB;AACpB;AAED;EACI,eAAgB;EAChB,eAAgB;EAChB,YAAa;AAChB;AAED;EACI,qBAAsB;EACtB,QAAS;EACT,SAAU;EACV,gBAAiB;EACjB,sBAAuB;EACvB,wBAAyB;EACzB,kCAAmC;EACnC,oBAAqB;EACrB,mCAAoC;EACpC,WAAY;AACf;AAED;EACI,iBAAkB;EAClB,eAAgB;EAChB,UAAW;EACX,iBAAkB;EAClB,YAAa;EACb,uBAAwB;AAC3B;AAED;EACI,sBAAuB;EACvB,wCAAyC;AAC5C;AAED;EACI,eAAgB;AACnB;AAED;EACI,eAAgB;AACnB;AAED;EACI,YAAa;EACb,gBAAiB;AACpB;AAED;EACI,uBAAwB;EACxB,gBAAiB;AACpB;AAED;EACI,eAAgB;EAChB,gBAAiB;EACjB,eAAgB;AACnB;AAED;EACI,aAAc;AACjB;AAED;EACI,gBAAiB;AACpB;AAED;EACW,uCAAI;EAEX;IACI,SAAU;EACb;EAED;IACW,sCAAI;IAAC,aAAI;IAA4B,eAAc;IAAzC,+BAAoB;IAAC,6BAAK;IAC3C,qCAAsC;IAEtC;MACI,SAAU;MACV,OAAQ;MACR,gBAAiB;MACjB,gBAAiB;MACjB,mBAAoB;MACpB,mBAAoB;IACvB;IAED;MACW,aAAI;MAAO,yBAAW;MAAjB,6BAAK;MACjB,mBAAoB;IACvB;EACJ;AACJ;AAKD;EACI,iBAAkB;AACrB;AAMD;EACI,eAAgB;EAChB,SAAU;EACV,UAAW;EACX,WAAY;EACZ,oBAAqB;EACrB,uBAAwB;AAC3B;AAGD;EACI,WAAY;EACZ,YAAa;AAChB;AAED;EACI,kBAAmB;AACtB;AAED;EACI,kBAAmB;AACtB;AAED;;EAGI,qBAAsB;EACtB,aAAc;AAEjB;AAED;EACI,cAAe;EACf,YAAa;EACb,iBAAkB;EAClB,gBAAiB;EACjB,SAAU;EACV,YAAa;AAChB;AAED;EACI,eAAgB;EAChB,qBAAsB;EACtB,oBAAqB;AACxB;AAED;EACI,uBAAwB;EACxB,uBAAwB;EACxB,YAAa;EACb,aAAc;EACd,SAAU;EACV,yBAA0B;EAC1B,kBAAmB;EACnB,QAAS;EACT,UAAW;EACX,gBAAiB;EACjB,aAAc;EACd,cAAe;EACf,YAAa;AAChB;AAED;EACI,aAAc;AACjB;AAED;EACI,YAAa;EACb,cAAe;AAClB;AAED;EACI,sBAAuB;AAC1B;AAED;EACI,uBAAwB;AAC3B;AAOD;EACI,eAAgB;AACnB;AAED;EACI,WAAY;AACf;AAED;EACI,gBAAiB;EAEjB,iBAAkB;EAElB,gBAAiB;EACjB,gBAAiB;AACpB;AAED;EACI,gBAAiB;EACjB,kBAAmB;EACnB,iBAAkB;EAElB,gBAAiB;EACjB,WAAY;AACf;AAED;EACI,mCAAoC;AACvC;AAED;EACI,mCAAoC;AACvC;AAED;EACI,qCAAsC;EACtC,8BAA+B;AAClC;AAED;EACI,aAAc;AACjB;AAED;EACI,WAAY;EACZ,gBAAiB;EACjB,eAAgB;EAChB,eAAgB;EAChB,iBAAkB;EAClB,iBAAkB;EAClB,cAAe;EACf,kBAAmB;EACnB,SAAU;EACV,gBAAiB;AACpB;AAED;EACI,gCAAiC;AACpC;AAED;EACI,cAAe;AAClB;AAED;EACI,aAAc;AACjB;AAED;EACI,cAAe;AAClB;AAED;EACI;IACyB,YAAS;IAAvB,gBAAa;EACvB;EAED;IACyB,YAAS;IAAvB,gBAAa;EACvB;EAED;IACyB,YAAS;IAAvB,gBAAa;EACvB;EAED;IAC0B,YAAS;IAAxB,iBAAc;EACxB;EAED;IAC0B,YAAS;IAAxB,iBAAc;EACxB;EAED;IACW,kBAAQ;IAAS,6BAAK;IAAb,+BAAO;IAAO,gCAAG;IAAC,eAAc;IAAC;MAAA;QAAA,2BAAkB;MAAA;IAAA;EACtE;AACJ;AAED;EACI,UAAW;EAEX,iBAAkB;AACrB;AAED;EACI,UAAW;EAEX,iBAAkB;AACrB;AAED;EACI,UAAW;EAEX,gBAAiB;AACpB;AAED;EACI,uBAAwB;AAC3B;AAED;EACI,YAAa;EACb,SAAU;EACV,eAAgB;EAChB,aAAc;EACd,sBAAuB;EACvB,WAAY;EACZ,UAAW;AACd;AAED;EACI,kBAAmB;EACnB,SAAU;EACV,kBAAmB;AACtB;AAGD;EACI,UAAW;AACd;AAED;EACI,UAAW;AACd;AAED;EACI,2BAA4B;AAC/B;AAED;EACI,WAAY;EACZ,yBAA0B;AAC7B;AAED;EACI,iCAAkC;AACrC;AAED;EACI,yBAA0B;AAC7B;AAED;EACI,sBAAuB;EACvB,eAAgB;AACnB;AAED;EACI,gBAAiB;AACpB;AAED;EACI,qBAAsB;AACzB;AAED;EAEI,iBAAkB;EAClB,YAAa;EACb,2BAA4B;EAC5B,eAAgB;AACnB;AAED;EACI,yBAA0B;EAC1B,aAAc;AACjB;AAED;EACI,WAAY;AACf;AAED;EACI,cAAe;AAClB;AAED;EACI,UAAW;AACd;AAED;EACI,UAAW;AACd;AAED;EACI,iBAAkB;AACrB;AAED;EACI,gBAAiB;EACjB,UAAW;AACd;AAED;EACI,eAAgB;EAChB,YAAa;AAEhB;AAED;EACI,qBAAsB;EACtB,YAAa;AAChB;AAED;EACI,UAAW;AACd;AAED;EACI,YAAa;AAChB;AAED;EACI,gBAAiB;EACjB,aAAc;AACjB;AAED;EACI,kBAAmB;EACnB,mBAAoB;AACvB;AAED;EACI,gBAAiB;EACjB,UAAW;AACd;AAED;EACI,oBAAqB;AACxB;AAED;EACI,yBAA0B;AAC7B;AAED;EACI,WAAY;EACZ,wBAAyB;AAC5B;AAED;EACI,gBAAiB;EACjB,YAAa;AAChB;AAED;EACI,sBAAuB;AAC1B;AAED;EACI,YAAa;EACb,eAAgB;AACnB;AAED;EACI,WAAY;AACf;AAED;EACI,uBAAwB;EACxB,wBAAyB;EACzB,YAAa;EACb,WAAY;EACZ,iBAAkB;EAClB,kBAAmB;EACnB,YAAa;AAChB;AAED;EACI,qBAAsB;EACtB,iBAAkB;EAClB,cAAe;EACf,WAAY;AACf;AAED;EACI,iBAAkB;AACrB;AAED;EACI,iBAAkB;EAClB,eAAgB;EAChB,gBAAiB;EACjB,YAAa;AAChB;AAED;EAC2B,kCAA4B;EAA5C,gBAAe;AACzB;AAED;EACI,gBAAiB;EACjB,iBAAkB;EAClB,eAAgB;EAChB,gCAAiC;AACpC;AAED;EACI,yBAA0B;AAC7B;AAED;EACI,UAAW;EACX,UAAW;AACd;AAED;EACI,UAAW;EACX,UAAW;AACd;AAED;EACI,UAAW;EACX,SAAU;AACb;AAED;EACI,YAAa;EACb,SAAU;AACb;AAED;EACI;IACqD,6HAAS;IAAT,sIAAS;IAAxB,+BAAc;IAAd;MAAA,wFAAc;IAAA;IAAzC,sCAAS;IAAT,kBAAS;IAAC,oCAAgB;EACpC;EAED;IACW,yCAAS;IAAT,oCAAS;EACnB;AACJ;AAED;EACI,iBAAkB;EAClB,UAAW;AACd;AAGD;EACI,kBAAmB;EAEnB;IAE6D,YAAW;IAArC,wBAAQ;IADI,kBAAK;IACR,+CAAgB;IAAhB,sDAAgB;IADjD,+BAAU;IAAC,iFAAc;IAAd;MAAA,6EAAc;IAAA;IAAM,wCAAI;IAAT,uCAAI;IACrC,kBAAW;IAAC,yBAAO;IAAP,2DAAO;IAAC,yBAAU;IAC9B,kBAAmB;IAEnB,kBAAmB;IACnB,UAAW;EACd;EAED;IACI,mBAAoB;EACvB;AACJ;AAGD;EACI,cAAe;AAClB;AAED;EACI;IACI,aAAc;EACjB;EAED;IACI,aAAa;EAChB;AACJ;AAED;EACI,0BAA2B;EAC3B,8BAA+B;EAC/B,kBAAmB;EACnB,YAAa;EACb,aAAc;EACd,kCAAmC;AACtC;AAED;EACI;IACI,+BAAgC;EACnC;EAED;IACI,iCAAkC;EACrC;AACJ;AAED;EACI;IACI,uBAAwB;EAC3B;EAED;IACI,yBAA0B;EAC7B;AACJ;AAED;EACI,eAAgB;AACnB;AAED;EACI,UAAW;EACX,gBAAiB;AACpB;AAED;EACI,qBAAsB;AACzB;AAED;EACI,qBAAsB;AACzB;AAED;EACI,qBAAsB;AACzB;AAED;EACI,qBAAsB;AACzB;AAED;EACI,0BAA2B;AAC9B;AAED;EACI,0BAA2B;AAC9B;AAED;EACI,wBAAyB;AAC5B;AAED;EACI,yBAA0B;AAC7B;AAED;EACI,gBAAiB;EACjB,uBAAwB;EACxB,2BAA4B;EAC5B,mBAAoB;AACvB;AAKD;EACI,SAAU;EACV,cAAe;EACf,aAAc;EACd,wCAAyC;EACzC,SAAU;EACV,gBAAiB;AACpB;AAED;EACI,YAAa;EACb,aAAc;EACd,gBAAiB;AACpB;AAED;EACI,YAAa;EACb,uBAAwB;EACxB,wBAAyB;EACzB,UAAW;EACX,2BAA4B;AAC/B;AAED;EACI,UAAW;AACd;AAED;EACI,mBAAoB;EACpB,kBAAmB;AACtB;AAED;EACI,gBAAiB;AAEpB;AAED;EACgB,uCAAI;EAAT,sCAAI;EACX,aAAc;EACd,gBAAiB;EACjB,qBAAsB;EACtB,yBAA0B;EAE1B;IACW,uCAAI;EACd;EAGD;IACI,YAAa;IACb,WAAY;IACZ,aAAc;IACd,sBAAuB;EAC1B;EAED;IACI,aAAc;IACd,YAAa;IACb,sBAAuB;IACvB,gBAAiB;IAEjB;MACI,cAAe;IAClB;IAED;MACI,OAAQ;MACR,aAAc;MACd,gBAAiB;MACjB,SAAU;MAGV;QACI,YAAa;QACb,oBAAqB;QACrB,gBAAiB;MACpB;MAED;QACI,YAAa;MAChB;IACJ;EACJ;AACJ;AAED;EACI,gBAAiB;EACjB,kBAAmB;EACnB,gBAAiB;AACpB;AAGD;EACI,eAAgB;EAEhB;IACI,eAAgB;EACnB;EAED;IACI,eAAgB;EACnB;EAED;IACI,eAAgB;EACnB;EAED;IACI,gBAAiB;EACpB;EAED;IACI,2BAA4B;EAC/B;AACJ;AAED;EACI;IACI,WAAY;EACf;AACJ;AAED;EACI,yBAA0B;AAC7B;AAED;EACI,8BAA+B;AAClC;AAED;EACI,4BAA6B;AAChC;AAED;EACI,eAAgB;AACnB;AAED;EACI,gBAAiB;AACpB;AAED;EACI,WAAY;AACf;AAED;EACI,kBAAmB;AACtB;AAED;EACW,aAAI;AACd;AAED;EACW,aAAI;AACd;AAED;EACW,cAAK;AACf;AAED;EACI,qBAAsB;EACtB,gBAAiB;EACjB,WAAY;EACZ,aAAc;EACd,eAAgB;EAChB,yCAA0C;EAC1C,6CAA8C;EAC9C,4CAA6C;EAE7C;IACI,sBAAuB;IACvB,cAAe;IACf,eAAgB;IAChB,6CAA8C;IAC9C,4CAA6C;IAC7C,8BAA+B;EAClC;EAED;IACI,WAAY;EACf;EAED;IACI,WAAY;EACf;EAED;IACI,cAAe;IACf,WAAY;EACf;EAED;IACI,cAAe;IACf,kBAAmB;EACtB;EAED;IACI,cAAe;IACf,mBAAoB;EACvB;EAED;IACI,cAAe;IACf,UAAW;EACd;EAED;IACI,cAAe;IACf,mBAAoB;EACvB;EAED;IACI,cAAe;IACf,mBAAoB;EACvB;EAED;IACI,cAAe;IACf,UAAW;EACd;EAED;IACI,cAAe;IACf,mBAAoB;EACvB;EAED;IACI,cAAe;IACf,mBAAoB;EACvB;EAED;IACI,cAAe;IACf,UAAW;EACd;EAED;IACI,cAAe;IACf,mBAAoB;EACvB;EAED;IACI,cAAe;IACf,mBAAoB;EACvB;EAED;IACI,cAAe;IACf,WAAY;EACf;EAED;IACI,wBAAyB;EAC5B;EAED;IACI,yBAA0B;EAC7B;EAED;IACI,gBAAiB;EACpB;EAED;IACI,yBAA0B;EAC7B;EAED;IACI,yBAA0B;EAC7B;EAED;IACI,gBAAiB;EACpB;EAED;IACI,yBAA0B;EAC7B;EAED;IACI,yBAA0B;EAC7B;EAED;IACI,gBAAiB;EACpB;EAED;IACI,yBAA0B;EAC7B;EAED;IACI,yBAA0B;EAC7B;AACJ;AAED;EACW,YAAI;AACd;AAED;EACI,uBAAwB;EACxB,wBAAyB;EACzB,sBAAuB;EAEvB;IACI,wBAAyB;IACzB,sBAAuB;IACvB,OAAQ;EACX;EAED;IACI,kBAAmB;IACnB,uBAAwB;EAC3B;AACJ;AAED;EACW,wBAAO;AACjB;AAED;EACI;IACI,sBAAuB;IACvB,sBAAuB;IACvB,yBAA0B;IAC1B,kBAAmB;IACnB,gBAAiB;IACjB,YAAa;IACb,yBAA0B;IAC1B,iBAAkB;IAClB,4CAA6C;IAC7C,yCAA0C;IAC1C,oCAAqC;EACxC;AACJ;AAED;EAEI,+BAAU;EADgC,oCAAM;EAAN,iBAAM;EAAC,mCAAe;EAA/C,oCAAQ;EAAC,4BAAe;EAAlC,cAAS;EACL,+HAAS;EAAT,sIAAS;AACvB;AAGD;EACI,yBAA0B;EAC1B,iBAAkB;EAIlB;IACI;MACI,gBAAiB;MACjB,MAAO;MACP,WAAY;MACZ,gBAAiB;IACpB;IAID;MACI,gBAAiB;MACjB,SAAU;MACV,WAAY;MACZ,gBAAiB;IACpB;EACJ;AAEJ;AAED;EACI,UAAW;EACX,iBAAkB;AACrB;AAED;EACW,aAAI;EAAS,mBAAY;EAApB,oCAAO;EACnB,kBAAmB;EAEnB;IACuB,eAAc;IAA1B,uCAAW;EACrB;EAED;IACW,yBAAO;IAAC;MAAA;QAAA,yBAAgB;MAAA;IAAA;IAAC;MAAA;QAAA,sCAAa;QAAb,kBAAa;MAAA;IAAA;IAAC;MAAA;QAAA,oCAAsB;MAAA;IAAA;IAClD;MAAA;QAAA,uCAAW;MAAA;IAAA;IAAC;MAAA;QAAA,sBAAa;MAAA;IAAA;IAAC;MAAA;QAAA,oCAAc;MAAA;IAAA;IAAnD;MAAA;QAAA,wCAAU;MAAA;IAAA;EACpB;EAED;IACW,uCAAW;IAAmB,6CAAa;IAAb,wCAAa;IAA/B,gCAAiB;IAEpC;MACW,gCAAiB;MACxB,iBAAkB;IACrB;EACJ;EAED;IACI,iBAAkB;EACrB;AAEJ;AAED;EACI,cAAe;AAClB;AAED;EACI;IACI,kBAAmB;IAEnB;MACI,WAAY;MACZ,kBAAmB;MACnB,MAAO;MACP,SAAU;MACV,UAAW;MACX,4BAA6B;IAChC;IAED;MACI,kBAAmB;MAEnB;QACI,WAAY;QACZ,kBAAmB;QACnB,SAAU;QACV,UAAW;QACX,WAAY;QACZ,2BAA4B;MAC/B;IACJ;EACJ;AACJ;AAED;EACI,YAAa;EACb,mBAAoB;EACpB,0BAA2B;AAC9B;ADhqBC;EAAA,WAAoB;EAApB,eAAoB;EAApB,gBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,gBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,gBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,gBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,gBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,gBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,wBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,gBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,oBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,iBAAoB;EAApB,eAAoB;EAApB,oBAAoB;AAAA;AAApB;EAAA,iBAAoB;EAApB,eAAoB;EAApB,oBAAoB;AAAA;AAApB;EAAA,iBAAoB;EAApB,eAAoB;EAApB,oBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,6BAAoB;EAApB,eAAoB;EAApB,iBAAoB;AAAA;AAApB;EAAA,6BAAoB;EAApB,eAAoB;EAApB,kBAAoB;AAAA;AAApB;EAAA,6BAAoB;EAApB,eAAoB;EAApB,mBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,wBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,sBAAoB;EAApB,eAAoB;EAApB,mBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,wBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,sBAAoB;EAApB,eAAoB;EAApB,mBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,wBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,wBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,kBAAoB;EAApB,eAAoB;EAApB,kBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,mBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,wBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,oBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,sBAAoB;EAApB,eAAoB;EAApB,mBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,sBAAoB;EAApB,eAAoB;EAApB,mBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,iBAAoB;EAApB,eAAoB;AAAA;AA3elB;EACE;IACE,yBAA0B;EAC3B;AACF;AAUD;EACE;IACE,YAAa;EACd;AACF;AAydH;EAAA;IAAA;MAAA,mBAAoB;MAApB,mBAAoB;MAApB,mBAAoB;MAApB,eAAoB;MAApB,eAAoB;MAApB,eAAoB;MAApB,sBAAoB;MAApB,sBAAoB;MAApB,sBAAoB;MAApB,oBAAoB;MAApB,oBAAoB;MAApB,sCAAoB;MAApB,uBAAoB;MAApB,wBAAoB;MAApB,+BAAoB;MAApB,yBAAoB;MAApB,wBAAoB;MAApB,uBAAoB;MAApB,4BAAoB;MAApB,gCAAoB;MAApB,+BAAoB;MAApB,+BAAoB;MAApB,+BAAoB;MAApB,qBAAoB;MAApB,yBAAoB;MAApB,sBAAoB;MAApB,sBAAoB;MAApB,0BAAoB;MAApB,uBAAoB;MAApB,4BAAoB;MAApB,gCAAoB;MAApB,6BAAoB;MAApB,wBAAoB;MAApB,2BAAoB;MAApB,8BAAoB;MAApB,iCAAoB;MAApB,wBAAoB;MAApB,2BAAoB;MAApB,4BAAoB;MAApB,kCAAoB;MAApB,yBAAoB;MAApB,kBAAoB;MAApB,wBAAoB;MAApB,sBAAoB;MAApB,uBAAoB;MAApB,wBAAoB;MAApB,oBAAoB;MAApB,qBAAoB;MAApB,sBAAoB;MAApB,mBAAoB;MAApB,yBAAoB;MAApB,+BAAoB;MAApB,4BAAoB;MAApB,8BAAoB;MAApB,2BAAoB;MAApB,iCAAoB;MAApB,+BAAoB;MAApB,gCAAoB;MAApB,iCAAoB;MAApB,6BAAoB;MAApB,8BAAoB;MAApB,+BAAoB;MAApB,4BAAoB;MAApB,sBAAoB;MAApB,kBAAoB;MAApB,+BAAoB;MAApB,4BAAoB;MAApB,gBAAoB;IAAA;EAAA;AAAA","sourcesContent":[null,"@layer theme, base, components, utilities;\n\n@layer theme {\n  @theme default {\n    --font-sans:\n      ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\",\n      \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    --font-serif: ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif;\n    --font-mono:\n      ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\n      \"Courier New\", monospace;\n\n    --color-red-50: oklch(97.1% 0.013 17.38);\n    --color-red-100: oklch(93.6% 0.032 17.717);\n    --color-red-200: oklch(88.5% 0.062 18.334);\n    --color-red-300: oklch(80.8% 0.114 19.571);\n    --color-red-400: oklch(70.4% 0.191 22.216);\n    --color-red-500: oklch(63.7% 0.237 25.331);\n    --color-red-600: oklch(57.7% 0.245 27.325);\n    --color-red-700: oklch(50.5% 0.213 27.518);\n    --color-red-800: oklch(44.4% 0.177 26.899);\n    --color-red-900: oklch(39.6% 0.141 25.723);\n    --color-red-950: oklch(25.8% 0.092 26.042);\n\n    --color-orange-50: oklch(98% 0.016 73.684);\n    --color-orange-100: oklch(95.4% 0.038 75.164);\n    --color-orange-200: oklch(90.1% 0.076 70.697);\n    --color-orange-300: oklch(83.7% 0.128 66.29);\n    --color-orange-400: oklch(75% 0.183 55.934);\n    --color-orange-500: oklch(70.5% 0.213 47.604);\n    --color-orange-600: oklch(64.6% 0.222 41.116);\n    --color-orange-700: oklch(55.3% 0.195 38.402);\n    --color-orange-800: oklch(47% 0.157 37.304);\n    --color-orange-900: oklch(40.8% 0.123 38.172);\n    --color-orange-950: oklch(26.6% 0.079 36.259);\n\n    --color-amber-50: oklch(98.7% 0.022 95.277);\n    --color-amber-100: oklch(96.2% 0.059 95.617);\n    --color-amber-200: oklch(92.4% 0.12 95.746);\n    --color-amber-300: oklch(87.9% 0.169 91.605);\n    --color-amber-400: oklch(82.8% 0.189 84.429);\n    --color-amber-500: oklch(76.9% 0.188 70.08);\n    --color-amber-600: oklch(66.6% 0.179 58.318);\n    --color-amber-700: oklch(55.5% 0.163 48.998);\n    --color-amber-800: oklch(47.3% 0.137 46.201);\n    --color-amber-900: oklch(41.4% 0.112 45.904);\n    --color-amber-950: oklch(27.9% 0.077 45.635);\n\n    --color-yellow-50: oklch(98.7% 0.026 102.212);\n    --color-yellow-100: oklch(97.3% 0.071 103.193);\n    --color-yellow-200: oklch(94.5% 0.129 101.54);\n    --color-yellow-300: oklch(90.5% 0.182 98.111);\n    --color-yellow-400: oklch(85.2% 0.199 91.936);\n    --color-yellow-500: oklch(79.5% 0.184 86.047);\n    --color-yellow-600: oklch(68.1% 0.162 75.834);\n    --color-yellow-700: oklch(55.4% 0.135 66.442);\n    --color-yellow-800: oklch(47.6% 0.114 61.907);\n    --color-yellow-900: oklch(42.1% 0.095 57.708);\n    --color-yellow-950: oklch(28.6% 0.066 53.813);\n\n    --color-lime-50: oklch(98.6% 0.031 120.757);\n    --color-lime-100: oklch(96.7% 0.067 122.328);\n    --color-lime-200: oklch(93.8% 0.127 124.321);\n    --color-lime-300: oklch(89.7% 0.196 126.665);\n    --color-lime-400: oklch(84.1% 0.238 128.85);\n    --color-lime-500: oklch(76.8% 0.233 130.85);\n    --color-lime-600: oklch(64.8% 0.2 131.684);\n    --color-lime-700: oklch(53.2% 0.157 131.589);\n    --color-lime-800: oklch(45.3% 0.124 130.933);\n    --color-lime-900: oklch(40.5% 0.101 131.063);\n    --color-lime-950: oklch(27.4% 0.072 132.109);\n\n    --color-green-50: oklch(98.2% 0.018 155.826);\n    --color-green-100: oklch(96.2% 0.044 156.743);\n    --color-green-200: oklch(92.5% 0.084 155.995);\n    --color-green-300: oklch(87.1% 0.15 154.449);\n    --color-green-400: oklch(79.2% 0.209 151.711);\n    --color-green-500: oklch(72.3% 0.219 149.579);\n    --color-green-600: oklch(62.7% 0.194 149.214);\n    --color-green-700: oklch(52.7% 0.154 150.069);\n    --color-green-800: oklch(44.8% 0.119 151.328);\n    --color-green-900: oklch(39.3% 0.095 152.535);\n    --color-green-950: oklch(26.6% 0.065 152.934);\n\n    --color-emerald-50: oklch(97.9% 0.021 166.113);\n    --color-emerald-100: oklch(95% 0.052 163.051);\n    --color-emerald-200: oklch(90.5% 0.093 164.15);\n    --color-emerald-300: oklch(84.5% 0.143 164.978);\n    --color-emerald-400: oklch(76.5% 0.177 163.223);\n    --color-emerald-500: oklch(69.6% 0.17 162.48);\n    --color-emerald-600: oklch(59.6% 0.145 163.225);\n    --color-emerald-700: oklch(50.8% 0.118 165.612);\n    --color-emerald-800: oklch(43.2% 0.095 166.913);\n    --color-emerald-900: oklch(37.8% 0.077 168.94);\n    --color-emerald-950: oklch(26.2% 0.051 172.552);\n\n    --color-teal-50: oklch(98.4% 0.014 180.72);\n    --color-teal-100: oklch(95.3% 0.051 180.801);\n    --color-teal-200: oklch(91% 0.096 180.426);\n    --color-teal-300: oklch(85.5% 0.138 181.071);\n    --color-teal-400: oklch(77.7% 0.152 181.912);\n    --color-teal-500: oklch(70.4% 0.14 182.503);\n    --color-teal-600: oklch(60% 0.118 184.704);\n    --color-teal-700: oklch(51.1% 0.096 186.391);\n    --color-teal-800: oklch(43.7% 0.078 188.216);\n    --color-teal-900: oklch(38.6% 0.063 188.416);\n    --color-teal-950: oklch(27.7% 0.046 192.524);\n\n    --color-cyan-50: oklch(98.4% 0.019 200.873);\n    --color-cyan-100: oklch(95.6% 0.045 203.388);\n    --color-cyan-200: oklch(91.7% 0.08 205.041);\n    --color-cyan-300: oklch(86.5% 0.127 207.078);\n    --color-cyan-400: oklch(78.9% 0.154 211.53);\n    --color-cyan-500: oklch(71.5% 0.143 215.221);\n    --color-cyan-600: oklch(60.9% 0.126 221.723);\n    --color-cyan-700: oklch(52% 0.105 223.128);\n    --color-cyan-800: oklch(45% 0.085 224.283);\n    --color-cyan-900: oklch(39.8% 0.07 227.392);\n    --color-cyan-950: oklch(30.2% 0.056 229.695);\n\n    --color-sky-50: oklch(97.7% 0.013 236.62);\n    --color-sky-100: oklch(95.1% 0.026 236.824);\n    --color-sky-200: oklch(90.1% 0.058 230.902);\n    --color-sky-300: oklch(82.8% 0.111 230.318);\n    --color-sky-400: oklch(74.6% 0.16 232.661);\n    --color-sky-500: oklch(68.5% 0.169 237.323);\n    --color-sky-600: oklch(58.8% 0.158 241.966);\n    --color-sky-700: oklch(50% 0.134 242.749);\n    --color-sky-800: oklch(44.3% 0.11 240.79);\n    --color-sky-900: oklch(39.1% 0.09 240.876);\n    --color-sky-950: oklch(29.3% 0.066 243.157);\n\n    --color-blue-50: oklch(97% 0.014 254.604);\n    --color-blue-100: oklch(93.2% 0.032 255.585);\n    --color-blue-200: oklch(88.2% 0.059 254.128);\n    --color-blue-300: oklch(80.9% 0.105 251.813);\n    --color-blue-400: oklch(70.7% 0.165 254.624);\n    --color-blue-500: oklch(62.3% 0.214 259.815);\n    --color-blue-600: oklch(54.6% 0.245 262.881);\n    --color-blue-700: oklch(48.8% 0.243 264.376);\n    --color-blue-800: oklch(42.4% 0.199 265.638);\n    --color-blue-900: oklch(37.9% 0.146 265.522);\n    --color-blue-950: oklch(28.2% 0.091 267.935);\n\n    --color-indigo-50: oklch(96.2% 0.018 272.314);\n    --color-indigo-100: oklch(93% 0.034 272.788);\n    --color-indigo-200: oklch(87% 0.065 274.039);\n    --color-indigo-300: oklch(78.5% 0.115 274.713);\n    --color-indigo-400: oklch(67.3% 0.182 276.935);\n    --color-indigo-500: oklch(58.5% 0.233 277.117);\n    --color-indigo-600: oklch(51.1% 0.262 276.966);\n    --color-indigo-700: oklch(45.7% 0.24 277.023);\n    --color-indigo-800: oklch(39.8% 0.195 277.366);\n    --color-indigo-900: oklch(35.9% 0.144 278.697);\n    --color-indigo-950: oklch(25.7% 0.09 281.288);\n\n    --color-violet-50: oklch(96.9% 0.016 293.756);\n    --color-violet-100: oklch(94.3% 0.029 294.588);\n    --color-violet-200: oklch(89.4% 0.057 293.283);\n    --color-violet-300: oklch(81.1% 0.111 293.571);\n    --color-violet-400: oklch(70.2% 0.183 293.541);\n    --color-violet-500: oklch(60.6% 0.25 292.717);\n    --color-violet-600: oklch(54.1% 0.281 293.009);\n    --color-violet-700: oklch(49.1% 0.27 292.581);\n    --color-violet-800: oklch(43.2% 0.232 292.759);\n    --color-violet-900: oklch(38% 0.189 293.745);\n    --color-violet-950: oklch(28.3% 0.141 291.089);\n\n    --color-purple-50: oklch(97.7% 0.014 308.299);\n    --color-purple-100: oklch(94.6% 0.033 307.174);\n    --color-purple-200: oklch(90.2% 0.063 306.703);\n    --color-purple-300: oklch(82.7% 0.119 306.383);\n    --color-purple-400: oklch(71.4% 0.203 305.504);\n    --color-purple-500: oklch(62.7% 0.265 303.9);\n    --color-purple-600: oklch(55.8% 0.288 302.321);\n    --color-purple-700: oklch(49.6% 0.265 301.924);\n    --color-purple-800: oklch(43.8% 0.218 303.724);\n    --color-purple-900: oklch(38.1% 0.176 304.987);\n    --color-purple-950: oklch(29.1% 0.149 302.717);\n\n    --color-fuchsia-50: oklch(97.7% 0.017 320.058);\n    --color-fuchsia-100: oklch(95.2% 0.037 318.852);\n    --color-fuchsia-200: oklch(90.3% 0.076 319.62);\n    --color-fuchsia-300: oklch(83.3% 0.145 321.434);\n    --color-fuchsia-400: oklch(74% 0.238 322.16);\n    --color-fuchsia-500: oklch(66.7% 0.295 322.15);\n    --color-fuchsia-600: oklch(59.1% 0.293 322.896);\n    --color-fuchsia-700: oklch(51.8% 0.253 323.949);\n    --color-fuchsia-800: oklch(45.2% 0.211 324.591);\n    --color-fuchsia-900: oklch(40.1% 0.17 325.612);\n    --color-fuchsia-950: oklch(29.3% 0.136 325.661);\n\n    --color-pink-50: oklch(97.1% 0.014 343.198);\n    --color-pink-100: oklch(94.8% 0.028 342.258);\n    --color-pink-200: oklch(89.9% 0.061 343.231);\n    --color-pink-300: oklch(82.3% 0.12 346.018);\n    --color-pink-400: oklch(71.8% 0.202 349.761);\n    --color-pink-500: oklch(65.6% 0.241 354.308);\n    --color-pink-600: oklch(59.2% 0.249 0.584);\n    --color-pink-700: oklch(52.5% 0.223 3.958);\n    --color-pink-800: oklch(45.9% 0.187 3.815);\n    --color-pink-900: oklch(40.8% 0.153 2.432);\n    --color-pink-950: oklch(28.4% 0.109 3.907);\n\n    --color-rose-50: oklch(96.9% 0.015 12.422);\n    --color-rose-100: oklch(94.1% 0.03 12.58);\n    --color-rose-200: oklch(89.2% 0.058 10.001);\n    --color-rose-300: oklch(81% 0.117 11.638);\n    --color-rose-400: oklch(71.2% 0.194 13.428);\n    --color-rose-500: oklch(64.5% 0.246 16.439);\n    --color-rose-600: oklch(58.6% 0.253 17.585);\n    --color-rose-700: oklch(51.4% 0.222 16.935);\n    --color-rose-800: oklch(45.5% 0.188 13.697);\n    --color-rose-900: oklch(41% 0.159 10.272);\n    --color-rose-950: oklch(27.1% 0.105 12.094);\n\n    --color-slate-50: oklch(98.4% 0.003 247.858);\n    --color-slate-100: oklch(96.8% 0.007 247.896);\n    --color-slate-200: oklch(92.9% 0.013 255.508);\n    --color-slate-300: oklch(86.9% 0.022 252.894);\n    --color-slate-400: oklch(70.4% 0.04 256.788);\n    --color-slate-500: oklch(55.4% 0.046 257.417);\n    --color-slate-600: oklch(44.6% 0.043 257.281);\n    --color-slate-700: oklch(37.2% 0.044 257.287);\n    --color-slate-800: oklch(27.9% 0.041 260.031);\n    --color-slate-900: oklch(20.8% 0.042 265.755);\n    --color-slate-950: oklch(12.9% 0.042 264.695);\n\n    --color-gray-50: oklch(98.5% 0.002 247.839);\n    --color-gray-100: oklch(96.7% 0.003 264.542);\n    --color-gray-200: oklch(92.8% 0.006 264.531);\n    --color-gray-300: oklch(87.2% 0.01 258.338);\n    --color-gray-400: oklch(70.7% 0.022 261.325);\n    --color-gray-500: oklch(55.1% 0.027 264.364);\n    --color-gray-600: oklch(44.6% 0.03 256.802);\n    --color-gray-700: oklch(37.3% 0.034 259.733);\n    --color-gray-800: oklch(27.8% 0.033 256.848);\n    --color-gray-900: oklch(21% 0.034 264.665);\n    --color-gray-950: oklch(13% 0.028 261.692);\n\n    --color-zinc-50: oklch(98.5% 0 0);\n    --color-zinc-100: oklch(96.7% 0.001 286.375);\n    --color-zinc-200: oklch(92% 0.004 286.32);\n    --color-zinc-300: oklch(87.1% 0.006 286.286);\n    --color-zinc-400: oklch(70.5% 0.015 286.067);\n    --color-zinc-500: oklch(55.2% 0.016 285.938);\n    --color-zinc-600: oklch(44.2% 0.017 285.786);\n    --color-zinc-700: oklch(37% 0.013 285.805);\n    --color-zinc-800: oklch(27.4% 0.006 286.033);\n    --color-zinc-900: oklch(21% 0.006 285.885);\n    --color-zinc-950: oklch(14.1% 0.005 285.823);\n\n    --color-neutral-50: oklch(98.5% 0 0);\n    --color-neutral-100: oklch(97% 0 0);\n    --color-neutral-200: oklch(92.2% 0 0);\n    --color-neutral-300: oklch(87% 0 0);\n    --color-neutral-400: oklch(70.8% 0 0);\n    --color-neutral-500: oklch(55.6% 0 0);\n    --color-neutral-600: oklch(43.9% 0 0);\n    --color-neutral-700: oklch(37.1% 0 0);\n    --color-neutral-800: oklch(26.9% 0 0);\n    --color-neutral-900: oklch(20.5% 0 0);\n    --color-neutral-950: oklch(14.5% 0 0);\n\n    --color-stone-50: oklch(98.5% 0.001 106.423);\n    --color-stone-100: oklch(97% 0.001 106.424);\n    --color-stone-200: oklch(92.3% 0.003 48.717);\n    --color-stone-300: oklch(86.9% 0.005 56.366);\n    --color-stone-400: oklch(70.9% 0.01 56.259);\n    --color-stone-500: oklch(55.3% 0.013 58.071);\n    --color-stone-600: oklch(44.4% 0.011 73.639);\n    --color-stone-700: oklch(37.4% 0.01 67.558);\n    --color-stone-800: oklch(26.8% 0.007 34.298);\n    --color-stone-900: oklch(21.6% 0.006 56.043);\n    --color-stone-950: oklch(14.7% 0.004 49.25);\n\n    --color-mauve-50: oklch(98.5% 0 0);\n    --color-mauve-100: oklch(96% 0.003 325.6);\n    --color-mauve-200: oklch(92.2% 0.005 325.62);\n    --color-mauve-300: oklch(86.5% 0.012 325.68);\n    --color-mauve-400: oklch(71.1% 0.019 323.02);\n    --color-mauve-500: oklch(54.2% 0.034 322.5);\n    --color-mauve-600: oklch(43.5% 0.029 321.78);\n    --color-mauve-700: oklch(36.4% 0.029 323.89);\n    --color-mauve-800: oklch(26.3% 0.024 320.12);\n    --color-mauve-900: oklch(21.2% 0.019 322.12);\n    --color-mauve-950: oklch(14.5% 0.008 326);\n\n    --color-olive-50: oklch(98.8% 0.003 106.5);\n    --color-olive-100: oklch(96.6% 0.005 106.5);\n    --color-olive-200: oklch(93% 0.007 106.5);\n    --color-olive-300: oklch(88% 0.011 106.6);\n    --color-olive-400: oklch(73.7% 0.021 106.9);\n    --color-olive-500: oklch(58% 0.031 107.3);\n    --color-olive-600: oklch(46.6% 0.025 107.3);\n    --color-olive-700: oklch(39.4% 0.023 107.4);\n    --color-olive-800: oklch(28.6% 0.016 107.4);\n    --color-olive-900: oklch(22.8% 0.013 107.4);\n    --color-olive-950: oklch(15.3% 0.006 107.1);\n\n    --color-mist-50: oklch(98.7% 0.002 197.1);\n    --color-mist-100: oklch(96.3% 0.002 197.1);\n    --color-mist-200: oklch(92.5% 0.005 214.3);\n    --color-mist-300: oklch(87.2% 0.007 219.6);\n    --color-mist-400: oklch(72.3% 0.014 214.4);\n    --color-mist-500: oklch(56% 0.021 213.5);\n    --color-mist-600: oklch(45% 0.017 213.2);\n    --color-mist-700: oklch(37.8% 0.015 216);\n    --color-mist-800: oklch(27.5% 0.011 216.9);\n    --color-mist-900: oklch(21.8% 0.008 223.9);\n    --color-mist-950: oklch(14.8% 0.004 228.8);\n\n    --color-taupe-50: oklch(98.6% 0.002 67.8);\n    --color-taupe-100: oklch(96% 0.002 17.2);\n    --color-taupe-200: oklch(92.2% 0.005 34.3);\n    --color-taupe-300: oklch(86.8% 0.007 39.5);\n    --color-taupe-400: oklch(71.4% 0.014 41.2);\n    --color-taupe-500: oklch(54.7% 0.021 43.1);\n    --color-taupe-600: oklch(43.8% 0.017 39.3);\n    --color-taupe-700: oklch(36.7% 0.016 35.7);\n    --color-taupe-800: oklch(26.8% 0.011 36.5);\n    --color-taupe-900: oklch(21.4% 0.009 43.1);\n    --color-taupe-950: oklch(14.7% 0.004 49.3);\n\n    --color-black: #000;\n    --color-white: #fff;\n\n    --spacing: 0.25rem;\n\n    --breakpoint-sm: 40rem;\n    --breakpoint-md: 48rem;\n    --breakpoint-lg: 64rem;\n    --breakpoint-xl: 80rem;\n    --breakpoint-2xl: 96rem;\n\n    --container-3xs: 16rem;\n    --container-2xs: 18rem;\n    --container-xs: 20rem;\n    --container-sm: 24rem;\n    --container-md: 28rem;\n    --container-lg: 32rem;\n    --container-xl: 36rem;\n    --container-2xl: 42rem;\n    --container-3xl: 48rem;\n    --container-4xl: 56rem;\n    --container-5xl: 64rem;\n    --container-6xl: 72rem;\n    --container-7xl: 80rem;\n\n    --text-xs: 0.75rem;\n    --text-xs--line-height: calc(1 / 0.75);\n    --text-sm: 0.875rem;\n    --text-sm--line-height: calc(1.25 / 0.875);\n    --text-base: 1rem;\n    --text-base--line-height: calc(1.5 / 1);\n    --text-lg: 1.125rem;\n    --text-lg--line-height: calc(1.75 / 1.125);\n    --text-xl: 1.25rem;\n    --text-xl--line-height: calc(1.75 / 1.25);\n    --text-2xl: 1.5rem;\n    --text-2xl--line-height: calc(2 / 1.5);\n    --text-3xl: 1.875rem;\n    --text-3xl--line-height: calc(2.25 / 1.875);\n    --text-4xl: 2.25rem;\n    --text-4xl--line-height: calc(2.5 / 2.25);\n    --text-5xl: 3rem;\n    --text-5xl--line-height: 1;\n    --text-6xl: 3.75rem;\n    --text-6xl--line-height: 1;\n    --text-7xl: 4.5rem;\n    --text-7xl--line-height: 1;\n    --text-8xl: 6rem;\n    --text-8xl--line-height: 1;\n    --text-9xl: 8rem;\n    --text-9xl--line-height: 1;\n\n    --font-weight-thin: 100;\n    --font-weight-extralight: 200;\n    --font-weight-light: 300;\n    --font-weight-normal: 400;\n    --font-weight-medium: 500;\n    --font-weight-semibold: 600;\n    --font-weight-bold: 700;\n    --font-weight-extrabold: 800;\n    --font-weight-black: 900;\n\n    --tracking-tighter: -0.05em;\n    --tracking-tight: -0.025em;\n    --tracking-normal: 0em;\n    --tracking-wide: 0.025em;\n    --tracking-wider: 0.05em;\n    --tracking-widest: 0.1em;\n\n    --leading-tight: 1.25;\n    --leading-snug: 1.375;\n    --leading-normal: 1.5;\n    --leading-relaxed: 1.625;\n    --leading-loose: 2;\n\n    --radius-xs: 0.125rem;\n    --radius-sm: 0.25rem;\n    --radius-md: 0.375rem;\n    --radius-lg: 0.5rem;\n    --radius-xl: 0.75rem;\n    --radius-2xl: 1rem;\n    --radius-3xl: 1.5rem;\n    --radius-4xl: 2rem;\n\n    --shadow-2xs: 0 1px rgb(0 0 0 / 0.05);\n    --shadow-xs: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n    --shadow-sm: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-md:\n      0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n    --shadow-lg:\n      0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n    --shadow-xl:\n      0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n    --shadow-2xl: 0 25px 50px -12px rgb(0 0 0 / 0.25);\n\n    --inset-shadow-2xs: inset 0 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-xs: inset 0 1px 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-sm: inset 0 2px 4px rgb(0 0 0 / 0.05);\n\n    --drop-shadow-xs: 0 1px 1px rgb(0 0 0 / 0.05);\n    --drop-shadow-sm: 0 1px 2px rgb(0 0 0 / 0.15);\n    --drop-shadow-md: 0 3px 3px rgb(0 0 0 / 0.12);\n    --drop-shadow-lg: 0 4px 4px rgb(0 0 0 / 0.15);\n    --drop-shadow-xl: 0 9px 7px rgb(0 0 0 / 0.1);\n    --drop-shadow-2xl: 0 25px 25px rgb(0 0 0 / 0.15);\n\n    --text-shadow-2xs: 0px 1px 0px rgb(0 0 0 / 0.15);\n    --text-shadow-xs: 0px 1px 1px rgb(0 0 0 / 0.2);\n    --text-shadow-sm:\n      0px 1px 0px rgb(0 0 0 / 0.075), 0px 1px 1px rgb(0 0 0 / 0.075),\n      0px 2px 2px rgb(0 0 0 / 0.075);\n    --text-shadow-md:\n      0px 1px 1px rgb(0 0 0 / 0.1), 0px 1px 2px rgb(0 0 0 / 0.1),\n      0px 2px 4px rgb(0 0 0 / 0.1);\n    --text-shadow-lg:\n      0px 1px 2px rgb(0 0 0 / 0.1), 0px 3px 2px rgb(0 0 0 / 0.1),\n      0px 4px 8px rgb(0 0 0 / 0.1);\n\n    --ease-in: cubic-bezier(0.4, 0, 1, 1);\n    --ease-out: cubic-bezier(0, 0, 0.2, 1);\n    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);\n\n    --animate-spin: spin 1s linear infinite;\n    --animate-ping: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n    --animate-bounce: bounce 1s infinite;\n\n    @keyframes spin {\n      to {\n        transform: rotate(360deg);\n      }\n    }\n\n    @keyframes ping {\n      75%,\n      100% {\n        transform: scale(2);\n        opacity: 0;\n      }\n    }\n\n    @keyframes pulse {\n      50% {\n        opacity: 0.5;\n      }\n    }\n\n    @keyframes bounce {\n      0%,\n      100% {\n        transform: translateY(-25%);\n        animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n      }\n\n      50% {\n        transform: none;\n        animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n      }\n    }\n\n    --blur-xs: 4px;\n    --blur-sm: 8px;\n    --blur-md: 12px;\n    --blur-lg: 16px;\n    --blur-xl: 24px;\n    --blur-2xl: 40px;\n    --blur-3xl: 64px;\n\n    --perspective-dramatic: 100px;\n    --perspective-near: 300px;\n    --perspective-normal: 500px;\n    --perspective-midrange: 800px;\n    --perspective-distant: 1200px;\n\n    --aspect-video: 16 / 9;\n\n    --default-transition-duration: 150ms;\n    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    --default-font-family: --theme(--font-sans, initial);\n    --default-font-feature-settings: --theme(\n      --font-sans--font-feature-settings,\n      initial\n    );\n    --default-font-variation-settings: --theme(\n      --font-sans--font-variation-settings,\n      initial\n    );\n    --default-mono-font-family: --theme(--font-mono, initial);\n    --default-mono-font-feature-settings: --theme(\n      --font-mono--font-feature-settings,\n      initial\n    );\n    --default-mono-font-variation-settings: --theme(\n      --font-mono--font-variation-settings,\n      initial\n    );\n  }\n\n  /* Deprecated */\n  @theme default inline reference {\n    --blur: 8px;\n    --shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-inner: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);\n    --drop-shadow: 0 1px 2px rgb(0 0 0 / 0.1), 0 1px 1px rgb(0 0 0 / 0.06);\n    --radius: 0.25rem;\n    --max-width-prose: 65ch;\n  }\n}\n\n@layer base {\n  /*\n  1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n  2. Remove default margins and padding\n  3. Reset all borders.\n*/\n\n  *,\n  ::after,\n  ::before,\n  ::backdrop,\n  ::file-selector-button {\n    box-sizing: border-box; /* 1 */\n    margin: 0; /* 2 */\n    padding: 0; /* 2 */\n    border: 0 solid; /* 3 */\n  }\n\n  /*\n  1. Use a consistent sensible line-height in all browsers.\n  2. Prevent adjustments of font size after orientation changes in iOS.\n  3. Use a more readable tab size.\n  4. Use the user's configured `sans` font-family by default.\n  5. Use the user's configured `sans` font-feature-settings by default.\n  6. Use the user's configured `sans` font-variation-settings by default.\n  7. Disable tap highlights on iOS.\n*/\n\n  html,\n  :host {\n    line-height: 1.5; /* 1 */\n    -webkit-text-size-adjust: 100%; /* 2 */\n    tab-size: 4; /* 3 */\n    font-family: --theme(\n      --default-font-family,\n      ui-sans-serif,\n      system-ui,\n      sans-serif,\n      \"Apple Color Emoji\",\n      \"Segoe UI Emoji\",\n      \"Segoe UI Symbol\",\n      \"Noto Color Emoji\"\n    ); /* 4 */\n    font-feature-settings: --theme(\n      --default-font-feature-settings,\n      normal\n    ); /* 5 */\n    font-variation-settings: --theme(\n      --default-font-variation-settings,\n      normal\n    ); /* 6 */\n    -webkit-tap-highlight-color: transparent; /* 7 */\n  }\n\n  /*\n  1. Add the correct height in Firefox.\n  2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n  3. Reset the default border style to a 1px solid border.\n*/\n\n  hr {\n    height: 0; /* 1 */\n    color: inherit; /* 2 */\n    border-top-width: 1px; /* 3 */\n  }\n\n  /*\n  Add the correct text decoration in Chrome, Edge, and Safari.\n*/\n\n  abbr:where([title]) {\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n  }\n\n  /*\n  Remove the default font size and weight for headings.\n*/\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-size: inherit;\n    font-weight: inherit;\n  }\n\n  /*\n  Reset links to optimize for opt-in styling instead of opt-out.\n*/\n\n  a {\n    color: inherit;\n    -webkit-text-decoration: inherit;\n    text-decoration: inherit;\n  }\n\n  /*\n  Add the correct font weight in Edge and Safari.\n*/\n\n  b,\n  strong {\n    font-weight: bolder;\n  }\n\n  /*\n  1. Use the user's configured `mono` font-family by default.\n  2. Use the user's configured `mono` font-feature-settings by default.\n  3. Use the user's configured `mono` font-variation-settings by default.\n  4. Correct the odd `em` font sizing in all browsers.\n*/\n\n  code,\n  kbd,\n  samp,\n  pre {\n    font-family: --theme(\n      --default-mono-font-family,\n      ui-monospace,\n      SFMono-Regular,\n      Menlo,\n      Monaco,\n      Consolas,\n      \"Liberation Mono\",\n      \"Courier New\",\n      monospace\n    ); /* 1 */\n    font-feature-settings: --theme(\n      --default-mono-font-feature-settings,\n      normal\n    ); /* 2 */\n    font-variation-settings: --theme(\n      --default-mono-font-variation-settings,\n      normal\n    ); /* 3 */\n    font-size: 1em; /* 4 */\n  }\n\n  /*\n  Add the correct font size in all browsers.\n*/\n\n  small {\n    font-size: 80%;\n  }\n\n  /*\n  Prevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n\n  sub {\n    bottom: -0.25em;\n  }\n\n  sup {\n    top: -0.5em;\n  }\n\n  /*\n  1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n  2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n  3. Remove gaps between table borders by default.\n*/\n\n  table {\n    text-indent: 0; /* 1 */\n    border-color: inherit; /* 2 */\n    border-collapse: collapse; /* 3 */\n  }\n\n  /*\n  Use the modern Firefox focus style for all focusable elements.\n*/\n\n  :-moz-focusring {\n    outline: auto;\n  }\n\n  /*\n  Add the correct vertical alignment in Chrome and Firefox.\n*/\n\n  progress {\n    vertical-align: baseline;\n  }\n\n  /*\n  Add the correct display in Chrome and Safari.\n*/\n\n  summary {\n    display: list-item;\n  }\n\n  /*\n  Make lists unstyled by default.\n*/\n\n  ol,\n  ul,\n  menu {\n    list-style: none;\n  }\n\n  /*\n  1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n  2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n      This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\n  img,\n  svg,\n  video,\n  canvas,\n  audio,\n  iframe,\n  embed,\n  object {\n    display: block; /* 1 */\n    vertical-align: middle; /* 2 */\n  }\n\n  /*\n  Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\n  img,\n  video {\n    max-width: 100%;\n    height: auto;\n  }\n\n  /*\n  1. Inherit font styles in all browsers.\n  2. Remove border radius in all browsers.\n  3. Remove background color in all browsers.\n  4. Ensure consistent opacity for disabled states in all browsers.\n*/\n\n  button,\n  input,\n  select,\n  optgroup,\n  textarea,\n  ::file-selector-button {\n    font: inherit; /* 1 */\n    font-feature-settings: inherit; /* 1 */\n    font-variation-settings: inherit; /* 1 */\n    letter-spacing: inherit; /* 1 */\n    color: inherit; /* 1 */\n    border-radius: 0; /* 2 */\n    background-color: transparent; /* 3 */\n    opacity: 1; /* 4 */\n  }\n\n  /*\n  Restore default font weight.\n*/\n\n  :where(select:is([multiple], [size])) optgroup {\n    font-weight: bolder;\n  }\n\n  /*\n  Restore indentation.\n*/\n\n  :where(select:is([multiple], [size])) optgroup option {\n    padding-inline-start: 20px;\n  }\n\n  /*\n  Restore space after button.\n*/\n\n  ::file-selector-button {\n    margin-inline-end: 4px;\n  }\n\n  /*\n  Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n*/\n\n  ::placeholder {\n    opacity: 1;\n  }\n\n  /*\n  Set the default placeholder color to a semi-transparent version of the current text color in browsers that do not\n  crash when using `color-mix(…)` with `currentcolor`. (https://github.com/tailwindlabs/tailwindcss/issues/17194)\n*/\n\n  @supports (not (-webkit-appearance: -apple-pay-button)) /* Not Safari */ or\n    (contain-intrinsic-size: 1px) /* Safari 17+ */ {\n    ::placeholder {\n      color: color-mix(in oklab, currentcolor 50%, transparent);\n    }\n  }\n\n  /*\n  Prevent resizing textareas horizontally by default.\n*/\n\n  textarea {\n    resize: vertical;\n  }\n\n  /*\n  Remove the inner padding in Chrome and Safari on macOS.\n*/\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  /*\n  1. Ensure date/time inputs have the same height when empty in iOS Safari.\n  2. Ensure text alignment can be changed on date/time inputs in iOS Safari.\n*/\n\n  ::-webkit-date-and-time-value {\n    min-height: 1lh; /* 1 */\n    text-align: inherit; /* 2 */\n  }\n\n  /*\n  Prevent height from changing on date/time inputs in macOS Safari when the input is set to `display: block`.\n*/\n\n  ::-webkit-datetime-edit {\n    display: inline-flex;\n  }\n\n  /*\n  Remove excess padding from pseudo-elements in date/time inputs to ensure consistent height across browsers.\n*/\n\n  ::-webkit-datetime-edit-fields-wrapper {\n    padding: 0;\n  }\n\n  ::-webkit-datetime-edit,\n  ::-webkit-datetime-edit-year-field,\n  ::-webkit-datetime-edit-month-field,\n  ::-webkit-datetime-edit-day-field,\n  ::-webkit-datetime-edit-hour-field,\n  ::-webkit-datetime-edit-minute-field,\n  ::-webkit-datetime-edit-second-field,\n  ::-webkit-datetime-edit-millisecond-field,\n  ::-webkit-datetime-edit-meridiem-field {\n    padding-block: 0;\n  }\n\n  /*\n  Center dropdown marker shown on inputs with paired `<datalist>`s in Chrome. (https://github.com/tailwindlabs/tailwindcss/issues/18499)\n*/\n\n  ::-webkit-calendar-picker-indicator {\n    line-height: 1;\n  }\n\n  /*\n  Remove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n  :-moz-ui-invalid {\n    box-shadow: none;\n  }\n\n  /*\n  Correct the inability to style the border radius in iOS Safari.\n*/\n\n  button,\n  input:where([type=\"button\"], [type=\"reset\"], [type=\"submit\"]),\n  ::file-selector-button {\n    appearance: button;\n  }\n\n  /*\n  Correct the cursor style of increment and decrement buttons in Safari.\n*/\n\n  ::-webkit-inner-spin-button,\n  ::-webkit-outer-spin-button {\n    height: auto;\n  }\n\n  /*\n  Make elements with the HTML hidden attribute stay hidden by default.\n*/\n\n  [hidden]:where(:not([hidden=\"until-found\"])) {\n    display: none !important;\n  }\n}\n\n@layer utilities {\n  @tailwind utilities;\n}\n","@import \"tailwindcss\";\r\n@import \"./common.css\";\r\n\r\n@layer base {\r\n    *, ::before, ::after {\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    /**, ::before, ::after {*/\r\n    /*    border-width: 0;*/\r\n    /*    border-style: solid;*/\r\n    /*    border-color: theme('borderColor.DEFAULT', currentColor);*/\r\n    /*}*/\r\n    img {\r\n        display: inline-block; /* Giữ theo kiểu truyền thống của Bootstrap */\r\n        vertical-align: middle;\r\n    }\r\n\r\n    button, input, select, optgroup, textarea, ::file-selector-button {\r\n        background-color: white;\r\n    }\r\n\r\n    select, input, textarea, optgroup {\r\n        &:not(.ui-select-container *) {\r\n            @apply border rounded border-gray-400 px-1\r\n        }\r\n    }\r\n}\r\n\r\n@theme {\r\n    --font-title: 'Tautz';\r\n    --font-primary: 'Roboto';\r\n    --color-title: #2d7194;\r\n    --color-main: white;\r\n    --color-link: #2d7194;\r\n    --color-main-field: #f9f9f9;\r\n    --color-main-field-border: #dddddd;\r\n    --color-row-even: var(--color-main-field);\r\n    --color-mascot-black: #474747;\r\n    /*--color-primary-base: #506C79;*/\r\n    --color-primary-base: #1B1B1B;\r\n    /*--color-base-hue: 199;*/\r\n    --color-base-hue: 0;\r\n    --color-base-0: hsl(199, 23%, 97%);\r\n    --color-base-50: hsl(199, 16%, 92%);\r\n    --color-base-100: hsl(199, 15%, 86%);\r\n    --color-base-150: hsl(199, 14%, 80%);\r\n    --color-base-200: hsl(199, 14%, 74%);\r\n    --color-base-300: hsl(199, 14%, 63%);\r\n    --color-base-400: hsl(199, 14%, 63%);\r\n    --color-base-500: hsl(199, 20%, 39%);\r\n    --color-base-600: hsl(199, 20%, 32%);\r\n    --color-base-700: hsl(199, 20%, 24%);\r\n    --color-base-800: hsl(199, 20%, 16%);\r\n    --color-base-850: hsl(199, 20%, 12%);\r\n    --color-base-primary: hsl(199, 20%, 12%);\r\n    --color-base-900: hsl(199, 20%, 8%);\r\n    --color-base-950: hsl(199, 20%, 4%);\r\n    --spacing: 0.25rem;\r\n}\r\n\r\nhtml {\r\n    font-size: 16px;\r\n    height: 100dvh !important;\r\n}\r\n\r\nbody {\r\n    height: 100dvh !important;\r\n}\r\n\r\n#divArea {\r\n    max-height: 100%;\r\n    overflow-x: auto;\r\n    width: 100%;\r\n    font-size: 13px;\r\n    flex-grow: 1;\r\n}\r\n\r\n#divAreaModal {\r\n    max-height: 100%;\r\n    overflow: auto;\r\n    width: 100%;\r\n    font-size: 13px;\r\n}\r\n\r\n#lock-message-background {\r\n    background-color: white;\r\n    opacity: 0.4;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    z-index: 10001;\r\n    display: none;\r\n}\r\n\r\ntable > thead > tr > td {\r\n    background-color: #fff;\r\n}\r\n\r\n.form-control {\r\n    border-radius: 0;\r\n}\r\n\r\n.btn {\r\n    @apply rounded-sm;\r\n}\r\n\r\n.text-info {\r\n    color: grey;\r\n    font-weight: bold;\r\n}\r\n\r\n.text-center .day-text-normal {\r\n    color: grey;\r\n    background-color: #ddd;\r\n}\r\n\r\n.uib-day button, .uib-month button, .uib-year button {\r\n    border-radius: 0;\r\n    border: solid 1px #ddd;\r\n}\r\n\r\n.uib-datepicker .uib-title, .uib-left, .uib-right {\r\n    border-radius: 0 !important;\r\n}\r\n\r\n.modal-header {\r\n    padding: 8px 15px;\r\n    color: black;\r\n    background-color: #c9bfb4;\r\n\r\n    .modal-title {\r\n        color: #2d7194;\r\n    }\r\n\r\n    .fa-times {\r\n        position: absolute;\r\n        right: 10px;\r\n        top: 10px;\r\n        font-size: 1rem;\r\n        cursor: pointer;\r\n    }\r\n}\r\n\r\n.modal-header > strong {\r\n    text-transform: uppercase;\r\n}\r\n\r\n.modal-header .modal-title {\r\n    display: block;\r\n    padding: 5px 0;\r\n}\r\n\r\n.modal-content {\r\n    border-radius: 0;\r\n}\r\n\r\n.btn-purple {\r\n    color: grey !important;\r\n    background-color: #fefefe;\r\n    border-color: darkgrey;\r\n}\r\n\r\n.btn.btn-secondary {\r\n    border: 1px solid #bfbfbf;\r\n}\r\n\r\n\r\n.btn-purple:focus,\r\n.btn-purple.focus {\r\n    color: black;\r\n    background-color: #ddd;\r\n    border-color: darkgrey;\r\n}\r\n\r\n.btn-purple:hover {\r\n    color: black;\r\n    background-color: #ddd;\r\n    border-color: darkgrey;\r\n}\r\n\r\n.btn-purple:active,\r\n.btn-purple.active,\r\n.open > .dropdown-toggle.btn-purple {\r\n    color: black;\r\n    background-color: #ddd;\r\n    border-color: darkgrey;\r\n}\r\n\r\n.btn-purple:active:hover,\r\n.btn-purple.active:hover,\r\n.open > .dropdown-toggle.btn-purple:hover,\r\n.btn-purple:active:focus,\r\n.btn-purple.active:focus,\r\n.open > .dropdown-toggle.btn-purple:focus,\r\n.btn-purple:active.focus,\r\n.btn-purple.active.focus,\r\n.open > .dropdown-toggle.btn-purple.focus {\r\n    color: black;\r\n    background-color: #ddd;\r\n    border-color: darkgrey;\r\n}\r\n\r\n.btn-purple:active,\r\n.btn-purple.active,\r\n.open > .dropdown-toggle.btn-purple {\r\n    background-image: none;\r\n}\r\n\r\n.btn-purple.disabled:hover,\r\n.btn-purple[disabled]:hover,\r\nfieldset[disabled] .btn-purple:hover,\r\n.btn-purple.disabled:focus,\r\n.btn-purple[disabled]:focus,\r\nfieldset[disabled] .btn-purple:focus,\r\n.btn-purple.disabled.focus,\r\n.btn-purple[disabled].focus,\r\nfieldset[disabled] .btn-purple.focus {\r\n    color: black;\r\n    background-color: #ddd;\r\n    border-color: darkgrey;\r\n}\r\n\r\n.btn-purple .badge {\r\n    color: black;\r\n    background-color: #ddd;\r\n}\r\n\r\n\r\n/*\r\n    Modified style\r\n*/\r\n/*.navbar-inverse {\r\n    color: #873600;\r\n    height: 4rem;\r\n    min-height: 1rem;\r\n}\r\n\r\n    .navbar-inverse .navbar-nav > .active > a, .navbar-inverse .navbar-nav > .active > a:focus, .navbar-inverse .navbar-nav > .active > a:hover {\r\n        color: #873600;\r\n    }\r\n\r\n    .navbar-inverse .navbar-nav > .open > a, .navbar-inverse .navbar-nav > .open > a:focus, .navbar-inverse .navbar-nav > .open > a:hover {\r\n        color: #873600;\r\n    }*/\r\n\r\n.home {\r\n}\r\n\r\n.home > .dropdown {\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    /*background-color: #edbb99;*/\r\n    /*border-right-style: ridge;*/\r\n}\r\n\r\n/*.dropdown-menu {\r\n    background-color: #edbb99;\r\n}*/\r\n\r\n/*.dropdown-menu > li > a {\r\n        color: #873600;\r\n    }*/\r\n\r\n.menu {\r\n    position: relative;\r\n}\r\n\r\n.menu > .dropdown-menu {\r\n    position: static;\r\n    display: block;\r\n    font-size: 12px;\r\n}\r\n\r\n.content-area {\r\n    margin-top: 5px;\r\n}\r\n\r\n.nav-tabs.nav-justified > li {\r\n    float: left;\r\n    width: 25% !important;\r\n}\r\n\r\n.category-area {\r\n    height: 70.1rem;\r\n    overflow: auto;\r\n    width: 100.2%;\r\n}\r\n\r\n.fit-content {\r\n    width: 103%;\r\n}\r\n\r\n.document-fields-group {\r\n    outline: 1px solid lightgray;\r\n    /*overflow-x: auto;*/\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.document-fields-group .title {\r\n    padding: 5px;\r\n    padding-left: 10px;\r\n    border: none;\r\n    color: black;\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n    background-color: #ddd;\r\n}\r\n\r\n\r\n.document-fields-group .content {\r\n    @apply bg-white p-2.5;\r\n}\r\n\r\n.text-input {\r\n    border: 1px solid #CCC;\r\n    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.075) inset;\r\n    padding: 3px;\r\n    min-width: 1rem;\r\n    width: 100%;\r\n    height: 30px;\r\n    color: dimgray;\r\n}\r\n\r\nlabel.input-inline {\r\n    line-height: 30px;\r\n}\r\n\r\nlabel.gray-label {\r\n    background-color: #ddd;\r\n    line-height: 30px;\r\n    padding: 0 8px;\r\n}\r\n\r\n.text-input:focus {\r\n    border-color: #66afe9;\r\n    outline: 0;\r\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6);\r\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6);\r\n}\r\n\r\n.text-search {\r\n    border: 1px solid #CCC;\r\n    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.075) inset;\r\n    padding: 6px;\r\n    min-width: 1rem;\r\n    width: 100%;\r\n    /*height: 25px;*/\r\n    font-weight: 500;\r\n    font-style: italic;\r\n}\r\n\r\n.select2-selection {\r\n    border: 1px solid #ccc !important;\r\n    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.075) inset;\r\n    min-width: 1rem;\r\n    width: 100%;\r\n    font-weight: 500;\r\n    font-style: italic;\r\n    border-radius: 0 !important;\r\n    line-height: inherit;\r\n    height: 32px !important;\r\n}\r\n\r\n.select2-container--default .select2-selection--single .select2-selection__rendered {\r\n    line-height: inherit;\r\n    padding: 6px;\r\n}\r\n\r\n.panel-default > .panel-heading {\r\n    background: none;\r\n}\r\n\r\n.panel-heading.fix-top {\r\n    position: absolute;\r\n    width: 100%;\r\n    top: 0\r\n}\r\n\r\n.panel-heading.fix-top.border-bottom,\r\n.row.border-bottom {\r\n    border-bottom: 1px solid #ddd;\r\n}\r\n\r\n\r\n.text-input-grid {\r\n    border: none;\r\n}\r\n\r\n#category-info > tbody > tr > td {\r\n    border: none;\r\n    padding: 5px !important;\r\n}\r\n\r\n\r\n#category-info tr > td:first-child {\r\n    /*font-weight: bold;*/\r\n}\r\n\r\n.table tr:first-child > th {\r\n    background-color: #ddd !important;\r\n    color: black;\r\n    border: solid 1px darkgrey;\r\n    border-bottom: none;\r\n}\r\n\r\n.table tr:last-child > th {\r\n    background-color: #fff;\r\n}\r\n\r\n/*.nav-tabs.nav-justified > .active > a, .nav-tabs.nav-justified > .active > a:focus, .nav-tabs.nav-justified > .active > a:hover {\r\n    border: 1px solid #e59866;\r\n}*/\r\n\r\na:not(.dropdown-toggle,.btn) {\r\n    color: grey; /*#e59866;*/\r\n}\r\n\r\ntable a[href] {\r\n    color: #2d7194;\r\n    text-decoration: underline;\r\n}\r\n\r\n/*.nav-tabs.nav-justified > li > a {\r\n    border-bottom: 1px solid #e59866;\r\n}*/\r\n\r\n.nav > li > a:hover, .nav > li > a:focus {\r\n    /*border: solid 0.1px #ddd !important;*/\r\n    /*background-color: #2f2f2f !important;*/\r\n    color: black;\r\n}\r\n\r\n.nav .open > a, .nav .open > a:hover, .nav .open > a:focus {\r\n    border: none;\r\n    /*background-color: #e59866 !important;*/\r\n}\r\n\r\n/*input, textarea, select {\r\n    color: #e59866 !important;\r\n}*/\r\n\r\n.panel-default, .panel-default > .panel-heading {\r\n    border-radius: 0px;\r\n}\r\n\r\n.input-group-addon {\r\n    background-color: #ddd;\r\n    border: solid 1px lightgrey;\r\n    color: black;\r\n    border-radius: 0;\r\n    text-align: left;\r\n}\r\n\r\n.footer {\r\n    position: absolute;\r\n    bottom: 10px;\r\n    background-color: #f2e8ec;\r\n    width: 100%;\r\n    height: 4rem;\r\n    color: #e59866;\r\n    text-align: center;\r\n}\r\n\r\n.common-content {\r\n    background-color: #fafafa;\r\n    position: absolute;\r\n    height: 100%;\r\n}\r\n\r\n.pagination > .active > a, .pagination > .active > a:focus, .pagination > .active > a:hover, .pagination > .active > span, .pagination > .active > span:focus, .pagination > .active > span:hover {\r\n    background-color: #ddd;\r\n    border-color: lightgrey;\r\n    color: black;\r\n}\r\n\r\n.pagination > li > a, .pagination > li > span {\r\n    color: black;\r\n}\r\n\r\n.nav-pills > li.active > a, .nav-pills > li.active > a:focus, .nav-pills > li.active > a:hover {\r\n    background-color: #ddd;\r\n    color: black;\r\n    line-height: 15px;\r\n}\r\n\r\n.nav-pills > li > a {\r\n    border-radius: 0;\r\n    cursor: pointer;\r\n}\r\n\r\n.dropup .dropdown-menu, .navbar-fixed-bottom .dropdown .dropdown-menu {\r\n    margin-bottom: -25px;\r\n}\r\n\r\n\r\n.mascot-brand {\r\n    float: right;\r\n}\r\n\r\n.customer-address {\r\n    background-color: #fafafa;\r\n    font-weight: 600;\r\n    line-height: 20px;\r\n    width: 23%;\r\n    margin: 10px;\r\n}\r\n\r\n\r\n.total-record {\r\n    /*color: #e59866;*/\r\n    font-weight: 600;\r\n}\r\n\r\n.caret-order {\r\n    cursor: pointer;\r\n    margin-top: 7px;\r\n    float: right;\r\n}\r\n\r\n.up-caret {\r\n    display: inline-block;\r\n    width: 0;\r\n    height: 0;\r\n    margin-left: 2px;\r\n    vertical-align: middle;\r\n    border-bottom: 4px solid;\r\n    border-left: 4px solid transparent;\r\n    border-top: 0 dotted;\r\n    border-right: 4px solid transparent;\r\n    content: \"\";\r\n}\r\n\r\n.upload-area {\r\n    line-height: 30px;\r\n    margin-top: 5px;\r\n    width: 98%;\r\n    margin-left: 15px;\r\n    height: 40px;\r\n    border: dotted 1px grey;\r\n}\r\n\r\n.text-focus {\r\n    border: solid 1px #ddd;\r\n    box-shadow: 0px 1px 5px rgba(0, 0, 0, 1);\r\n}\r\n\r\n.header-cursor {\r\n    cursor: pointer;\r\n}\r\n\r\n.panel-title {\r\n    font-size: 14px;\r\n}\r\n\r\n.copy-text {\r\n    color: white;\r\n    font-size: 0.2px;\r\n}\r\n\r\nem::selection {\r\n    color: white !important;\r\n    background: none;\r\n}\r\n\r\n.fake-span {\r\n    cursor: pointer;\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n}\r\n\r\n.pending-popover {\r\n    display: none;\r\n}\r\n\r\n.table .table-rule > tbody > tr > td {\r\n    border-top: none;\r\n}\r\n\r\n.page-heading {\r\n    @apply mb-2;\r\n\r\n    &.no-margin {\r\n        margin: 0;\r\n    }\r\n\r\n    .page-title {\r\n        @apply my-2 grid grid-cols-[auto_1fr] gap-2 cursor-default;\r\n        grid-template-areas: \"title controls\";\r\n\r\n        h3 {\r\n            margin: 0;\r\n            flex: 0;\r\n            grid-area: title;\r\n            font-size: 1.8em;\r\n            font-weight: normal;\r\n            font-family: Roboto;\r\n        }\r\n\r\n        .controls {\r\n            @apply flex gap-2 justify-end;\r\n            grid-area: controls;\r\n        }\r\n    }\r\n}\r\n\r\n.table-content {\r\n}\r\n\r\n.page-body {\r\n    margin-top: 160px;\r\n}\r\n\r\n.page-body table {\r\n}\r\n\r\n\r\n.page-paging {\r\n    position: fixed;\r\n    top: 95px;\r\n    left: 15px;\r\n    right: 15px;\r\n    padding-bottom: 10px;\r\n    background-color: white;\r\n}\r\n\r\n\r\n.dropdown dd, .dropdown dt {\r\n    margin: 0px;\r\n    padding: 0px;\r\n}\r\n\r\n.dropdown ul {\r\n    margin: -1px 0 0 0;\r\n}\r\n\r\n.dropdown dd {\r\n    position: relative;\r\n}\r\n\r\n.dropdown a,\r\n.dropdown a:visited {\r\n    /*color: #873600;*/\r\n    text-decoration: none;\r\n    outline: none;\r\n    /*font-size: 12px;*/\r\n}\r\n\r\n.dropdown dt a {\r\n    display: block;\r\n    height: 30px;\r\n    line-height: 24px;\r\n    overflow: hidden;\r\n    border: 0;\r\n    width: 235px;\r\n}\r\n\r\n.dropdown dt a span, .multiSel span {\r\n    cursor: pointer;\r\n    display: inline-block;\r\n    padding: 0 3px 2px 0;\r\n}\r\n\r\n.dropdown dd ul {\r\n    background-color: white;\r\n    border: double 1px gray;\r\n    color: black;\r\n    display: none;\r\n    left: 0px;\r\n    padding: 2px 15px 2px 5px;\r\n    position: absolute;\r\n    top: 2px;\r\n    width: 99%;\r\n    list-style: none;\r\n    height: 100px;\r\n    overflow: auto;\r\n    z-index: 999;\r\n}\r\n\r\n.dropdown span.value {\r\n    display: none;\r\n}\r\n\r\n.dropdown dd ul li a {\r\n    padding: 5px;\r\n    display: block;\r\n}\r\n\r\n.dropdown dd ul li a:hover {\r\n    background-color: #fff;\r\n}\r\n\r\n.document-fields-group table td {\r\n    padding: 5px !important;\r\n}\r\n\r\n/*.cart-footer .basket-footer-values {\r\n    margin-right: 0px;\r\n    margin-left: auto;\r\n}*/\r\n\r\n.cart-footer {\r\n    font-size: 12px;\r\n}\r\n\r\n.cart-footer table.basket-footer-values {\r\n    width: 100%;\r\n}\r\n\r\n.cart-footer .basket-footer-values tr > td:first-child {\r\n    min-width: 150px;\r\n    /*font-size: 15px;*/\r\n    padding: 3px 15px;\r\n    /*font-size: 15px;*/\r\n    font-weight: 300;\r\n    line-height: 1.4;\r\n}\r\n\r\n.cart-footer .basket-footer-values tr > td:last-child {\r\n    min-width: 120px;\r\n    padding-right: 5px;\r\n    text-align: right;\r\n    /*font-size: 14px;*/\r\n    font-weight: 600;\r\n    color: #777;\r\n}\r\n\r\n.cart-footer .basket-footer-values tr.noted {\r\n    background-color: yellow !important;\r\n}\r\n\r\n.cart-footer .basket-footer-values tr.sub-noted {\r\n    background-color: yellow !important;\r\n}\r\n\r\n.validation-failed {\r\n    border: 1px dashed #eb340a !important;\r\n    background: #faebe7 !important;\r\n}\r\n\r\n.validation-hide {\r\n    display: none;\r\n}\r\n\r\n.validation-advice {\r\n    clear: both;\r\n    min-height: 13px;\r\n    margin: 3px 0 0;\r\n    font-size: 11px;\r\n    font-weight: bold;\r\n    line-height: 13px;\r\n    color: #eb340a;\r\n    position: relative;\r\n    top: 100%;\r\n    text-align: left;\r\n}\r\n\r\n.has-error input {\r\n    border-color: #eb340a !important;\r\n}\r\n\r\n.has-error .control-label, .has-error .error-message {\r\n    color: #eb340a;\r\n}\r\n\r\n.error-message {\r\n    display: none;\r\n}\r\n\r\n.has-error .error-message {\r\n    display: block;\r\n}\r\n\r\n.modal-dialog {\r\n    &:has(.sm-modal) {\r\n        @apply max-w-[480px] w-[90dvw];\r\n    }\r\n\r\n    &:has(.md-modal) {\r\n        @apply max-w-[640px] w-[90dvw];\r\n    }\r\n\r\n    &:has(.lg-modal) {\r\n        @apply max-w-[960px] w-[90dvw];\r\n    }\r\n\r\n    &:has(.xl-modal) {\r\n        @apply max-w-[1280px] w-[90dvw];\r\n    }\r\n\r\n    &:has(.xxl-modal) {\r\n        @apply max-w-[1980px] w-[90dvw];\r\n    }\r\n\r\n    .modal-header .icon-close {\r\n        @apply absolute right-0 top-0 m-2 cursor-pointer hover:text-red-500;\r\n    }\r\n}\r\n\r\n.customer-rule-dialog > .modal-dialog {\r\n    width: 50%;\r\n    /*margin-left: 25%;*/\r\n    margin-top: 100px;\r\n}\r\n\r\n.add-rule-dialog > .modal-dialog {\r\n    width: 90%;\r\n    /*margin-left: 15%;*/\r\n    margin-top: 100px;\r\n}\r\n\r\n.edit-rule-dialog > .modal-dialog {\r\n    width: 90%;\r\n    /*margin-left: 15%;*/\r\n    margin-top: 50px;\r\n}\r\n\r\n.table-no-border > tbody > tr > td {\r\n    border: none !important;\r\n}\r\n\r\n.fixed-header {\r\n    border: none;\r\n    top: 35px;\r\n    position: fixed;\r\n    z-index: 1020;\r\n    background-color: #FFF;\r\n    right: 15px;\r\n    left: 15px;\r\n}\r\n\r\n.free-content {\r\n    position: absolute;\r\n    top: 75px;\r\n    margin-right: 15px;\r\n}\r\n\r\n\r\ntable.product-size-table tr td:first-child {\r\n    width: 20%;\r\n}\r\n\r\ntable.product-size-table tr td:last-child {\r\n    width: 30%;\r\n}\r\n\r\ntable.product-size-table tr td {\r\n    border-top: none !important;\r\n}\r\n\r\n.btn-focus {\r\n    color: #333;\r\n    background-color: #e6e6e6;\r\n}\r\n\r\ntd {\r\n    vertical-align: middle !important;\r\n}\r\n\r\n.line-focus {\r\n    background-color: #fafafa;\r\n}\r\n\r\n.multiSelectCert > ul > li:hover {\r\n    background-color: #ddd;\r\n    cursor: pointer;\r\n}\r\n\r\n.invoice-header {\r\n    margin-top: 25px;\r\n}\r\n\r\n.invoice-title {\r\n    display: inline-block;\r\n}\r\n\r\n.invoice-section-header {\r\n    /*color: white;*/\r\n    font-weight: bold;\r\n    padding: 8px;\r\n    background-color: lightGrey;\r\n    margin-top: 5px;\r\n}\r\n\r\n.invoice-section-body {\r\n    border: solid 1px #dddddd;\r\n    padding: 10px;\r\n}\r\n\r\n.invoice-section-body table {\r\n    width: 100%;\r\n}\r\n\r\n.invoice-section-body table td {\r\n    padding: 1px 0;\r\n}\r\n\r\n.invoice-section-body table.two-col td:first-child {\r\n    width: 30%;\r\n}\r\n\r\n.invoice-section-body table.two-col td:last-child {\r\n    width: 70%;\r\n}\r\n\r\n.invoice-section-body table.item-invoiced td:not(:first-child), .invoice-section-body table.item-invoiced th:not(:first-child) {\r\n    text-align: right;\r\n}\r\n\r\n.email-type-list {\r\n    list-style: none;\r\n    padding: 0;\r\n}\r\n\r\n.email-type-list > li {\r\n    cursor: pointer;\r\n    padding: 3px;\r\n    /*background: rgba(178, 182, 175, 0.23);*/\r\n}\r\n\r\n.email-type-list > li > a:hover {\r\n    text-decoration: none;\r\n    color: black;\r\n}\r\n\r\n.email-placeholder-code {\r\n    padding: 0;\r\n}\r\n\r\n.email-placeholder-code > li {\r\n    padding: 3px;\r\n}\r\n\r\n.email-placeholder-code-info {\r\n    list-style: none;\r\n    padding: 10px;\r\n}\r\n\r\n.email-placeholder-code-info > li {\r\n    padding-left: 25px;\r\n    padding-bottom: 3px;\r\n}\r\n\r\n.dealer-group {\r\n    list-style: none;\r\n    padding: 0;\r\n}\r\n\r\n.dealer-group > li {\r\n    padding-bottom: 10px;\r\n}\r\n\r\n.dealer-group > li:hover {\r\n    background-color: #fafafa;\r\n}\r\n\r\n.filter-group {\r\n    margin: 5px;\r\n    width: calc(100% - 10px);\r\n}\r\n\r\n.filter-group > .input-group-addon {\r\n    text-align: left;\r\n    width: 110px;\r\n}\r\n\r\n.dealer-detail {\r\n    border: solid 1px #ddd;\r\n}\r\n\r\n.dealer-detail > li > a > i {\r\n    float: right;\r\n    font-size: 15px;\r\n}\r\n\r\n.dealer-detail > li > a > i:hover {\r\n    color: grey;\r\n}\r\n\r\n.return-accept-box {\r\n    border: solid 1px green;\r\n    background-color: yellow;\r\n    height: 22px;\r\n    float: left;\r\n    margin-right: 5px;\r\n    margin-bottom: 3px;\r\n    padding: 2px;\r\n}\r\n\r\na.help {\r\n    display: inline-block;\r\n    line-height: 20px;\r\n    padding: 0 5px;\r\n    color: #000;\r\n}\r\n\r\n.top-200 {\r\n    margin-top: 200px;\r\n}\r\n\r\n.ep-header-select-box {\r\n    padding: 5px 10px;\r\n    font-size: 12px;\r\n    line-height: 1.5;\r\n    height: 30px;\r\n}\r\n\r\n.small-multi-select {\r\n    @apply overflow-y-auto h-[clamp(200px,50dvh,80dvh)];\r\n}\r\n\r\n.small-multi-select li {\r\n    list-style: none;\r\n    padding: 6px 12px;\r\n    font-size: 12px;\r\n    border-bottom: 1px solid #dddddd;\r\n}\r\n\r\n.small-multi-select li:hover {\r\n    background-color: #fefefe;\r\n}\r\n\r\n.customer-group-dialog .modal-dialog {\r\n    width: 60%;\r\n    top: 100px;\r\n}\r\n\r\n.dealer-customer-group-dialog .modal-dialog {\r\n    width: 90%;\r\n    top: 100px;\r\n}\r\n\r\n.select-image-dialog .modal-dialog {\r\n    width: 90%;\r\n    top: 10px;\r\n}\r\n\r\n.promotion-index-dialog .modal-dialog {\r\n    width: 800px;\r\n    top: 10px;\r\n}\r\n\r\n.color-item.active {\r\n    .color-image {\r\n        @apply outline-3 outline-gray-500 shadow-current shadow-md\r\n    }\r\n\r\n    .color-name {\r\n        @apply font-bold;\r\n    }\r\n}\r\n\r\n.filter-super-class {\r\n    font-weight: bold;\r\n    color: red;\r\n}\r\n\r\n\r\n.tooltip-holder {\r\n    position: relative;\r\n\r\n    .tooltip-text {\r\n        @apply rounded-lg bg-gray-700/80 py-1 px-2 w-max\r\n        text-center text-xs text-white left-1/2 -translate-x-1/2 bottom-full;\r\n        visibility: hidden;\r\n        /*Position the tooltip */\r\n        position: absolute;\r\n        z-index: 1;\r\n    }\r\n\r\n    &:hover .tooltip-text {\r\n        visibility: visible;\r\n    }\r\n}\r\n\r\n\r\n#divInstore {\r\n    margin: 5% 10%;\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n    #divInstore {\r\n        margin: 3% 2%;\r\n    }\r\n\r\n    #divInstore .display {\r\n        display: none\r\n    }\r\n}\r\n\r\n.loading {\r\n    border: 16px solid #f3f3f3; /* Light grey */\r\n    border-top: 16px solid #3498db; /* Blue */\r\n    border-radius: 50%;\r\n    width: 120px;\r\n    height: 120px;\r\n    animation: spin 2s linear infinite;\r\n}\r\n\r\n@-webkit-keyframes spin {\r\n    0% {\r\n        -webkit-transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n@keyframes spin {\r\n    0% {\r\n        transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n.conflict-rule-dialog > .modal-dialog {\r\n    margin-top: 20%;\r\n}\r\n\r\n.refund-order-dialog > .modal-dialog {\r\n    width: 60%;\r\n    margin-top: 50px;\r\n}\r\n\r\n.custom-modal-60 .modal-dialog {\r\n    width: 60% !important;\r\n}\r\n\r\n.custom-modal-70 .modal-dialog {\r\n    width: 70% !important;\r\n}\r\n\r\n.custom-modal-80 .modal-dialog {\r\n    width: 80% !important;\r\n}\r\n\r\n.custom-modal-90 .modal-dialog {\r\n    width: 90% !important;\r\n}\r\n\r\ntable thead tr th {\r\n    overflow: unset !important;\r\n}\r\n\r\ntd, th {\r\n    overflow: unset !important;\r\n}\r\n\r\n.ui-dialog {\r\n    z-index: 9999 !important;\r\n}\r\n\r\n.text-red {\r\n    color: #d0033f !important;\r\n}\r\n\r\n#tblList .col-key {\r\n    max-width: 600px;\r\n    text-overflow: ellipsis;\r\n    overflow: hidden !important;\r\n    white-space: nowrap;\r\n}\r\n\r\n.body-content {\r\n}\r\n\r\n.navbar {\r\n    margin: 0;\r\n    flex: 0 0 auto;\r\n    z-index: 1030;\r\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n    border: 0;\r\n    border-radius: 0;\r\n}\r\n\r\n.navbar #logo.navbar-header {\r\n    height: 60px;\r\n    display: flex;\r\n    align-items: end;\r\n}\r\n\r\n.navbar #logo.navbar-header .navbar-brand {\r\n    height: 100%;\r\n    color: white !important;\r\n    margin: unset !important;\r\n    padding: 0;\r\n    background-position: center;\r\n}\r\n\r\n*::-webkit-scrollbar {\r\n    width: 8px;\r\n}\r\n\r\n*::-webkit-scrollbar-thumb {\r\n    background: #E0E0E0;\r\n    border-radius: 4px;\r\n}\r\n\r\n*::-webkit-scrollbar-thumb:hover {\r\n    background: #bbb;\r\n\r\n}\r\n\r\nmain {\r\n    @apply pl-2 pr-2;\r\n    display: flex;\r\n    overflow-y: auto;\r\n    --bs-gutter-x: 1.5rem;\r\n    background-color: #fefefe;\r\n\r\n    &:has(.page-container) {\r\n        @apply pr-0;\r\n    }\r\n\r\n\r\n    > div {\r\n        flex-grow: 1;\r\n        width: 100%;\r\n        display: flex;\r\n        flex-direction: column;\r\n    }\r\n\r\n    .page-box {\r\n        display: flex;\r\n        height: 100%;\r\n        flex-direction: column;\r\n        overflow: hidden;\r\n\r\n        .page-heading {\r\n            flex: 0 0 auto;\r\n        }\r\n\r\n        .layout-wrapper {\r\n            flex: 1;\r\n            display: flex;\r\n            overflow: hidden;\r\n            margin: 0;\r\n\r\n\r\n            .content-scrollable {\r\n                height: 100%;\r\n                padding-bottom: 15px;\r\n                overflow-y: auto;\r\n            }\r\n\r\n            .sidebar-fixed {\r\n                height: 100%;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.modal-body {\r\n    max-height: 75vh;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n}\r\n\r\n\r\n.text-input:not(textarea) {\r\n    max-width: 45ch;\r\n\r\n    &.text-input-xs {\r\n        max-width: 15ch;\r\n    }\r\n\r\n    &.text-input-sm {\r\n        max-width: 30ch;\r\n    }\r\n\r\n    &.text-input-md {\r\n        max-width: 45ch;\r\n    }\r\n\r\n    &.text-input-lg {\r\n        max-width: 100ch;\r\n    }\r\n\r\n    &.text-input-full {\r\n        max-width: unset !important;\r\n    }\r\n}\r\n\r\n#distributor-info {\r\n    tr:has(td:nth-child(2)) td:nth-child(1) {\r\n        width: 35ch;\r\n    }\r\n}\r\n\r\n.break-word {\r\n    overflow-wrap: break-word;\r\n}\r\n\r\n.grid-cols-subgrid {\r\n    grid-template-columns: subgrid;\r\n}\r\n\r\n.col-span-2 {\r\n    grid-column: span 2 / span 2;\r\n}\r\n\r\n.cursor-pointer:hover {\r\n    cursor: pointer;\r\n}\r\n\r\n.list-style-none {\r\n    list-style: none;\r\n}\r\n\r\n.text-gray {\r\n    color: grey;\r\n}\r\n\r\n.text-balance {\r\n    text-wrap: balance;\r\n}\r\n\r\n.d-grid {\r\n    @apply grid;\r\n}\r\n\r\n.d-flex {\r\n    @apply flex;\r\n}\r\n\r\n.d-block {\r\n    @apply block;\r\n}\r\n\r\n.row {\r\n    --bs-gutter-x: 1.5rem;\r\n    --bs-gutter-y: 0;\r\n    width: 100%;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    margin-top: calc(-1 * var(--bs-gutter-y));\r\n    margin-right: calc(-0.5 * var(--bs-gutter-x));\r\n    margin-left: calc(-0.5 * var(--bs-gutter-x));\r\n\r\n    > * {\r\n        box-sizing: border-box;\r\n        flex-shrink: 0;\r\n        max-width: 100%;\r\n        padding-right: calc(var(--bs-gutter-x) * 0.5);\r\n        padding-left: calc(var(--bs-gutter-x) * 0.5);\r\n        margin-top: var(--bs-gutter-y);\r\n    }\r\n\r\n    > *:not([class*=\"col-\"]) {\r\n        width: 100%;\r\n    }\r\n\r\n    .col {\r\n        flex: 1 0 0;\r\n    }\r\n\r\n    .col-auto {\r\n        flex: 0 0 auto;\r\n        width: auto;\r\n    }\r\n\r\n    .col-1 {\r\n        flex: 0 0 auto;\r\n        width: 8.33333333%;\r\n    }\r\n\r\n    .col-2 {\r\n        flex: 0 0 auto;\r\n        width: 16.66666667%;\r\n    }\r\n\r\n    .col-3 {\r\n        flex: 0 0 auto;\r\n        width: 25%;\r\n    }\r\n\r\n    .col-4 {\r\n        flex: 0 0 auto;\r\n        width: 33.33333333%;\r\n    }\r\n\r\n    .col-5 {\r\n        flex: 0 0 auto;\r\n        width: 41.66666667%;\r\n    }\r\n\r\n    .col-6 {\r\n        flex: 0 0 auto;\r\n        width: 50%;\r\n    }\r\n\r\n    .col-7 {\r\n        flex: 0 0 auto;\r\n        width: 58.33333333%;\r\n    }\r\n\r\n    .col-8 {\r\n        flex: 0 0 auto;\r\n        width: 66.66666667%;\r\n    }\r\n\r\n    .col-9 {\r\n        flex: 0 0 auto;\r\n        width: 75%;\r\n    }\r\n\r\n    .col-10 {\r\n        flex: 0 0 auto;\r\n        width: 83.33333333%;\r\n    }\r\n\r\n    .col-11 {\r\n        flex: 0 0 auto;\r\n        width: 91.66666667%;\r\n    }\r\n\r\n    .col-12 {\r\n        flex: 0 0 auto;\r\n        width: 100%;\r\n    }\r\n\r\n    .offset-1 {\r\n        margin-left: 8.33333333%;\r\n    }\r\n\r\n    .offset-2 {\r\n        margin-left: 16.66666667%;\r\n    }\r\n\r\n    .offset-3 {\r\n        margin-left: 25%;\r\n    }\r\n\r\n    .offset-4 {\r\n        margin-left: 33.33333333%;\r\n    }\r\n\r\n    .offset-5 {\r\n        margin-left: 41.66666667%;\r\n    }\r\n\r\n    .offset-6 {\r\n        margin-left: 50%;\r\n    }\r\n\r\n    .offset-7 {\r\n        margin-left: 58.33333333%;\r\n    }\r\n\r\n    .offset-8 {\r\n        margin-left: 66.66666667%;\r\n    }\r\n\r\n    .offset-9 {\r\n        margin-left: 75%;\r\n    }\r\n\r\n    .offset-10 {\r\n        margin-left: 83.33333333%;\r\n    }\r\n\r\n    .offset-11 {\r\n        margin-left: 91.66666667%;\r\n    }\r\n}\r\n\r\n.flex-grow-1 {\r\n    @apply grow;\r\n}\r\n\r\n.cke_chrome {\r\n    height: 100% !important;\r\n    display: flex !important;\r\n    flex-direction: column;\r\n\r\n    .cke_inner {\r\n        display: flex !important;\r\n        flex-direction: column;\r\n        flex: 1;\r\n    }\r\n\r\n    .cke_contents {\r\n        flex: 1 !important;\r\n        height: auto !important;\r\n    }\r\n}\r\n\r\n[id^=nspopover-] {\r\n    @apply z-2000!;\r\n}\r\n\r\n.ns-popover-tooltip-theme {\r\n    .ns-popover-tooltip {\r\n        box-sizing: border-box;\r\n        background-color: #fff;\r\n        border: 1px solid #d2d2d2;\r\n        border-radius: 3px;\r\n        max-width: 20rem;\r\n        margin: 10px;\r\n        padding: .5625rem .875rem;\r\n        font-size: 1.2rem;\r\n        -webkit-box-shadow: 0 .3125rem .625rem #0003;\r\n        -moz-box-shadow: 0 .3125rem .625rem #0003;\r\n        box-shadow: 0 .3125rem .625rem #0003;\r\n    }\r\n}\r\n\r\n.ns-popover-dropdown-select {\r\n    @apply p-[5px_0] bg-white bg-clip-padding border border-gray-200\r\n    rounded-xl shadow-lg\r\n}\r\n\r\n\r\ntable.sticky-header {\r\n    border-collapse: separate;\r\n    border-spacing: 0;\r\n\r\n    /* Dòng thứ nhất */\r\n\r\n    thead {\r\n        tr:nth-child(1) th {\r\n            position: sticky;\r\n            top: 0;\r\n            z-index: 11;\r\n            background: #fff;\r\n        }\r\n\r\n        /* Dòng thứ hai - dính dưới dòng thứ nhất */\r\n\r\n        tr:nth-child(2) th {\r\n            position: sticky;\r\n            top: 40px;\r\n            z-index: 10;\r\n            background: #fff;\r\n        }\r\n    }\r\n\r\n}\r\n\r\nng-container.ng-scope {\r\n    all: unset;\r\n    display: contents;\r\n}\r\n\r\n.nav.nav-stacked li {\r\n    @apply flex gap-x-1 items-center;\r\n    padding: 10px 15px;\r\n\r\n    &:hover {\r\n        @apply bg-gray-100 cursor-pointer;\r\n    }\r\n\r\n    .fa {\r\n        @apply ms-auto hover:text-black hover:outline hover:outline-base-300;\r\n        @apply hover:px-1 hover:-mr-1 hover:rounded hover:bg-white;\r\n    }\r\n\r\n    &.active {\r\n        @apply bg-gray-200 text-mascot-black font-semibold;\r\n\r\n        a {\r\n            @apply text-mascot-black;\r\n            display: contents;\r\n        }\r\n    }\r\n\r\n    a {\r\n        display: contents;\r\n    }\r\n\r\n}\r\n\r\n.dropdown:hover > .dropdown-menu {\r\n    display: block;\r\n}\r\n\r\n.category-tree, [data-angular-treeview] {\r\n    ul {\r\n        position: relative;\r\n\r\n        &::before {\r\n            content: \"\";\r\n            position: absolute;\r\n            top: 0;\r\n            bottom: 0;\r\n            left: 10px;\r\n            border-left: 1px dashed #ccc;\r\n        }\r\n\r\n        li {\r\n            padding-left: 20px;\r\n\r\n            &::before {\r\n                content: \"\";\r\n                position: absolute;\r\n                top: 15px; /* Align with middle of text */\r\n                left: 10px;\r\n                width: 10px;\r\n                border-top: 1px dashed #ccc;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.drag-ghost {\r\n    opacity: 0.4;\r\n    background: #e5e7eb; /* gray-200 */\r\n    border: 1px dashed #9ca3af; /* gray-400 */\r\n}\r\n","/* Style when highlighting a search. */\r\n.ui-select-highlight {\r\n    font-weight: bold;\r\n}\r\n\r\n.ui-select-offscreen {\r\n    clip: rect(0 0 0 0) !important;\r\n    width: 1px !important;\r\n    height: 1px !important;\r\n    border: 0 !important;\r\n    margin: 0 !important;\r\n    padding: 0 !important;\r\n    overflow: hidden !important;\r\n    position: absolute !important;\r\n    outline: 0 !important;\r\n    left: 0px !important;\r\n    top: 0px !important;\r\n}\r\n\r\n\r\n.ui-select-choices-row:hover {\r\n    background-color: #f5f5f5;\r\n}\r\n\r\n/* Select2 theme */\r\n\r\n/* Mark invalid Select2 */\r\n.ng-dirty.ng-invalid > a.select2-choice {\r\n    border-color: #D44950;\r\n}\r\n\r\n.select2-result-single {\r\n    padding-left: 0;\r\n}\r\n\r\n.select2-locked > .select2-search-choice-close{\r\n    display:none;\r\n}\r\n\r\n.select-locked > .ui-select-match-close{\r\n    display:none;\r\n}\r\n\r\nbody > .select2-container.open {\r\n    z-index: 9999; /* The z-index Select2 applies to the select2-drop */\r\n}\r\n\r\n/* Handle up direction Select2 */\r\n.ui-select-container[theme=\"select2\"].direction-up .ui-select-match,\r\n.ui-select-container.select2.direction-up .ui-select-match {\r\n    border-radius: 4px; /* FIXME hardcoded value :-/ */\r\n    border-top-left-radius: 0;\r\n    border-top-right-radius: 0;\r\n}\r\n.ui-select-container[theme=\"select2\"].direction-up .ui-select-dropdown,\r\n.ui-select-container.select2.direction-up .ui-select-dropdown {\r\n    border-radius: 4px; /* FIXME hardcoded value :-/ */\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n\r\n    border-top-width: 1px;  /* FIXME hardcoded value :-/ */\r\n    border-top-style: solid;\r\n\r\n    box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.25);\r\n\r\n    margin-top: -4px; /* FIXME hardcoded value :-/ */\r\n}\r\n.ui-select-container[theme=\"select2\"].direction-up .ui-select-dropdown .select2-search,\r\n.ui-select-container.select2.direction-up .ui-select-dropdown .select2-search {\r\n    margin-top: 4px; /* FIXME hardcoded value :-/ */\r\n}\r\n.ui-select-container[theme=\"select2\"].direction-up.select2-dropdown-open .ui-select-match,\r\n.ui-select-container.select2.direction-up.select2-dropdown-open .ui-select-match {\r\n    border-bottom-color: #5897fb;\r\n}\r\n\r\n.ui-select-container[theme=\"select2\"] .ui-select-dropdown .ui-select-search-hidden,\r\n.ui-select-container[theme=\"select2\"] .ui-select-dropdown .ui-select-search-hidden input{\r\n    opacity: 0;\r\n    height: 0;\r\n    min-height: 0;\r\n    padding: 0;\r\n    margin: 0;\r\n    border:0;\r\n}\r\n\r\n/* Selectize theme */\r\n\r\n/* Helper class to show styles when focus */\r\n.selectize-input.selectize-focus{\r\n    border-color: #007FBB !important;\r\n}\r\n\r\n/* Fix input width for Selectize theme */\r\n.selectize-control.single > .selectize-input > input {\r\n    width: 100%;\r\n}\r\n\r\n/* Fix line break when there's at least one item selected with the Selectize theme */\r\n.selectize-control.multi > .selectize-input > input {\r\n    margin: 0 !important;\r\n}\r\n\r\n/* Fix dropdown width for Selectize theme */\r\n.selectize-control > .selectize-dropdown {\r\n    width: 100%;\r\n}\r\n\r\n/* Mark invalid Selectize */\r\n.ng-dirty.ng-invalid > div.selectize-input {\r\n    border-color: #D44950;\r\n}\r\n\r\n/* Handle up direction Selectize */\r\n.ui-select-container[theme=\"selectize\"].direction-up .ui-select-dropdown {\r\n    box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.25);\r\n    margin-top: -2px; /* FIXME hardcoded value :-/ */\r\n}\r\n\r\n.ui-select-container[theme=\"selectize\"] input.ui-select-search-hidden{\r\n    opacity: 0;\r\n    height: 0;\r\n    min-height: 0;\r\n    padding: 0;\r\n    margin: 0;\r\n    border:0;\r\n    width: 0;\r\n}\r\n\r\n/* Bootstrap theme */\r\n\r\n/* Helper class to show styles when focus */\r\n.btn-default-focus {\r\n    color: #333;\r\n    background-color: #EBEBEB;\r\n    border-color: #ADADAD;\r\n    text-decoration: none;\r\n    outline: 5px auto -webkit-focus-ring-color;\r\n    outline-offset: -2px;\r\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);\r\n}\r\n\r\n.ui-select-bootstrap .ui-select-toggle {\r\n    position: relative;\r\n}\r\n\r\n.ui-select-bootstrap .ui-select-toggle > .caret {\r\n    position: absolute;\r\n    height: 10px;\r\n    top: 50%;\r\n    right: 10px;\r\n    margin-top: -2px;\r\n}\r\n\r\n/* Fix Bootstrap dropdown position when inside a input-group */\r\n.input-group > .ui-select-bootstrap.dropdown {\r\n    /* Instead of relative */\r\n    position: static;\r\n}\r\n\r\n.input-group > .ui-select-bootstrap > input.ui-select-search.form-control {\r\n    border-radius: 4px; /* FIXME hardcoded value :-/ */\r\n    border-top-right-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n}\r\n.input-group > .ui-select-bootstrap > input.ui-select-search.form-control.direction-up {\r\n    border-radius: 4px !important; /* FIXME hardcoded value :-/ */\r\n    border-top-right-radius: 0 !important;\r\n    border-bottom-right-radius: 0 !important;\r\n}\r\n\r\n.ui-select-bootstrap .ui-select-search-hidden{\r\n    opacity: 0;\r\n    height: 0;\r\n    min-height: 0;\r\n    padding: 0;\r\n    margin: 0;\r\n    border:0;\r\n}\r\n\r\n.ui-select-bootstrap > .ui-select-match > .btn{\r\n    /* Instead of center because of .btn */\r\n    text-align: left !important;\r\n}\r\n\r\n.ui-select-bootstrap > .ui-select-match > .caret {\r\n    position: absolute;\r\n    top: 45%;\r\n    right: 15px;\r\n}\r\n\r\n/* See Scrollable Menu with Bootstrap 3 http://stackoverflow.com/questions/19227496 */\r\n.ui-select-bootstrap > .ui-select-choices ,.ui-select-bootstrap > .ui-select-no-choice {\r\n    width: 100%;\r\n    height: auto;\r\n    max-height: 200px;\r\n    overflow-x: hidden;\r\n    margin-top: -1px;\r\n}\r\n\r\nbody > .ui-select-bootstrap.open {\r\n    z-index: 1000; /* Standard Bootstrap dropdown z-index */\r\n}\r\n\r\n.ui-select-multiple.ui-select-bootstrap {\r\n    height: auto;\r\n    padding: 3px 3px 0 3px;\r\n}\r\n\r\n.ui-select-multiple.ui-select-bootstrap input.ui-select-search {\r\n    background-color: transparent !important; /* To prevent double background when disabled */\r\n    border: none;\r\n    outline: none;\r\n    height: 1.666666em;\r\n    margin-bottom: 3px;\r\n}\r\n\r\n.ui-select-multiple.ui-select-bootstrap .ui-select-match .close {\r\n    font-size: 1.6em;\r\n    line-height: 0.75;\r\n}\r\n\r\n.ui-select-multiple.ui-select-bootstrap .ui-select-match-item {\r\n    outline: 0;\r\n    margin: 0 3px 3px 0;\r\n}\r\n\r\n.ui-select-multiple .ui-select-match-item {\r\n    position: relative;\r\n}\r\n\r\n.ui-select-multiple .ui-select-match-item.dropping .ui-select-match-close {\r\n    pointer-events: none;\r\n}\r\n\r\n.ui-select-multiple:hover .ui-select-match-item.dropping-before:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    right: 100%;\r\n    height: 100%;\r\n    margin-right: 2px;\r\n    border-left: 1px solid #428bca;\r\n}\r\n\r\n.ui-select-multiple:hover .ui-select-match-item.dropping-after:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 100%;\r\n    height: 100%;\r\n    margin-left: 2px;\r\n    border-right: 1px solid #428bca;\r\n}\r\n\r\n.ui-select-bootstrap .ui-select-choices-row>span {\r\n    cursor: pointer;\r\n    display: block;\r\n    padding: 3px 20px;\r\n    clear: both;\r\n    font-weight: 400;\r\n    line-height: 1.42857143;\r\n    color: #333;\r\n    white-space: nowrap;\r\n}\r\n\r\n.ui-select-bootstrap .ui-select-choices-row>span:hover, .ui-select-bootstrap .ui-select-choices-row>span:focus {\r\n    text-decoration: none;\r\n    color: #262626;\r\n    background-color: #f5f5f5;\r\n}\r\n\r\n.ui-select-bootstrap .ui-select-choices-row.active>span {\r\n    color: #fff;\r\n    text-decoration: none;\r\n    outline: 0;\r\n    background-color: #428bca;\r\n}\r\n\r\n.ui-select-bootstrap .ui-select-choices-row.disabled>span,\r\n.ui-select-bootstrap .ui-select-choices-row.active.disabled>span {\r\n    color: #777;\r\n    cursor: not-allowed;\r\n    background-color: #fff;\r\n}\r\n\r\n/* fix hide/show angular animation */\r\n.ui-select-match.ng-hide-add,\r\n.ui-select-search.ng-hide-add {\r\n    display: none !important;\r\n}\r\n\r\n/* Mark invalid Bootstrap */\r\n.ui-select-bootstrap.ng-dirty.ng-invalid > button.btn.ui-select-match {\r\n    border-color: #D44950;\r\n}\r\n\r\n/* Handle up direction Bootstrap */\r\n.ui-select-container[theme=\"bootstrap\"].direction-up .ui-select-dropdown {\r\n    box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n.ui-select-bootstrap .ui-select-match-text {\r\n    width: 100%;\r\n    padding-right: 1em;\r\n}\r\n.ui-select-bootstrap .ui-select-match-text span {\r\n    display: inline-block;\r\n    width: 100%;\r\n    overflow: hidden;\r\n}\r\n.ui-select-bootstrap .ui-select-toggle > a.btn {\r\n    position: absolute;\r\n    height: 10px;\r\n    right: 10px;\r\n    margin-top: -2px;\r\n}\r\n\r\n/* Spinner */\r\n.ui-select-refreshing.glyphicon {\r\n    position: absolute;\r\n    right: 0;\r\n    padding: 8px 27px;\r\n}\r\n\r\n@-webkit-keyframes ui-select-spin {\r\n    0% {\r\n        -webkit-transform: rotate(0deg);\r\n        transform: rotate(0deg);\r\n    }\r\n    100% {\r\n        -webkit-transform: rotate(359deg);\r\n        transform: rotate(359deg);\r\n    }\r\n}\r\n@keyframes ui-select-spin {\r\n    0% {\r\n        -webkit-transform: rotate(0deg);\r\n        transform: rotate(0deg);\r\n    }\r\n    100% {\r\n        -webkit-transform: rotate(359deg);\r\n        transform: rotate(359deg);\r\n    }\r\n}\r\n\r\n.ui-select-spin {\r\n    -webkit-animation: ui-select-spin 2s infinite linear;\r\n    animation: ui-select-spin 2s infinite linear;\r\n}\r\n\r\n.ui-select-refreshing.ng-animate {\r\n    -webkit-animation: none 0s;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
